/* eslint-disable no-undef  */
/* eslint-disable no-unused-expressions  */
/* eslint-disable eqeqeq  */
/* eslint-disable no-array-constructor  */
/* eslint-disable no-unused-vars  */
/* eslint-disable no-cond-assign  */
/* eslint-disable no-useless-escape  */
/* eslint-disable no-redeclare  */
/* eslint-disable no-throw-literal  */
/* eslint-disable no-new-object  */
/* eslint-disable no-sequences  */
/* eslint unicode-bom: ["error", "always"] */
var ActiveXObject;
var ProcessRequiredRuleToSelectFIFSet;
var SelectedFIFOrderCounter = 0;
var SelectedOrderCounter = 0;
var aDisplayGroups;
var aFIFCategoryList;
var aIntColorList;
var aOptionListwSortOrder = [];
var aOptions;
var aSelOptions;
var bInList;
var bIncluded;
var bOptionIncluded;
var bRequired;
var bRequiredByOther;
var counter;
var errModel2001;
var i;
var iCol = 0;
var j;
var oAccessories;
var oAssets;
var oCurAsset;
var oECEVC;
var oECM;
var oExtColor;
var oFIFCategories;
var oFIFCategory;
var oFIFRule;
var oIntColor;
var oNewAcc;
var oOpCodeAttribute;
var oOptionColorAttribute;
var oPartNumberAttribute;
var oReqByListOption;
var oReqByOption;
var oSelFIF;
var oSelOption;
var pricedelta;
var sOpCode;
var sOptions;
var usedByAnOption1;
var sExtColExt;
var sExtColCode;
var sExtColors;
var oExtColors;
var oIntColors;
var aAddAssets;
var aAssets;



/* RULES ENGINE FILES START */

//*********************************************************************************************************
//Filename	    : eConfigRulesEngine.js
//Author	    : Pankil Patel
//Date/Time	    : 05/05/2008
//Updated Date  : 07/26/2021
//Version       : 4.2
//Purpose	    : This file contains methods to support eConfig 4.0 Build & Price configuration.
//Revisions	    : Date          Author          Description
//              05/05/2008    Pankil Patel    Creating skeleton  
//              06/20/2008    Pankil Patel    Finalizing Release v. 1.0
//              06/24/2008    Pankil Patel    Implementing Tony's feedback
//              09/09/2008    Pankil Patel    Bug fix AT # 48463
//              11/20/2008    Pankil Patel    Bug fix AT # 51743
//              01/08/2009    Pankil Patel    Bug fix AT # 52521 - Added GetOptionsByaDisplayGroup to return 
//                                                                   Options in a particular sort order set in AW.
//              02/23/2009    Pankil Patel    Bug fix AT # 54641 
//              04/29/2009    Pankil Patel    Bug fix AT # 54641 - Additional issue when Required Accessory and Package gets selected causing issue with incorrect state.
//              01/06/2015    Pankil Patel    Creating FIF Processing Methods
//              01/29/2015    Pankil Patel    Updated GetModelState to return OptionDealerPrice instead of OptionPrice when DealerNumber is present.
//              02/05/2015    Pankil Patel    Added AddModelFIFs, AddFIFAssets, AddFIFTexts
//              02/06/2015    Pankil Patel    Added GetFIFsByaDisplayGroup and GetFIFsByDisplayGroups
//              02/16/2015    Pankil Patel    Removed dealer_no from configuration xml. Only adds the attribute when the dealer no is present.
//              04/20/2015    Pankil Patel    Update to the exterior & interior price delta in ColorComboList structure since exterior price delta now exists at interior color based on
//                                            exterior price color extension
//              04/23/2015    Pankil Patel    Bug fix AT #119483 - Option Dealer Price issue from SaveRetrieveConfiguration
//                                            It was caused by dealer_no attribute not getting added to configuration xml from rules engine.
//                                            Calculate Price is also updated to add OptionDealerPrice when DealerNumber is present.
//              07/27/2015    Pankil Patel    Bug fix AT #121620 - Selecting RE results in required conflict containing RD along with TD. RD shouldn't be in the list
//              08/16/2015    Pankil Patel    Bug fix AT #121952 - Issue with SetModelState not selecting right FIFs.
//              08/30/2015    Pankil Patel    Bug fix AT #122375 - Issue with GetModelState failing on Chrome/Firefox since it is not able to create xml document.
//              09/29/2015    Pankil Patel    Bug fix AT #123149 - GetModelState Xml returns "DEALERNO" string
//              10/12/2015    Pankil Patel    Bug fix AT #123405 - SetModelState selects two FIFs in a category (WB and WC) instead of a specific one
//              11/25-29/2015 Pankil Patel    Price Delta change required by Razorfish
//              09/06/2018    Pankil Patel    Adding "json" support in GetModelState
//              09/14-18/2018 Pankil Patel    Bug fix for generated configuration for accessories/fifs/exterior_price_color_cd_ext 
//              09/24-28/2018 Pankil Patel    Bug fix for SetModelState
//              07/15-26/2021 Pankil Patel    Implement FIF Packages (individual FIF's price will not be calculated)
//*********************************************************************************************************

function ECConfigurationManager() {
    ///<summary>
    /// ECConfigurationManager function defines the constructor for this class. 
    /// All public methods will be accessed using this public class.
    ///</summary>
    this.AutoApproveChanges = false;
}

ECConfigurationManager.prototype.ModelList = new Array();

function ECRulesEngineQueryResult() {
    /// <summary>
    /// ECRulesEngineQueryResult class contains various conflict arrays. After all Configuration Engine rules
    /// are processed, appropriate conflicts are filled and returned to the caller. The PassedValidation flag 
    /// determines if the validation of rules passed or failed. The caller can then send appropriate errors 
    /// to the user.
    /// <b>Types of conflicts returned:</b>
    /// Model Color Conflicts - Exterior/Interior Color conflicts.
    /// Visually Exclusive Conflicts - Asset z-order conflicts.
    /// Option Rules Conflicts - Option Required, Excluded and Included Options
    /// Option Color Conflicts - Option Color Conflicts with selected Exterior/Interior Color conflicts.
    /// </summary>
    this.currentOption;
    this.RequiredOptions = new Array();
    this.IncludedOptions = new Array();
    this.ExcludedOptions = new Array();
    this.ExclusivelyRequiredFIFs = new Array();
    this.RequiredFIFs = new Array();
    this.ExcludedFIFs = new Array();
    this.FIFColorConflicts = new Array();
    this.VisuallyExclusiveAssets = new Array();
    this.OptionColorConflicts = new Array();
    this.ModelColorConflicts = new Array();
    this.PassedValidation = false;
}

function ECModelColorConflict() {
    /// <summary>
    /// Returns Model Color Conflicts. 
    /// </summary>
    this.CurrentlySelectedColorCode = "";
    this.CurrentlySelectedColorType = "";
    this.ConflictingColorCode = "";
    this.ConflictingColorType = "";
    this.ModelId = "";
}

function ECOptionColorConflict() {
    /// <summary>
    /// Returns Option Color Conflicts.
    /// </summary>
    this.OpCode = "";
    this.ColorCode = "";
    this.ColorType = "";
    this.ModelId = "";
}

function ECVisuallyExclusiveConflict() {
    /// <summary>
    /// This object contains the visually exclusive conflict list. 
    /// It is populated when two assets with same zOrder are selected.
    /// </summary>
    this.CurrentlySelectedAssetId = "";
    this.CurrentlySelectedOpCode = "";
    this.CurrentlySelectedModelId = "";
    this.ConflictingAssetId = "";
    this.ConflictingOpCode = "";
    this.ConflictingModelId = "";
}

function ECVisibleAssets() {
    /// <summary>
    /// This object contains the Visible Assets Array containing 
    /// currently selected assets. It is populated by calling 
    /// the AddVisibleAsset method and removes any asset that got deselected
    /// by calling the RemoveVisibleAsset. It is populated when two assets with 
    /// same zOrder are selected.
    /// </summary>
}

ECVisibleAssets.prototype.VisibleAssets = new Array();

function ECVisibleAsset(sModelId, sOpCode, sAssetIdent) {
    /// <summary>
    /// Individual Visible Asset object containing the ModelId, OpCode and AssetIdent selected by user
    /// </summary>
    this.ModelId = sModelId;
    this.OpCode = sOpCode;
    this.AssetIdent = sAssetIdent;
}


// Error Messages
var errModel1000 = new Error(1000, "Model does not exist");
var errModel1001 = new Error(1001, "ModelList Array empty");
var errModel1002 = new Error(1002, "ModelState string not found in url");
var errModel1003 = new Error(1003, "ModelId is required to process rules");
var errOption2000 = new Error(2000, "Model Option List Empty");
var errOption2001 = new Error(2001, "Option does not exist");
var errOption2002 = new Error(2002, "Unable to obtain Options for passed in DisplayGroup");
var errFIF5001 = new Error(5001, "FIF does not exist");
var errColor3000 = new Error(3000, "Exterior Color List empty for this model");
var errColor3001 = new Error(3001, "Interior Color List empty for this model");
var errColor3002 = new Error(3002, "Error populating Model Color Conflict");
var errRules4000 = new Error(4000, "Error processing Model Option Rules");
var errRules4001 = new Error(4001, "Error Adding Visible Asset");

//Global Counter
SelectedOrderCounter = 0;
SelectedFIFOrderCounter = 0;

ECConfigurationManager.prototype.ProcessModelColorRules = function (sModelId, sSelExtColor, sSelIntColor) {
    /// <summary>
    /// Assumption: The model list variable within the ConfigurationEngine class must be
    /// populated with data from one or more unique models. The source of the data
    /// for this variable should be the eConfig serverside "getmodeloptions"
    /// method. The "getmodeloptions" method takes in one or more models and
    /// returns a JSON representation of the model data. This JSON is then used to
    /// populate the model list variable. Eventhough multiple models can be added
    /// to the model list variable, the models must be all be unique (different
    /// model IDs). This means that you CAN NOT configure two models with the same
    /// model ID at the same time. Configuration of multiple models is supported
    /// but only if the model IDs are different.

    /// There is no explicit "select model" method because the main methods
    /// (ProcessModelColorRules and ProcessModelOptionRules) both require the model
    /// ID to be passed in as part of the method call. This model id is what we use
    /// to determine which model in the model list to use. For consistency, we
    /// require you to pass in this value even if you only have one model in the
    /// model list. If you pass us a model id that doesn't exist, we'll return an
    /// exception. See the error messages section for more information on the
    /// exceptions this API can raise. You will need to write code to handle the
    /// exceptions appropriately.
    ///
    /// This method allows the selection of Exterior and Interior Color for passed in Model in the state. 
    /// The following steps shows the state selection process during build and price process
    ///
    /// Step1 ProcessModelColorRules  - This method validates the selected exterior/interior colors are valid for the selected Model.
    ///                                 Also, Option Color Conflicts rules will also be checked incase options are already selected in the state.
    /// Step2 ProcessModelOptionRules - This process is called for verifying model option rules and selecting appropriate options.
    ///                                 Since Option Color Rules need to be validated, the colors are obtained from the state
    ///                                 assuming Step1 is already executed. Incase this method is called directly, default
    ///                                 exterior color(first color in array) and default interior color(first color in array for the selected
    ///                                 exterior color) are selected and Option color rules are processed based on this colors.
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose configuration needs to be validated</param>
    /// <param name="sSelExtColor">Currently selected exterior color</param>
    /// <param name="sSelIntColor">Currently selected interior color</param>
    /// <returns>ECRulesEngineQueryResult object with conflicts/no conflicts and passedValidation flag as true/false.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>

    var oECRE = new ECRulesEngine();
    try {
        return oECRE.ValidateConfiguration(sModelId, sSelExtColor, sSelIntColor, "", "", false);
    }
    catch (e) { throw e; }
    finally { oECRE = null; }
}

ECConfigurationManager.prototype.ProcessModelOptionRules = function (sModelId, sSelOpCode, bAutoApproveChanges) {
    /// <summary> 
    /// Assumption: The model list variable within the ConfigurationEngine class must be
    /// populated with data from one or more unique models. The source of the data
    /// for this variable should be the eConfig serverside "getmodeloptions"
    /// method. The "getmodeloptions" method takes in one or more models and
    /// returns a JSON representation of the model data. This JSON is then used to
    /// populate the model list variable. Eventhough multiple models can be added
    /// to the model list variable, the models must be all be unique (different
    /// model IDs). This means that you CAN NOT configure two models with the same
    /// model ID at the same time. Configuration of multiple models is supported
    /// but only if the model IDs are different.

    /// There is no explicit "select model" method because the main methods
    /// (ProcessModelColorRules and ProcessModelOptionRules) both require the model
    /// ID to be passed in as part of the method call. This model id is what we use
    /// to determine which model in the model list to use. For consistency, we
    /// require you to pass in this value even if you only have one model in the
    /// model list. If you pass us a model id that doesn't exist, we'll return an
    /// exception. See the error messages section for more information on the
    /// exceptions this API can raise. You will need to write code to handle the
    /// exceptions appropriately.
    ///
    /// This method allows the selection of Options in state based on Model Option Rules validation for passed in Model in the state. 
    /// The following steps shows the state selection process during build and price process
    ///
    /// Step1 ProcessModelColorRules  - This method validates the selected exterior/interior colors are valid for the selected Model.
    ///                                 Also, Option Color Conflicts rules will also be checked incase options are already selected in the state.
    /// Step2 ProcessModelOptionRules - This process is called for verifying model option rules and selecting appropriate options.
    ///                                 Since Option Color Rules need to be validated, the colors are obtained from the state
    ///                                 assuming Step1 is already executed. Incase this method is called directly, default
    ///                                 exterior color(first color in array) and default interior color(first color in array for the selected
    ///                                 exterior color) are selected and Option color rules are processed based on this colors.
    /// Imp Note: If bAutoApproveChanges is set to true, if Option Color Conflicts arises, the conflict will be raised to the caller. 
    ///           No Option Color will be selected. 
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose configuration needs to be validated</param>
    /// <param name="sSelExtColor">Currently selected exterior color</param>
    /// <param name="sSelIntColor">Currently selected interior color</param>
    /// <param name="sSelOpCode">Currently selected OpCode</param>
    /// <param name="bAutoApproveChanges">If False, returns conflict object to the caller Else resolves conflicts automatically</param>    
    /// <returns>ECRulesEngineQueryResult object with conflicts/no conflicts and passedValidation flag as true/false.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECRE = new ECRulesEngine();
    try {
        return oECRE.ValidateConfiguration(sModelId, "", "", sSelOpCode, "", bAutoApproveChanges);
    }
    catch (e) { throw e; }
    finally { oECRE = null; }
}

ECConfigurationManager.prototype.ProcessModelFIFRules = function (sModelId, sFIFId, bAutoApproveChanges, sExclusivelySelectedFIFs) {
    /// <summary> 
    /// Assumption: The model list variable within the ConfigurationEngine class must be
    /// populated with data from one or more unique models. The source of the data
    /// for this variable should be the eConfig serverside "getmodeloptions"
    /// method. The "getmodeloptions" method takes in one or more models and
    /// returns a JSON representation of the model data. This JSON is then used to
    /// populate the model list variable. Eventhough multiple models can be added
    /// to the model list variable, the models must be all be unique (different
    /// model IDs). This means that you CAN NOT configure two models with the same
    /// model ID at the same time. Configuration of multiple models is supported
    /// but only if the model IDs are different.

    /// There is no explicit "select model" method because the main methods
    /// (ProcessModelColorRules, ProcessModelOptionRules and ProcessModelFIFRules) all require the model
    /// ID to be passed in as part of the method call. This model id is what we use
    /// to determine which model in the model list to use. For consistency, we
    /// require you to pass in this value even if you only have one model in the
    /// model list. If you pass us a model id that doesn't exist, we'll return an
    /// exception. See the error messages section for more information on the
    /// exceptions this API can raise. You will need to write code to handle the
    /// exceptions appropriately.
    ///
    /// This method allows the selection of FIFs in state based on Model FIF Rules validation for passed in Model in the state. 
    /// The following steps shows the state selection process during build and price process
    ///
    /// Step1 ProcessModelColorRules  - This method validates the selected exterior/interior colors are valid for the selected Model.
    ///                                 Also, Option Color Conflicts rules will also be checked incase options are already selected in the state.
    /// Step2 ProcessModelOptionRules - This process is called for verifying model option rules and selecting appropriate options.
    ///                                 Since Option Color Rules need to be validated, the colors are obtained from the state
    ///                                 assuming Step1 is already executed. Incase this method is called directly, default
    ///                                 exterior color(first color in array) and default interior color(first color in array for the selected
    ///                                 exterior color) are selected and Option color rules are processed based on this colors.
    /// Step3 ProcessModelFIFRules    - This process is called for verifying model fif rules and selecting appropriate fifs.
    ///                                 Since FIF Color Rules need to be validated, the colors are obtained from the state assuming Step1 is
    ///                                 already executed. Incase this method is called directly, default exterior color(first color in array)
    ///                                 and default interior color(first color in array for the selected exterior color) are selected and FIF Color
    ///                                 rules are processed based on this colors.
    ///    
    /// Imp Note: If bAutoApproveChanges is set to true, if FIF Color Conflicts arises, the conflict will be raised to the caller. 
    ///           No FIF will be selected. 
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose configuration needs to be validated</param>
    /// <param name="sSelFIFCode">Currently selected FIFCode</param>
    /// <param name="bAutoApproveChanges">If False, returns conflict object to the caller Else resolves conflicts automatically</param>
    ///<param name="sExclusivelySelectedFIFs">This will be comma seperated list of FIFIds that are part of ExclusivelyRequiredFIFs and selected by User</param>
    /// <returns>ECRulesEngineQueryResult object with conflicts/no conflicts and passedValidation flag as true/false.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECRE = new ECRulesEngine();
    try {
        return oECRE.ValidateConfiguration(sModelId, "", "", "", sFIFId, bAutoApproveChanges, sExclusivelySelectedFIFs);
    }
    catch (e) { throw e; }
    finally { oECRE = null; }
}

ECConfigurationManager.prototype.GetVisuallyExclusiveList = function (sModelId, sOpCode, sAssetIdent) {
    /// <summary>
    /// This method processes the visually exclusive rules and returns any conflicts
    /// Below are the process steps that need to be followed
    /// 1. An Asset is obtained by the user by calling GetAsset method and passing in the ModelId, OpCode and AssetIdent.
    /// 2. For each Option Asset selected, the GetVisuallyExclusiveList is called. For the first time, the VisibleAsset list
    ///    containing all the selected Visible Assets is empty and no conflicts are returned to the user.
    /// 3. The caller should add the selected asset to the Visible Asset List by calling the AddVisibleAssets() method.
    /// 4. For any subsequent calls, the ZOrder of the selected Asset having same ModelId is compared against the assets 
    ///    contained in the VisibleAssetList. Any resulting conflict will be populated in VisuallyExclusiveOptions array
    ///    of the ECQueryRulesEngineResult. Based on the user selection, AddVisibleAsset and RemoveVisibleAsset should be 
    ///    called to add or remove it from the VisibleAsset List.       
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose configuration needs to be validated</param>
    /// <param name="sOpCode">Currently selected OpCode</param>
    /// <param name="sAssetIdent">Currently selected Asset Ident</param>
    /// <returns>ECRulesEngineQueryResult object with conflicts/no conflicts and passedValidation flag as true/false.</returns>
    /// <exception>None</exception>
    var oECVAS, aVisibleAssets, oSelAsset, oQueryResult, bResult;
    oECM = new ECConfigurationManager();
    oQueryResult = new ECRulesEngineQueryResult();
    oECVAS = new ECVisibleAssets();

    aVisibleAssets = oECVAS.VisibleAssets;
    oSelAsset = oECM.GetAsset(sModelId, sOpCode, sAssetIdent);
    if (aVisibleAssets != null) {
        for (var i = 0; i < aVisibleAssets.length; i++) {
            oCurAsset = oECM.GetAsset(aVisibleAssets[i].ModelId, aVisibleAssets[i].OpCode, aVisibleAssets[i].AssetIdent);
            if (oCurAsset.ZOrder == oSelAsset.ZOrder) {
                //create visually exclusive conflict
                oECEVC = new ECVisuallyExclusiveConflict();
                oECEVC.CurrentlySelectedAssetId = sAssetIdent;
                oECEVC.CurrentlySelectedOpCode = sOpCode;
                oECEVC.CurrentlySelectedModelId = sModelId;
                oECEVC.ConflictingAssetId = aVisibleAssets[i].AssetIdent;
                oECEVC.ConflictingOpCode = aVisibleAssets[i].OpCode;
                oECEVC.ConflictingModelId = aVisibleAssets[i].ModelId;
                oQueryResult.VisuallyExclusiveAssets.push(oECEVC);
                bResult = false;
                break;
            }
        }
    }
    if (bResult) {
        oQueryResult.PassedValidation = true;
    }
    return oQueryResult;
}

ECConfigurationManager.prototype.AddVisibleAsset = function (sModelId, sOpCode, sAssetIdent) {
    /// <summary>
    /// This method is called to add the currently selected asset to the Visible Asset List.  Keeping track of currently selected
    /// and unselected assets using the VisibleAssetList  by adding/removing it from the asset list ensures valid results
    /// of any visually conflicting assets using the GetVisuallyExclusiveList.
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose configuration needs to be validated</param>
    /// <param name="sOpCode">Currently selected OpCode</param>
    /// <param name="sAssetIdent">Currently selected Asset Ident</param>
    /// <returns>Returns true/false.</returns>
    /// <exception>None</exception>
    var oECVA, oECVAS, bAssetExists, bResult;
    bAssetExists = false;
    bResult = false;
    try {
        oECVA = new ECVisibleAsset(sModelId, sOpCode, sAssetIdent);
        oECVAS = new ECVisibleAssets();
        for (var i = 0; i < oECVAS.VisibleAssets.length; i++) {
            if ((oECVAS.VisibleAssets[i].ModelId == sModelId) && (oECVAS.VisibleAssets[i].OpCode == sOpCode) && (oECVAS.VisibleAssets[i].AssetIdent == sAssetIdent)) {
                bAssetExists = true;
                break;
            }
        }
        if (!bAssetExists) {
            oECVAS.VisibleAssets.push(oECVA);
        }
        bResult = true;
    }
    catch (e) { throw errRules4001; }

    return bResult;
}

ECConfigurationManager.prototype.RemoveVisibleAsset = function (sModelId, sOpCode, sAssetIdent) {
    /// <summary>
    /// This method is called to remove the currently selected asset from the Visible Asset List. Keeping track of currently selected
    /// and unselected assets using the VisibleAssetList  by adding/removing it from the asset list ensures valid results
    /// of any visually conflicting assets using the GetVisuallyExclusiveList.      
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose configuration needs to be validated</param>
    /// <param name="sOpCode">Currently selected OpCode</param>
    /// <param name="sAssetIdent">Currently selected Asset Ident</param>
    /// <returns>Returns true/false.</returns>
    /// <exception>None</exception>
    var oECVAS, bAssetExists, bResult;
    bAssetExists = false;
    bResult = false;
    try {
        oECVAS = new ECVisibleAssets();
        for (var i = 0; i < oECVAS.VisibleAssets.length; i++) {
            if ((oECVAS.VisibleAssets[i].ModelId == sModelId) && (oECVAS.VisibleAssets[i].OpCode == sOpCode) && (oECVAS.VisibleAssets[i].AssetIdent == sAssetIdent)) {
                oECVAS.VisibleAssets.splice(i, 1);
                bResult = true;
                break;
            }
        }
    }
    catch (e) { bResult = false; }

    return bResult;
}

ECConfigurationManager.prototype.GetAsset = function (sModelId, sOpCode, sAssetIdent) //TODO: Change case for sOpCode
{
    /// <summary>
    /// This method returns the ECAsset object for the passed in Model, Option and AssetIdent within it.      
    /// </summary>
    /// <param name="sModelId">ModelId of the Model</param>
    /// <param name="sOpCode">OpCode for Option whose AssetList needs to be checked</param>
    /// <param name="sAssetIdent">Asset Ident of Asset</param>
    /// <returns>Returns asset object</returns>
    /// <exception>None</exception>
    var oECM, oModel, aAssets;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);

    try {
        if (oModel != null) {
            aOptions = oModel.ModelOptionList;
            if (aOptions != null) {
                for (var j = 0; j < aOptions.length; j++) {
                    if (aOptions[j].OpCode == sOpCode) {
                        aAssets = aOptions[j].OptionAssetList;
                        if (aAssets != null) {
                            for (var i = 0; i < aAssets.length; i++) {
                                if (aAssets[i].AssetId = sAssetIdent) {
                                    return aAssets[i];
                                }
                            }
                        }
                    }
                }
            }
            else {
                throw errOption2000;
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; }
}

ECConfigurationManager.prototype.GetModel = function (sModelId) {
    /// <summary>
    /// This method returns the ECModel object for the passed in ModelId
    /// </summary>
    /// <param name="sModelId">ModelId of the requested Model</param>
    /// <returns>ECModel object</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oModel, oECM, aModels;

    oECM = new ECConfigurationManager();
    aModels = oECM.ModelList;

    try {
        if (aModels != null) {
            for (var i = 0; i < aModels.length; i++) {
                if (aModels[i].ModelId == sModelId) {
                    oModel = aModels[i];
                }
            }
        }
        else {
            throw errModel1001;
        }
    }
    catch (e) { throw e; }
    finally { aModels = null; }

    return oModel;
}

ECConfigurationManager.prototype.GetOption = function (sModelId, sOpCode) {
    /// <summary>
    /// This method returns the ECOption object for the passed in ModelId and OpCode
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose Option is requested</param>
    /// <param name="sOpCode">OpCode for the requested Option</param>
    /// <returns>ECOption object</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oOption, oECM, oModel, aOptions;

    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);

    try {
        if (oModel != null) {
            aOptions = oModel.ModelOptionList;
            if (aOptions != null) {
                for (var i = 0; i < aOptions.length; i++) {
                    if (aOptions[i].OpCode == sOpCode) {
                        oOption = aOptions[i];
                        break;
                    }
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; }
    // return the populated option object
    return oOption;
}

ECConfigurationManager.prototype.GetOptions = function (sModelId, aOpCodeList) {
    /// <summary>
    /// This method returns the ECOption objects for the passed in ModelId and OpCode Array
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose Options are requested</param>
    /// <param name="aOpCodeList">Array of OpCodes for which Options are requested</param>
    /// <returns>Array of ECOption object</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>

    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);
    var aOptionList = new Array();
    var counter = 0;

    try {
        if (oModel != null) {
            for (var j = 0; j < aOpCodeList.length; j++) {
                for (var i = 0; i < oModel.ModelOptionList.length; i++) {
                    if (oModel.ModelOptionList[i].OpCode == aOpCodeList[j]) {
                        aOptionList[counter] = oModel.ModelOptionList[i];
                        counter++;
                    }
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; }
    return aOptionList;
}

ECConfigurationManager.prototype.GetOptionsByaDisplayGroup = function (sModelId, sOptionDisplayGroup) {
    /// <summary>
    /// This method returns the ECOption objects for the passed in ModelId and DisplayGroup
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose Options are requested</param>
    /// <param name="sOptionDisplayGroup">DisplayGroup Code for which Options are requested</param>
    /// <returns>Array of ECOption object</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);
    var aOptionList = new Array();
    var aOptionUnsortedList = new Array();
    var aOptionListwSortOrder = new Array();
    var counter = 0;

    try {
        for (var i = 0; i < oModel.ModelOptionList.length; i++) {
            aDisplayGroups = oModel.ModelOptionList[i].DisplayGroups;
            if (aDisplayGroups != null) {
                for (var j = 0; j < aDisplayGroups.length; j++) {
                    if (aDisplayGroups[j].DisplayGrpCd == sOptionDisplayGroup) {
                        aOptionUnsortedList[counter] = oModel.ModelOptionList[i];
                        aOptionListwSortOrder[counter] = { "OpCode": oModel.ModelOptionList[i].OpCode, "SortOrder": aDisplayGroups[j].OptionSortOrder };

                        counter++;
                    }
                }
            }
        }
        aOptionListwSortOrder.sort(oECM.SortArray);
        for (var k = 0; k < aOptionListwSortOrder.length; k++) {
            for (var l = 0; l < aOptionUnsortedList.length; l++) {
                if (aOptionListwSortOrder[k].OpCode == aOptionUnsortedList[l].OpCode) {
                    aOptionList[k] = aOptionUnsortedList[l];
                }
            }
        }
        return aOptionList;
    }
    catch (e) {
        throw e;
    }
    finally {
        oModel = null; aOptionListwSortOrder = null; aOptionUnsortedList = null;
    }
}

ECConfigurationManager.prototype.SortArray = function (a, b) {
    var x = parseInt(a.SortOrder);
    var y = parseInt(b.SortOrder);
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
}

ECConfigurationManager.prototype.GetOptionsByDisplayGroup = function (sModelId, aOptionDisplayGroupList) {
    /// <summary>
    /// This method returns the ECOption objects for the passed in ModelId and DisplayGroups
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose Options are requested</param>
    /// <param name="aOptionDisplayGroupList">Array of DisplayGroup Code for which Options are requested</param>
    /// <returns>Array of ECOption object</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>

    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);
    var aOptionList = new Array();
    var counter = 0;

    try {
        if (oModel != null) {
            for (var k = 0; k < aOptionDisplayGroupList.length; k++) {
                for (var i = 0; i < oModel.ModelOptionList.length; i++) {
                    aDisplayGroups = oModel.ModelOptionList[i].DisplayGroups;
                    if (aDisplayGroups != null) {
                        for (var j = 0; j < aDisplayGroups.length; j++) {
                            if (aDisplayGroups[j].DisplayGrpCd == aOptionDisplayGroupList[k]) {
                                aOptionList[counter] = oModel.ModelOptionList[i];
                                counter++;
                            }
                        }
                    }
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; }
    return aOptionList;
}

ECConfigurationManager.prototype.GetModelAssets = function (sModelId, sAssetTypeCode, sAssetViewCode) {
    /// <summary>
    /// This method returns the ECAsset objects for the passed in ModelId, AssetTypeCode and AssetViewCode
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose Assets are requested</param>
    /// <param name="sAssetTypeCode">Asset Type Code i.e. "IMGOVERLAY"</param>
    /// <param name="sAssetViewCode">Asset View Code i.e. "34FRONT"</param>
    /// <returns>ECAsset objects</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM, oModel, oAssets, aAssets;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);
    aAssets = new Array();

    try {
        if (oModel != null) {
            oAssets = oModel.ModelAssetList;
            for (var j = 0; j < oAssets.length; j++) {
                if (oAssets[j].AssetTypeCode == sAssetTypeCode) {
                    if (oAssets[j].AssetViewCode == sAssetViewCode) {
                        aAssets.push(oAssets[j]);
                    }
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oAssets = null; }

    return aAssets;
}

ECConfigurationManager.prototype.GetModelTexts = function (sModelId, sTextTypeCode) {
    /// <summary>
    /// This method returns the ECText objects for the passed in ModelId and TextTypeCode
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose Assets are requested</param>
    /// <param name="sTextTypeCode">Text Type Code of the Marketing text</param>
    /// <returns>ECText objects</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>

    var oECM, oModel, oTexts, aTexts;

    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);
    aTexts = new Array();

    try {
        if (oModel != null) {
            oTexts = oModel.ModelTextList;
            for (var j = 0; j < oTexts.length; j++) {
                if (oTexts[j].TextTypeCode == sTextTypeCode) {
                    aTexts.push(oTexts[j]);
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oTexts = null; }

    return aTexts;
}

ECConfigurationManager.prototype.GetOptionAssets = function (sModelId, sAssetTypeCode, sAssetViewCode) {
    /// <summary>
    /// This method returns the ECAsset objects for the passed in ModelId, AssetTypeCode and AssetViewCode.
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose Assets are requested</param>
    /// <param name="sAssetTypeCode">Asset Type Code i.e. "IMGOVERLAY"</param>
    /// <param name="sAssetViewCode">Asset View Code i.e. "34FRONT"</param>
    /// <returns>ECAsset objects</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM, oModel, oOptions, aAssets;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);
    aAssets = new Array();

    try {
        if (oModel != null) {
            oOptions = oModel.ModelOptionList;
            if (oOptions != null) {
                for (var j = 0; j < oOptions.length; j++) {
                    oAssets = oOptions[j].OptionAssetList;
                    for (var k = 0; k < oAssets.length; k++) {
                        if (oAssets[k].AssetTypeCode == sAssetTypeCode) {
                            if (oAssets[k].AssetViewCode == sAssetViewCode) {
                                aAssets.push(oAssets[k]);
                            }
                        }
                    }
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oOptions = null; }

    return aAssets;
}

ECConfigurationManager.prototype.GetOptionTexts = function (sModelId, sTextTypeCode) {
    /// <summary>
    /// This method returns the ECTexts objects for the passed in ModelId and TextTypeCode.
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose Marketing Texts are requested</param>
    /// <param name="sTextTypeCode">Text Type Code</param>
    /// <returns>ECText objects</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM, oModel, oOptions, oTexts, aTexts;

    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);
    aTexts = new Array();

    try {
        if (oModel != null) {
            oOptions = oModel.ModelOptionList;
            if (oOptions != null) {
                for (var j = 0; j < oOptions.length; j++) {
                    oTexts = oOptions[j].OptionTextList;
                    for (var k = 0; k < oTexts.length; k++) {
                        if (oTexts[k].TextTypeCode == sTextTypeCode) {
                            aTexts.push(oTexts[k]);
                        }
                    }
                }
            }
            else {
                throw errOption2000;
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oOptions = null; oTexts = null; }

    return aTexts;
}

ECConfigurationManager.prototype.SetModelState = function (sModelState) {
    /// <summary>
    /// This method restores the state of the Model by parsing the sModelState string containing state information.
    /// The method makes calls to ProcessModelColorRules and ProcessModelOptionRules with AutoApproveflag set to true.
    /// The correct state is selected and the user can obtain the new state by calling GetModelState method.    
    /// Any Model Color Conflicts or Option Color Conflicts are returned to the user.
    /// </summary>
    /// <param name="sModelState">
    ///  This param contains the state information. It is obtained by calling GetModelState and passing ModelId and type "qs"                            
    /// </param>   
    /// <returns>ECRulesEngineQueryResult</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>

    var sModelId, sExtCol, sHondaCode, sIntCol, aOpCodes, aFIFs, aModelState, oQueryResult;
    aModelState = new Array();
    aOpCodes = new Array();
    aFIFs = new Array();

    try {
        sModelState = unescape(sModelState);
        window.text = sModelState;
        if (sModelState.indexOf("$") > 0) {
            aModelState = sModelState.split("$");
        }
        else {
            aModelState = sModelState.split("|");
        }
        sModelId = aModelState[0].substring(2);
        sExtCol = aModelState[1].substring(3);
        sHondaCode = aModelState[2].substring(3);
        sIntCol = aModelState[3].substring(3);
        if (aModelState[4] != "O:") {
            aOpCodes = aModelState[4].substring(2).split(",");
        }
        if (aModelState[5] != "F:") {
            aFIFs = aModelState[5].substring(2).split(",");
        }
        sExtColCode = aModelState[6].split(",");
        sExtColExt = aModelState[7].split(",");

        var oECM = new ECConfigurationManager();
        oECM.ProcessModelColorRules(sModelId, sExtCol, sIntCol);

        for (var i = 0; i < aOpCodes.length; i++) {
            oQueryResult = oECM.ProcessModelOptionRules(sModelId, aOpCodes[i], true);
        }

        //Restoring FIF State by processing selected FIFs
        for (var j = 0; j < aFIFs.length; j++) {
            var sFIFId = aFIFs[j].split(";")[0];
            var oFIF = oECM.GetFIFById(sModelId, sFIFId);
            if (oFIF != null) {
                oQueryResult = oECM.ProcessModelFIFRules(sModelId, sFIFId, true, "");
            }
            else {
                throw errFIF5001;
            }
        }

        //        var aFIFsSelected = oECM.GetCurrentlySelectedFIFs(sModelId);
        //        if (aFIFsSelected != null) {
        //            for (var k = 0; k < aFIFsSelected.length; k++) {
        //                oQueryResult = oECM.ProcessModelFIFRules(sModelId, aFIFsSelected[k].FIFId, true, "");
        //            }
        //        }
    }
    catch (e) { throw e; }
    finally { sModelId = null; sExtCol = null; sHondaCode = null; sIntCol = null; aOpCodes = null; }

    return oQueryResult;
}

ECConfigurationManager.prototype.GetStateFromQS = function (sParam) {
    /// <summary>
    /// This method parses the url to obtain the modelstate querystring param passed in. The result is then
    /// passed to SetModelState method which sets the appropriate state.
    /// 
    /// Note: This method will be used in a multiple page build and price process. The state information is
    /// passed to the next/previous page as querystring param.
    /// </summary>
    /// <param name="sModelState">
    ///  This param contains the state information. It is obtained by calling GetModelState and passing ModelId and type "qs"                            
    /// </param>   
    /// <returns>ECRulesEngineQueryResult</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>

    sParam = sParam.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + sParam + "=([^&#]*)";
    var repString = "?" + sParam;
    var regex = new RegExp(regexS);
    var results = regex.exec(window.location.href);

    var sModelState = results.toString();
    sModelState = sModelState.replace("?" + sParam + "=", "");

    try {
        if (results == null) {
            throw errModel1002;
        }
        else {
            var oECM = new ECConfigurationManager();
            var oQueryResult = oECM.SetModelState(sModelState);
        }
    }
    catch (e) { throw e; }
    finally { results = null; sModelState = null; }

    return oQueryResult;
}

ECConfigurationManager.prototype.ClearModelState = function (sModelId) {
    /// <summary>
    /// This method clears the state of the model selected colors and accessories.
    /// </summary>
    /// <param name="sModelId">ModelId for which state will be cleared</param>   
    /// <returns>None</returns>
    /// <exception>If Model is not found in the ModelList, it will throw errModel1000 - Model doesn't exist</exception>
    var oECM, oModel, oSelExtCol, oSelIntCol, aOptions, aOptionColors, aFIFs;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId)

    try {
        if (oModel != null) {
            oModel.IsSelected = false;
            oSelExtCol = oECM.GetSelectedExteriorColor(sModelId);
            if (oSelExtCol != null) {
                oSelExtCol.IsSelected = false;
            }
            oSelIntCol = oECM.GetSelectedInteriorColor(sModelId);
            if (oSelIntCol != null) {
                oSelIntCol.IsSelected = false;
            }
            aOptions = oModel.ModelOptionList;
            for (var i = 0; i < aOptions.length; i++) {
                if (aOptions[i].IsSelected) {
                    aOptions[i].IsSelected = false;
                    aOptionColors = aOptions[i].OptionColorList;
                    if (aOptionColors.length > 0) {
                        for (var j = 0; j < aOptionColors.length; j++) {
                            if (aOptionColors[j].IsSelected) {
                                aOptionColors[j].IsSelected = false;
                            }
                        }
                    }
                }
            }

            //Resetting FIFs to not selected
            aFIFs = oModel.ModelFIFList;
            if (aFIFs != null) {
                for (var j = 0; j < aFIFs.length; j++) {
                    if (aFIFs[j].IsSelected) {
                        aFIFs[j].IsSelected = false;
                    }
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; }
}

ECConfigurationManager.prototype.GetModelState = function (sModelId, sType, borigConfig) {
    /// <summary>
    /// This method obtains the current state of the configuration. Based on the return type passed in, the configuration 
    /// is returned in either XML/JSON/QueryString format. 
    /// sType values:- XML: xml, JSON: json, QueryString: qs
    /// </summary>
    /// <param name="sModelId">ModelId of the model whose configuration is obtained.</param>
    /// <returns>Configuration XML/JSON string/State String</returns>
    /// <exception>If no Model is present, returns errModel1000 - "Model doesn't exist" error</exception>
    /// <exception>If Configuration XML is requested and XmlDocument is not loaded, an exception is thrown</exception>
    var configXml, configXmlDoc, oECM, oModel, aOptions, aSelFIFs, sFIFs;
    var aOptionColors, bOptionColor;
    var fTotalPrice, sColorMfgCode, sProductHondaCode, sColorCode;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);


    if (sType.toLowerCase() == "xmlold") {
        configXml = "<configured-model model_id=\"\" total_configured_price=\"\" config_title=\"\">";
        configXml += "<color exterior_mfg_color_cd=\"\" interior_color_cd=\"\" product_honda_cd=\"\" />";
        configXml += "<accessories></accessories>";
        configXml += "</configured-model>";

        try {
            configXmlDoc = new ActiveXObject("MSXML2.DOMDocument");
        }
        catch (e) {
            try {
                configXmlDoc = document.implementation.CreateDocument("", "", null);
            }
            catch (e) { throw e; }
        }
        if (configXmlDoc != null) {
            configXmlDoc.async = "false";
            configXmlDoc.loadXML(configXml);

            var oSelExtColor = oECM.GetSelectedExteriorColor(sModelId);
            var oSelIntColor = oECM.GetSelectedInteriorColor(sModelId);

            configXmlDoc.selectSingleNode("configured-model/@model_id").text = sModelId;
            configXmlDoc.selectSingleNode("configured-model/@total_configured_price").text = oModel.TotalPrice;
            if (oSelExtColor != null) {
                configXmlDoc.selectSingleNode("configured-model/color/@exterior_mfg_color_cd").text = oSelExtColor.ColorMfgCode;
                configXmlDoc.selectSingleNode("configured-model/color/@product_honda_cd").text = oSelExtColor.ProductHondaCode;
            }
            if (oSelIntColor != null) {
                configXmlDoc.selectSingleNode("configured-model/color/@interior_color_cd").text = oSelIntColor.ColorCode;
            }


            aOptions = oModel.ModelOptionList;

            oAccessories = configXmlDoc.selectSingleNode("configured-model/accessories");
            for (var i = 0; i < aOptions.length; i++) {
                if (aOptions[i].IsSelected) {
                    if (aOptions[i].OptionColorList.length > 0) {
                        aOptionColors = aOptions[i].OptionColorList;
                        for (var j = 0; j < aOptionColors.length; j++) {
                            bOptionColor = false;
                            if (aOptionColors[j].IsSelected) {
                                bOptionColor = true;

                                oNewAcc = configXmlDoc.createElement("accessory");
                                oAccessories.appendChild(oNewAcc);

                                oOpCodeAttribute = configXmlDoc.createAttribute("op_code");
                                oOpCodeAttribute.nodeValue = aOptions[i].OpCode;
                                oNewAcc.setAttributeNode(oOpCodeAttribute);

                                oPartNumberAttribute = configXmlDoc.createAttribute("part_number");
                                oPartNumberAttribute.nodeValue = aOptionColors[j].PartNumber;
                                oNewAcc.setAttributeNode(oPartNumberAttribute);

                                oOptionColorAttribute = configXmlDoc.createAttribute("option_color_cd");

                                if (aOptionColors[j].ColorType == "E") {
                                    oOptionColorAttribute.nodeValue = aOptionColors[j].ColorMfgCode;
                                }
                                else {
                                    oOptionColorAttribute.nodeValue = aOptionColors[j].ColorCode;
                                }
                                oNewAcc.setAttributeNode(oOptionColorAttribute);
                                break;
                            }
                        }
                    }

                    if (!bOptionColor) {
                        oNewAcc = configXmlDoc.createElement("accessory");
                        oAccessories.appendChild(oNewAcc);

                        oOpCodeAttribute = configXmlDoc.createAttribute("op_code");
                        oOpCodeAttribute.nodeValue = aOptions[i].OpCode;

                        oNewAcc.setAttributeNode(oOpCodeAttribute);
                    }
                }

            }
            return configXmlDoc.xml;
        }
    }
    else if (sType.toLowerCase() == "xml") {
        configXml = "<configuration  total_configured_price=\"TOTALPRICE\" DEALERNO > ";
        configXml += "<model id=\"MODELID\" model_year=\"MODELYEAR\" msrp=\"MSRP\">";
        configXml += "<client_side_state>CLIENTSIDESTATE</client_side_state>"
        configXml += "<color exterior_color_ident=\"EXTERIORCOLORIDENT\" exterior_color_name=\"EXTERIORCOLORNAME\" exterior_color_cd=\"EXTERIORCOLORCODE\" exterior_mfg_color_cd=\"EXTERIORMFGCOLORCODE\" exterior_mfg_color_cd_ext=\"EXTERIORMFGCOLORCODEEXT\" exterior_price_delta=\"EXTERIORPRICEDELTA\" interior_color_ident=\"INTERIORCOLORIDENT\" interior_color_name=\"INTERIORCOLORNAME\" interior_color_cd=\"INTERIORCOLORCODE\" interior_price_delta=\"INTERIORPRICEDELTA\" product_honda_cd=\"PRODUCTHONDACODE\" />";
        configXml += "<accessories>SELECTEDACCESSORIES</accessories>";
        configXml += "<fifs>SELECTEDFIFS</fifs>";
        configXml += "</model>";
        configXml += "<original_configuration_data>ORIGINALCONFIGURATIONDATA</original_configuration_data>";
        configXml += "</configuration>";

        var accessoryXml = "<accessory op_cd=\"OPCODE\" option_name=\"OPTIONNAME\" msrp=\"OPTIONMSRP\" OPTIONCOLORSTRING selection_type=\"SELECTIONTYPE\" selected_order=\"SELECTEDORDER\" />";
        var fifXml = "<fif id=\"FIFID\" cd=\"FIFCODE\" fif_desc=\"FIFDESC\" category_cd=\"FIFCATEGORYCODE\" fif_category_desc=\"FIFCATEGORYDESC\" msrp=\"FIFMSRP\" weight=\"FIFWEIGHT\" />";

        if (configXml != null) {
            var oSelExtColor = oECM.GetSelectedExteriorColor(sModelId);
            var oSelIntColor = oECM.GetSelectedInteriorColor(sModelId);

            configXml = configXml.replace("TOTALPRICE", oModel.TotalPrice);
            if (oModel.DealerNumber != null) {
                if (oModel.DealerNumber != "") {

                    var dealerString = "dealer_no=\"" + oModel.DealerNumber + "\"";
                    configXml = configXml.replace("DEALERNO", dealerString);
                }
                else {
                    configXml = configXml.replace("DEALERNO", "");
                }
            }
            else {
                configXml = configXml.replace("DEALERNO", "");
            }

            configXml = configXml.replace("MODELID", sModelId);
            configXml = configXml.replace("MODELYEAR", oModel.ModelYear);
            configXml = configXml.replace("MSRP", oModel.MSRP);
            if (oSelExtColor != null) {

                configXml = configXml.replace("EXTERIORMFGCOLORCODE", oSelExtColor.ColorMfgCode);
                configXml = configXml.replace("EXTERIORCOLORNAME", oSelExtColor.ColorName);
                if ((oSelExtColor.ProductHondaCode) == undefined) {
                    configXml = configXml.replace("PRODUCTHONDACODE", "");
                }
                else {
                    configXml = configXml.replace("PRODUCTHONDACODE", oSelExtColor.ProductHondaCode);
                }
                configXml = configXml.replace("EXTERIORCOLORIDENT", oSelExtColor.ColorIdent);
            }
            if (oSelIntColor != null) {

                configXml = configXml.replace("INTERIORCOLORCODE", oSelIntColor.ColorCode);
                configXml = configXml.replace("INTERIORCOLORIDENT", oSelIntColor.ColorIdent);
                configXml = configXml.replace("INTERIORCOLORNAME", oSelIntColor.ColorName);

                if (oModel.ColorComboList[oSelExtColor.ColorMfgCode].InteriorColors != null) {
                    for (var i = 0; i < oModel.ColorComboList[oSelExtColor.ColorMfgCode].InteriorColors.length; i++) {
                        if (oModel.ColorComboList[oSelExtColor.ColorMfgCode].InteriorColors[i].ColorCode == oSelIntColor.ColorCode) {
                            var fInteriorColorPriceDelta = oModel.ColorComboList[oSelExtColor.ColorMfgCode].InteriorColors[i].InteriorPriceDelta;

                            configXml = configXml.replace("INTERIORPRICEDELTA", fInteriorColorPriceDelta);
                            configXml = configXml.replace("EXTERIORPRICEDELTA", oModel.ColorComboList[oSelExtColor.ColorMfgCode].PriceDelta);
                            configXml = configXml.replace("EXTERIORCOLORCODE", oModel.ColorComboList[oSelExtColor.ColorMfgCode].InteriorColors[i].ExteriorColorCode);
                            configXml = configXml.replace("EXTERIORMFGCOLORCODEEXT", oModel.ColorComboList[oSelExtColor.ColorMfgCode].InteriorColors[i].ExteriorMfgColorCodeExtension);
                        }
                    }
                }
            }


            aOptions = oModel.ModelOptionList;

            var sAccessories = "";
            for (var i = 0; i < aOptions.length; i++) {
                if (aOptions[i].IsSelected) {
                    if (aOptions[i].OptionColorList.length > 0) {
                        aOptionColors = aOptions[i].OptionColorList;
                        for (var j = 0; j < aOptionColors.length; j++) {
                            bOptionColor = false;
                            if (aOptionColors[j].IsSelected) {
                                bOptionColor = true;


                                var sNewAccessory = accessoryXml;

                                sNewAccessory = sNewAccessory.replace("OPCODE", aOptions[i].OpCode);
                                sNewAccessory = sNewAccessory.replace("OPTIONNAME", aOptions[i].OptionName);
                                //If DealerNumber is present, pass the dealer price else pass the msrp

                                if (oModel.DealerNumber.length > 0) {

                                    sNewAccessory = sNewAccessory.replace("OPTIONMSRP", aOptions[i].OptionDealerPrice);
                                }
                                else {

                                    sNewAccessory = sNewAccessory.replace("OPTIONMSRP", aOptions[i].OptionPrice);
                                }


                                var sOptionColor = "part_number=\"PARTNUMBER\" option_color_cd=\"OPTIONCOLORCODE\"";

                                sOptionColor = sOptionColor.replace("PARTNUMBER", aOptionColors[j].PartNumber);

                                if (aOptionColors[j].ColorType == "E") {

                                    sOptionColor = sOptionColor.replace("OPTIONCOLORCODE", aOptionColors[j].ColorMfgCode);
                                }
                                else {

                                    sOptionColor = sOptionColor.replace("OPTIONCOLORCODE", aOptionColors[j].ColorCode);
                                }

                                sNewAccessory = sNewAccessory.replace("OPTIONCOLORSTRING", sOptionColor);


                                var selType = aOptions[i].SType;
                                if (selType == "undefined") { selType = ""; }
                                sNewAccessory = sNewAccessory.replace("SELECTIONTYPE", selType);


                                var selOrder = aOptions[i].SelectedOrder;
                                if (selOrder == undefined) {
                                    selOrder = "";
                                }
                                sNewAccessory = sNewAccessory.replace("SELECTEDORDER", selOrder);

                                sAccessories += sNewAccessory;
                                break;
                            }
                        }
                    }

                    if (!bOptionColor) {

                        sNewAccessory = accessoryXml;


                        sNewAccessory = sNewAccessory.replace("OPCODE", aOptions[i].OpCode);
                        sNewAccessory = sNewAccessory.replace("OPTIONNAME", aOptions[i].OptionName);


                        if (oModel.DealerNumber.length > 0) {

                            sNewAccessory = sNewAccessory.replace("OPTIONMSRP", aOptions[i].OptionDealerPrice);
                        }
                        else {

                            sNewAccessory = sNewAccessory.replace("OPTIONMSRP", aOptions[i].OptionPrice);
                        }



                        var sOptionColor = ""; //Since no option color
                        var selType = aOptions[i].SType;
                        sNewAccessory = sNewAccessory.replace("OPTIONCOLORSTRING", sOptionColor);
                        if (selType == undefined) {
                            selType = "";
                        }
                        sNewAccessory = sNewAccessory.replace("SELECTIONTYPE", selType);

                        var selOrder = aOptions[i].SelectedOrder;
                        if (selOrder == undefined) {
                            selOrder = "";
                        }
                        sNewAccessory = sNewAccessory.replace("SELECTEDORDER", selOrder);
                        sAccessories += sNewAccessory;
                    }
                }
            }
            configXml = configXml.replace("SELECTEDACCESSORIES", sAccessories);
            var aFIFs = oECM.GetCurrentlySelectedFIFs(sModelId);
            var sFIFs = "";

            if (aFIFs != null) {
                for (var k = 0; k < aFIFs.length; k++) {
                    var sNewFIF = fifXml;



                    sNewFIF = sNewFIF.replace("FIFID", aFIFs[k].FIFId);
                    sNewFIF = sNewFIF.replace("FIFCODE", aFIFs[k].FIFCode);
                    sNewFIF = sNewFIF.replace("FIFDESC", aFIFs[k].FIFDesc);
                    sNewFIF = sNewFIF.replace("FIFCATEGORYCODE", aFIFs[k].FIFCategoryCd);
                    var oFIFCategory = oECM.GetFIFCategoryByCode(sModelId, aFIFs[k].FIFCategoryCd);
                    sNewFIF = sNewFIF.replace("FIFCATEGORYDESC", oFIFCategory.FIFCategoryDesc);

                    var fifPrice = oECM.GetFIFPrice(sModelId, aFIFs[k]);

                    fifPrice = isNaN(parseFloat(fifPrice)) ? 0 : parseFloat(fifPrice);
                    sNewFIF = sNewFIF.replace("FIFMSRP", fifPrice);

                    var fifWeight = aFIFs[k].FIFWeight;

                    fifWeight = isNaN(parseFloat(fifWeight)) ? 0 : parseFloat(fifWeight);
                    sNewFIF = sNewFIF.replace("FIFWEIGHT", fifWeight);

                    sFIFs += sNewFIF;
                }
            }
            configXml = configXml.replace("SELECTEDFIFS", sFIFs);

            var sClientSideState = oECM.GetModelState(sModelId, "qs", false);

            configXml = configXml.replace("CLIENTSIDESTATE", sClientSideState);
            //If original configuration flag set to true, return original data along with config
            if (borigConfig) {
                var oModel = oECM.GetModel(sModelId);
                var stringModel = JSON.stringify(oModel);

                configXml = configXml.replace("ORIGINALCONFIGURATIONDATA", stringModel);
            }
            else {
                configXml = configXml.replace("ORIGINALCONFIGURATIONDATA", "");
            }

            return configXml;
        }
    }
    else if (sType.toLowerCase() == "jsonold") {

        var sJsonModel, sJsonExtColor, sJsonIntColor, sJsonOption, sExtColor, sIntColor;
        sJsonModel = "{\"ModelId\":\"MODEL_ID\",\"ExteriorColors\":[{EXTERIOR_COLOR}],\"InteriorColors\":[{INTERIOR_COLOR}],\"ModelOptionList\":[OPTIONS]}";
        sJsonExtColor = "\"ColorMfgCode\":\"COLOR_MFG_CODE\",\"ProductHondaCode\":\"PRODUCTHONDACODE\"";
        sJsonIntColor = "\"ColorCode\":\"COLOR_CODE\"";
        sJsonOption = "{\"OpCode\":\"OPCODE\"}";

        sJsonModel = sJsonModel.replace("MODEL_ID", sModelId);
        oExtColor = oECM.GetSelectedExteriorColor(sModelId);
        oIntColor = oECM.GetSelectedInteriorColor(sModelId);
        aSelOptions = oECM.GetCurrentlySelectedOptions(sModelId);

        if (oExtColor != null) {
            sExtColor = sJsonExtColor;

            sExtColor = sExtColor.replace("COLOR_MFG_CODE", oExtColor.ColorMfgCode);

            if (oExtColor.ProductHondaCode != null) {
                sExtColor = sExtColor.replace("PRODUCTHONDACODE", oExtColor.ProductHondaCode);
            }
            else {
                sExtColor = sExtColor.replace("PRODUCTHONDACODE", " ");
            }

        }
        if (oIntColor != null) {
            sIntColor = sJsonIntColor;
            sIntColor = sIntColor.replace("COLOR_CODE", oIntColor.ColorCode);
        }
        sOptions = sJsonOption;
        for (var k = 0; k < aSelOptions.length; k++) {
            sOptions = sOptions.replace("OPCODE", aSelOptions[k].OpCode);
            if (!(k == (aSelOptions.length - 1))) {
                sOptions += "," + sJsonOption;
            }
        }
        sOptions.replace("," + sJsonOption, "");
        sJsonModel = sJsonModel.replace("EXTERIOR_COLOR", sExtColor);
        sJsonModel = sJsonModel.replace("INTERIOR_COLOR", sIntColor);
        sJsonModel = sJsonModel.replace("OPTIONS", sOptions);

        return sJsonModel;
    }
    else if (sType.toLowerCase() == "json") {
        var configJson;
        configJson = "{ \"configuration\": { \"model\": {\"client_side_state\": \"CLIENTSIDESTATE\",\"color\": {\"@exterior_color_ident\": \"EXTERIORCOLORIDENT\",\"@exterior_color_name\": \"EXTERIORCOLORNAME\","
        configJson += "\"@exterior_color_cd\": \"EXTERIORCOLORCODE\", \"@exterior_mfg_color_cd\": \"EXTERIORMFGCOLORCODE\", \"@exterior_mfg_color_cd_ext\": \"EXTERIORMFGCOLORCODEEXT\","
        configJson += "\"@exterior_price_delta\": \"EXTERIORPRICEDELTA\", \"@interior_color_ident\": \"INTERIORCOLORIDENT\", \"@interior_color_name\": \"INTERIORCOLORNAME\","
        configJson += "\"@interior_color_cd\": \"INTERIORCOLORCODE\", \"@interior_price_delta\": \"INTERIORPRICEDELTA\", \"@product_honda_cd\": \"PRODUCTHONDACODE\""
        configJson += "},\"accessories\": { SELECTEDACCESSORIES}, \"fifs\": { SELECTEDFIFS },\"@id\": \"MODELID\",\"@model_year\": \"MODELYEAR\",\"@msrp\": \"MSRP\"},\"original_configuration_data\": \"ORIGINALCONFIGURATIONDATA\",\"@total_configured_price\": \"TOTALPRICE\" DEALERNO }}"
        var accessoriesJson = "\"accessory\": [ACCESSORIES ]";
        var accessoryJson = " {\"@op_cd\": \"OPCODE\",\"@option_name\": \"OPTIONNAME\",\"@msrp\": \"OPTIONMSRP\",OPTIONCOLORSTRING \"@selection_type\": \"SELECTIONTYPE\",\"@selected_order\": \"SELECTEDORDER\"}";
        var fifsJson = "\"fif\": [FIFS]";
        var fifJson = "{\"@id\": \"FIFID\",\"@cd\": \"FIFCODE\",\"@fif_desc\": \"FIFDESC\",\"@category_cd\": \"FIFCATEGORYCODE\",\"@fif_category_desc\": \"FIFCATEGORYDESC\",\"@msrp\": \"FIFMSRP\",\"@weight\": \"FIFWEIGHT\"}";

        if (configJson != null) {
            var oSelExteriorColor = oECM.GetSelectedExteriorColor(sModelId);
            var oSelInteriorColor = oECM.GetSelectedInteriorColor(sModelId);

            configJson = configJson.replace("TOTALPRICE", oModel.TotalPrice);
            if (oModel.DealerNumber != null) {
                if (oModel.DealerNumber != "") {

                    var sDealer = "@dealer_no\":\"" + oModel.DealerNumber + "\"";
                    configJson = configJson.replace("DEALERNO", sDealer);
                }
                else {
                    configJson = configJson.replace("DEALERNO", "");
                }
            }
            else {
                configJson = configJson.replace("DEALERNO", "");
            }

            configJson = configJson.replace("MODELID", sModelId);
            configJson = configJson.replace("MODELYEAR", oModel.ModelYear);
            configJson = configJson.replace("MSRP", oModel.MSRP);
            if (oSelExteriorColor != null) {

                configJson = configJson.replace("EXTERIORMFGCOLORCODE", oSelExteriorColor.ColorMfgCode);
                configJson = configJson.replace("EXTERIORCOLORNAME", oSelExteriorColor.ColorName);
                if ((oSelExteriorColor.ProductHondaCode) == undefined) {
                    configJson = configJson.replace("PRODUCTHONDACODE", " ");
                }
                else {
                    configJson = configJson.replace("PRODUCTHONDACODE", oSelExteriorColor.ProductHondaCode);
                }
                configJson = configJson.replace("EXTERIORCOLORIDENT", oSelExteriorColor.ColorIdent);
            }
            if (oSelInteriorColor != null) {

                configJson = configJson.replace("INTERIORCOLORCODE", oSelInteriorColor.ColorCode);
                configJson = configJson.replace("INTERIORCOLORIDENT", oSelInteriorColor.ColorIdent);
                configJson = configJson.replace("INTERIORCOLORNAME", oSelInteriorColor.ColorName);

                if (oModel.ColorComboList[oSelExteriorColor.ColorMfgCode].InteriorColors != null) {
                    for (var i = 0; i < oModel.ColorComboList[oSelExteriorColor.ColorMfgCode].InteriorColors.length; i++) {
                        if (oModel.ColorComboList[oSelExteriorColor.ColorMfgCode].InteriorColors[i].ColorCode == oSelInteriorColor.ColorCode) {
                            var fIntColorPriceDelta = oModel.ColorComboList[oSelExteriorColor.ColorMfgCode].InteriorColors[i].InteriorPriceDelta;

                            configJson = configJson.replace("INTERIORPRICEDELTA", fIntColorPriceDelta);
                            configJson = configJson.replace("EXTERIORPRICEDELTA", oModel.ColorComboList[oSelExteriorColor.ColorMfgCode].PriceDelta);
                            configJson = configJson.replace("EXTERIORCOLORCODE", oModel.ColorComboList[oSelExteriorColor.ColorMfgCode].InteriorColors[i].ExteriorColorCode);
                            configJson = configJson.replace("EXTERIORMFGCOLORCODEEXT", oModel.ColorComboList[oSelExteriorColor.ColorMfgCode].InteriorColors[i].ExteriorMfgColorCodeExtension);
                        }
                    }
                }
            }


            aOptions = oModel.ModelOptionList;

            var strAccessories = "";
            for (var i = 0; i < aOptions.length; i++) {
                if (aOptions[i].IsSelected) {
                    if (aOptions[i].OptionColorList.length > 0) {
                        aOptionColors = aOptions[i].OptionColorList;
                        for (var j = 0; j < aOptionColors.length; j++) {
                            bOptionColor = false;
                            if (aOptionColors[j].IsSelected) {
                                bOptionColor = true;


                                var strNewAccessory = accessoryJson;

                                strNewAccessory = strNewAccessory.replace("OPCODE", aOptions[i].OpCode);
                                strNewAccessory = strNewAccessory.replace("OPTIONNAME", aOptions[i].OptionName);
                                //If DealerNumber is present, pass the dealer price else pass the msrp

                                if (oModel.DealerNumber.length > 0) {

                                    strNewAccessory = strNewAccessory.replace("OPTIONMSRP", aOptions[i].OptionDealerPrice);
                                }
                                else {

                                    strNewAccessory = strNewAccessory.replace("OPTIONMSRP", aOptions[i].OptionPrice);
                                }


                                var sAccessoryOptionColor = "\"@part_number\":\"PARTNUMBER\", \"@option_color_cd\"=\"OPTIONCOLORCODE\",";

                                sAccessoryOptionColor = sAccessoryOptionColor.replace("PARTNUMBER", aOptionColors[j].PartNumber);

                                if (aOptionColors[j].ColorType == "E") {

                                    sAccessoryOptionColor = sAccessoryOptionColor.replace("OPTIONCOLORCODE", aOptionColors[j].ColorMfgCode);
                                }
                                else {

                                    sAccessoryOptionColor = sAccessoryOptionColor.replace("OPTIONCOLORCODE", aOptionColors[j].ColorCode);
                                }

                                strNewAccessory = strNewAccessory.replace("OPTIONCOLORSTRING", sAccessoryOptionColor);


                                var sSelType = aOptions[i].SType;
                                if (sSelType == "undefined") { sSelType = ""; }
                                strNewAccessory = strNewAccessory.replace("SELECTIONTYPE", sSelType);


                                var sSelOrder = aOptions[i].SelectedOrder;
                                if (sSelOrder == undefined) {
                                    sSelOrder = "";
                                }
                                strNewAccessory = strNewAccessory.replace("SELECTEDORDER", sSelOrder);

                                strAccessories += strNewAccessory;
                                break;
                            }
                        }
                    }

                    if (!bOptionColor) {

                        strNewAccessory = accessoryJson;


                        strNewAccessory = strNewAccessory.replace("OPCODE", aOptions[i].OpCode);
                        strNewAccessory = strNewAccessory.replace("OPTIONNAME", aOptions[i].OptionName);


                        if (oModel.DealerNumber.length > 0) {

                            strNewAccessory = strNewAccessory.replace("OPTIONMSRP", aOptions[i].OptionDealerPrice);
                        }
                        else {

                            strNewAccessory = strNewAccessory.replace("OPTIONMSRP", aOptions[i].OptionPrice);
                        }



                        var sOptionColor = ""; //Since no option color
                        var sSelType = aOptions[i].SType;
                        strNewAccessory = strNewAccessory.replace("OPTIONCOLORSTRING", sOptionColor);
                        if (sSelType == undefined) {
                            sSelType = "";
                        }
                        strNewAccessory = strNewAccessory.replace("SELECTIONTYPE", sSelType);

                        var sSelOrder = aOptions[i].SelectedOrder;
                        if (sSelOrder == undefined) {
                            sSelOrder = "";
                        }
                        strNewAccessory = strNewAccessory.replace("SELECTEDORDER", sSelOrder);
                        strAccessories += strNewAccessory + ",";
                    }
                }
            }
            strAccessories = strAccessories.replace(/,\s*$/, "");
            if (strAccessories != "") {
                accessoriesJson = accessoriesJson.replace("ACCESSORIES", strAccessories);
                configJson = configJson.replace("SELECTEDACCESSORIES", accessoriesJson);
            }
            else {
                configJson = configJson.replace("SELECTEDACCESSORIES", "");
            }
            var aSelFIFs = oECM.GetCurrentlySelectedFIFs(sModelId);
            var sSelFIFs = "";

            if (aSelFIFs != null) {
                for (var k = 0; k < aSelFIFs.length; k++) {
                    var sNewFIF = fifJson;



                    sNewFIF = sNewFIF.replace("FIFID", aSelFIFs[k].FIFId);
                    sNewFIF = sNewFIF.replace("FIFCODE", aSelFIFs[k].FIFCode);
                    sNewFIF = sNewFIF.replace("FIFDESC", aSelFIFs[k].FIFDesc);
                    sNewFIF = sNewFIF.replace("FIFCATEGORYCODE", aSelFIFs[k].FIFCategoryCd);
                    var oFIFCategory = oECM.GetFIFCategoryByCode(sModelId, aSelFIFs[k].FIFCategoryCd);
                    sNewFIF = sNewFIF.replace("FIFCATEGORYDESC", oFIFCategory.FIFCategoryDesc);

                    var fifPrice = oECM.GetFIFPrice(sModelId, aSelFIFs[k]);

                    fifPrice = isNaN(parseFloat(fifPrice)) ? 0 : parseFloat(fifPrice);
                    sNewFIF = sNewFIF.replace("FIFMSRP", fifPrice);

                    var fifWeight = aSelFIFs[k].FIFWeight;

                    fifWeight = isNaN(parseFloat(fifWeight)) ? 0 : parseFloat(fifWeight);
                    sNewFIF = sNewFIF.replace("FIFWEIGHT", fifWeight);

                    sSelFIFs += sNewFIF + ",";
                }
            }
            sSelFIFs = sSelFIFs.replace(/,\s*$/, "");
            if (sSelFIFs != "") {
                fifsJson = fifsJson.replace("FIFS", sSelFIFs);
                configJson = configJson.replace("SELECTEDFIFS", fifsJson);
            }
            else {
                configJson = configJson.replace("SELECTEDFIFS", "");
            }
            var sClientSideStateQS = oECM.GetModelState(sModelId, "qs", false);

            configJson = configJson.replace("CLIENTSIDESTATE", sClientSideStateQS);
            //If original configuration flag set to true, return original data along with config
            if (borigConfig) {
                var oCurrentModel = oECM.GetModel(sModelId);
                var strModel = JSON.stringify(oCurrentModel);

                configJson = configJson.replace("ORIGINALCONFIGURATIONDATA", strModel);
            }
            else {
                configJson = configJson.replace("ORIGINALCONFIGURATIONDATA", "");
            }
            return configJson;
        }
    }
    else if (sType.toLowerCase() == "qs") {
        var sQsState, sOpcodes;

        sQsState = "M:MODELID$EC:EXTERIORCOLOR$HC:HONDACODE$IC:INTERIORCOLOR$O:OPTIONS$F:FIFS$ECC:EXTCOLORCODE$ECX:EXTCOLOREXT";

        sQsState = sQsState.replace("MODELID", sModelId);
        oModel = oECM.GetModel(sModelId);
        oExtColor = oECM.GetSelectedExteriorColor(sModelId);
        if (oExtColor != null) {
            sQsState = sQsState.replace("EXTERIORCOLOR", oExtColor.ColorMfgCode);
            sQsState = sQsState.replace("HONDACODE", oExtColor.ProductHondaCode);
        }
        else {
            sQsState = sQsState.replace("EXTERIORCOLOR", "");
            sQsState = sQsState.replace("HONDACODE", "");
        }
        oIntColor = oECM.GetSelectedInteriorColor(sModelId);

        if (oIntColor != null) {
            sQsState = sQsState.replace("INTERIORCOLOR", oIntColor.ColorCode);
            //sQsState = sQsState.replace("EXTCOLORCODE", oModel - This needs to get the 
            aIntColorList = oECM.GetInteriorColorList(sModelId, oExtColor.ColorMfgCode);
            if (aIntColorList != null) {
                for (var ai = 0; ai < aIntColorList.length; ai++) {
                    if (aIntColorList[ai].ColorCode == oIntColor.ColorCode) {
                        sQsState = sQsState.replace("EXTCOLORCODE", oModel.ColorComboList[oExtColor.ColorMfgCode].InteriorColors[ai].ExteriorColorCode);
                        sQsState = sQsState.replace("EXTCOLOREXT", oModel.ColorComboList[oExtColor.ColorMfgCode].InteriorColors[ai].ExteriorMfgColorCodeExtension);
                    }
                }
            }
        }
        else {
            sQsState = sQsState.replace("INTERIORCOLOR", "");
            sQsState = sQsState.replace("EXTCOLORCODE", "");
            sQsState = sQsState.replace("EXTCOLOREXT", "");
        }
        aSelOptions = oECM.GetCurrentlySelectedOptions(sModelId);
        if (aSelOptions != null) {
            sOpcodes = "";
            counter = 0;
            aOptionListwSortOrder = new Array();
            for (var i = 0; i < aSelOptions.length; i++) {
                //added check for Selected Type - 01/13/2009
                if (aSelOptions[i].SType == "Selected") {
                    aOptionListwSortOrder[counter] = { "OpCode": aSelOptions[i].OpCode, "SortOrder": aSelOptions[i].SelectedOrder };
                    counter += 1;
                }
            }

            aOptionListwSortOrder.sort(oECM.SortArray);
            for (var j = 0; j < aOptionListwSortOrder.length; j++) {
                if (aOptionListwSortOrder[j] != null) {
                    if (!(j == (aOptionListwSortOrder.length - 1))) {
                        sOpcodes += aOptionListwSortOrder[j].OpCode + ",";
                    }
                    else {
                        sOpcodes += aOptionListwSortOrder[j].OpCode;
                    }
                }
            }
            sQsState = sQsState.replace("OPTIONS", sOpcodes);
        }

        aSelFIFs = oECM.GetCurrentlySelectedFIFs(sModelId);
        if (aSelFIFs != null) {
            sFIFs = "";
            if (aSelFIFs.length > 0) {
                sFIFs = "";
                for (var k = 0; k < aSelFIFs.length; k++) {
                    if (!(k == (aSelFIFs.length - 1))) {
                        sFIFs += aSelFIFs[k].FIFId + ";" + aSelFIFs[k].FIFCategoryCd + ";" + aSelFIFs[k].FIFCode + ",";
                    }
                    else {
                        sFIFs += aSelFIFs[k].FIFId + ";" + aSelFIFs[k].FIFCategoryCd + ";" + aSelFIFs[k].FIFCode;
                    }
                }

            }
            sQsState = sQsState.replace("FIFS", sFIFs);
        }

        return sQsState;
    }
}

ECConfigurationManager.prototype.GetCurrentlySelectedFIFs = function (sModelId) {
    var oECM = new ECConfigurationManager();
    var aFIFs = new Array();
    var aSelectedFIFs = new Array();
    var oModel = oECM.GetModel(sModelId);
    aFIFs = oModel.ModelFIFList;
    if (aFIFs != null) {
        if (aFIFs.length > 0) {
            for (var i = 0; i < aFIFs.length; i++) {
                if (aFIFs[i].IsSelected) {
                    aSelectedFIFs.push(aFIFs[i]);
                }
            }
            return aSelectedFIFs;
        }
    }
}

ECConfigurationManager.prototype.RemoveModel = function (sModelId) {
    /// <summary>
    /// This method removes the passed in Model from the ModelList. 
    /// </summary>
    /// <param name="sModelId">ModelId of Model to be removed</param>
    /// <returns>True/False</returns>

    var oECM = new ECConfigurationManager();
    var aModels = oECM.ModelList;
    var returnFlag = false;
    if (aModels != null) {
        for (i = 0; i < aModels.length; i++) {
            if (aModels[i].ModelId == sModelId) {
                aModels.splice(i, 1);
                returnFlag = true;
                break;
            }
        }
    }
    return returnFlag;
}

ECConfigurationManager.prototype.GetCurrentlySelectedOptions = function (sModelId) {
    /// <summary>
    /// This method gets the currently selected options for the passed in Model
    /// </summary>
    /// <param name="sModelId">ModelId for which selected options are requested</param>
    /// <returns>Option objects or null if none are selected</returns>
    /// <exception>If no Model is present, returns errModel1000 - "Model doesn't exist" error</exception>
    /// <exception>If no OptionList is present, returns errOption2000 - "Model Options doesn't exist" error</exception>

    var oECM, oModel, aOptions, aSelOptions;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);
    try {
        if (oModel != null) {
            aSelOptions = new Array();
            aOptions = oModel.ModelOptionList;
            if (aOptions != null) {
                for (var i = 0; i < aOptions.length; i++) {
                    if (aOptions[i].IsSelected) {
                        aSelOptions.push(aOptions[i]);
                    }
                }
            }
            else {
                throw errOption2000;
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; aOptions = null; }

    return aSelOptions;
}

ECConfigurationManager.prototype.GetCurrentlyUnselectedOptions = function (sModelId) {
    /// <summary>
    /// This method gets the currently unselected options for the passed in Model
    /// </summary>
    /// <param name="sModelId">ModelId for which selected options are requested</param>
    /// <returns>Option objects or null if all are selected</returns>
    /// <exception>If no Model is present, returns errModel1000 - "Model doesn't exist" error</exception>
    /// <exception>If no OptionList is present, returns errOption2000 - "Model Options doesn't exist" error</exception>
    var oECM, oModel, aOptions, aUnselOptions;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);
    try {
        if (oModel != null) {
            aUnselOptions = new Array();
            aOptions = oModel.ModelOptionList;
            if (aOptions != null) {
                for (var i = 0; i < aOptions.length; i++) {
                    if (!aOptions[i].IsSelected) {
                        aUnselOptions.push(aOptions[i]);
                    }
                }
            }
            else {
                throw errOption2000;
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; aOptions = null; }

    return aUnselOptions;
}

ECConfigurationManager.prototype.GetSelectedExteriorColor = function (sModelId) {
    /// <summary>
    /// This method gets the currently selected exterior color for the passed in Model
    /// </summary>
    /// <param name="sModelId">ModelId for which selected exterior color is requested</param>
    /// <returns>Model Exterior ECColor object or null if no exterior color is selected.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oSelExtColor, oECM, oModel, oExtColors;

    try {
        oECM = new ECConfigurationManager();
        oModel = oECM.GetModel(sModelId);

        if (oModel != null) {

            oExtColors = oModel.ExteriorColors;
            for (var eCol = 0; eCol < oExtColors.length; eCol++) {
                if (oExtColors[eCol].IsSelected) {
                    oSelExtColor = oExtColors[eCol];
                    break;
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; }

    return oSelExtColor;
}

ECConfigurationManager.prototype.GetSelectedInteriorColor = function (sModelId) {
    /// <summary>
    /// This method gets the currently selected interior color for the passed in Model
    /// </summary>
    /// <param name="sModelId">ModelId for which selected interior color is requested</param>
    /// <returns>Model Interior ECColor object or null if no interior color is selected.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>

    var oSelIntColor, oModel, oIntColors;

    try {
        oModel = this.GetModel(sModelId);

        if (oModel != null) {
            oIntColors = oModel.InteriorColors;
            for (iCol = 0; iCol < oIntColors.length; iCol++) {
                if (oIntColors[iCol].IsSelected) {
                    oSelIntColor = oIntColors[iCol];
                    break;
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; }

    return oSelIntColor;
}

ECConfigurationManager.prototype.GetExteriorColors = function (sModelId) {
    /// <summary>
    /// This method gets all the exterior colors for the passed in Model
    /// </summary>
    /// <param name="sModelId">ModelId for which exterior colors is requested</param>
    /// <returns>Model Exterior ECColor objects or null if no exterior colors are present.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>

    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);

    try {
        if (oModel != null) {
            return oModel.ExteriorColors;
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; }
}

ECConfigurationManager.prototype.GetExteriorColorList = function (sModelId, sIntColCode) {
    /// <summary>
    /// This method gets all the exterior colors for the passed in interior color
    /// </summary>
    /// <param name="sModelId">ModelId for which exterior colors is requested</param>
    /// <param name="sIntColCode">Interior Color Code</param>
    /// <returns>Model Exterior ECColor objects or null if no exterior colors are present.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM, oModel, oExtColors, aExtColors, aIntColors;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);
    aExtColors = new Array();

    try {
        if (oModel != null) {
            oExtColors = oModel.ExteriorColors;
            for (var i = 0; i < oExtColors.length; i++) {
                aIntColors = oModel.ColorComboList[oExtColors[i].ColorMfgCode].InteriorColors;
                for (var j = 0; j < aIntColors.length; j++) {
                    if (aIntColors[j].ColorCode == sIntColCode) {
                        aExtColors.push(oExtColors[i]);
                    }
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oExtColors = null; aIntColors = null; }

    return aExtColors;
}

ECConfigurationManager.prototype.GetInteriorColors = function (sModelId) {
    /// <summary>
    /// This method gets all the interior colors for the passed in ModelId
    /// </summary>
    /// <param name="sModelId">ModelId for which interior colors is requested</param>
    /// <returns>Model Interior ECColor objects or null if no interior colors are present.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);

    try {
        if (oModel != null) {
            return oModel.InteriorColors;
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; }

}

ECConfigurationManager.prototype.GetInteriorColorList = function (sModelId, sExtColorCode) {
    /// <summary>
    /// This method gets all the interior colors for the passed in exterior color and Model
    /// </summary>
    /// <param name="sModelId">ModelId for which interior colors are requested</param>
    /// <param name="sExtColCode">Exterior Color Code</param>
    /// <returns>Model Interior ECColor objects or null if no interior colors are present.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>

    var oECM, oModel, aIntColors, oExtColors, aIntColorList;

    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);
    aIntColors = new Array();

    try {
        if (oModel != null) {
            oExtColors = oModel.ExteriorColors;

            for (var k = 0; k < oExtColors.length; k++) {
                if (oExtColors[k].ColorMfgCode == sExtColorCode) {
                    aIntColorList = oModel.ColorComboList[oExtColors[k].ColorMfgCode].InteriorColors;

                    for (j = 0; j < aIntColorList.length; j++) {
                        var color = oECM.GetColor(oModel, aIntColorList[j].ColorCode, "I");
                        if (color) {
                            aIntColors.push(color);
                        }
                    }
                    break;
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oExtColors = null; aIntColorList = null; }

    return aIntColors;
}

ECConfigurationManager.prototype.GetColor = function (oModel, sColCode, sColType) {
    /// <summary>
    /// This method returns a specific ECColor object based on the passed in color code and type
    /// </summary>
    /// <param name="sModelId">ModelId for which exterior/interior color is requested</param>
    /// <param name="sColCode">Mfg Color code for Exterior Color and Color Code for Interior Color</param>
    /// <returns>Model Exterior or Interior ECColor object or null if no colors match the color code and type passed in.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>

    var oExtColors, oIntColors;
    try {
        if (oModel != null) {
            if (sColType == "E") {
                oExtColors = oModel.ExteriorColors;
                for (var i = 0; i < oExtColors.length; i++) {
                    if (oExtColors[i].ColorMfgCode == sColCode) {
                        return oExtColors[i];
                    }
                }
            }
            else if (sColType == "I") {
                oIntColors = oModel.InteriorColors;
                for (var i = 0; i < oIntColors.length; i++) {
                    if (oIntColors[i].ColorCode == sColCode) {
                        return oIntColors[i];
                    }
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oExtColors = null; oIntColors = null; }
}

ECConfigurationManager.prototype.GetFIFCategories = function (sModelId) {
    /// <summary>
    /// This method gets all the FIF Categories for a given model id
    /// </summary>
    /// <param name="sModelId">ModelId for which FIF Categories are requested</param>
    /// <returns>Model FIFCategory objects or null if no FIF Categories are present.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);

    var oFIFCategories;
    try {
        if (oModel != null) {
            oFIFCategories = oModel.ModelFIFCategoryList;
            return oFIFCategories;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oFIFCategories = null; }
}

ECConfigurationManager.prototype.GetFIFCategoryById = function (sModelId, sFIFCategoryId) {
    /// <summary>
    /// This method gets FIFCategory for a given model id and fif category id
    /// </summary>
    /// <param name="sModelId">ModelId for which FIF Category is requested</param>
    /// <param name="sFIFCategoryId">FIF Category for which FIF Category is requested</param>
    /// <returns>FIFCategory object or null if no FIFCategory is found for a particular category</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);

    var oFIFs;
    try {
        if (oModel != null) {
            oFIFCategories = oModel.ModelFIFCategoryList;
            for (var i = 0; i < oFIFCategories.length; i++) {
                if (oFIFCategories[i].FIFCategoryId == sFIFCategoryId) {
                    return oFIFCategories[i];
                }
            }
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oFIFCategories = null; }
}

ECConfigurationManager.prototype.GetFIFCategoryByCode = function (sModelId, sFIFCategoryCd) {
    /// <summary>
    /// This method gets FIFCategory for a given model id and fif category id
    /// </summary>
    /// <param name="sModelId">ModelId for which FIF Category is requested</param>
    /// <param name="sFIFCategoryCd">FIF Category Code for which FIF Category is requested</param>
    /// <returns>FIFCategory object or null if no FIFCategory is found for a particular category</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);

    var oFIFs;
    try {
        if (oModel != null) {
            oFIFCategories = oModel.ModelFIFCategoryList;
            for (var i = 0; i < oFIFCategories.length; i++) {
                if (oFIFCategories[i].FIFCategoryCd == sFIFCategoryCd) {
                    return oFIFCategories[i];
                }
            }
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oFIFCategories = null; }
}

ECConfigurationManager.prototype.GetFIFsByCategory = function (sModelId, sFIFCategoryId) {
    /// <summary>
    /// This method gets all the FIFs for a given model id and fif category id
    /// </summary>
    /// <param name="sModelId">ModelId for which FIF are requested</param>
    /// <param name="sFIFCategoryId">FIF Category for which FIFs are requested</param>
    /// <returns>FIF objects or null if no FIFs in a particular category are present.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);

    var oFIFs = new Array();;
    try {
        if (oModel != null) {
            oFIFCategory = oECM.GetFIFCategoryById(sModelId, sFIFCategoryId);

            for (var i = 0; i < oFIFCategory.FIFs.length; i++) {
                var sFIFId = oFIFCategory.FIFs[i];

                var oFIF = oECM.GetFIFById(sModelId, sFIFId);

                if (oFIF != null) {
                    oFIFs.push(oFIF);
                }

            }
            return oFIFs;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oExtColors = null; oIntColors = null; }
}

ECConfigurationManager.prototype.GetFIFsByCategoryCode = function (sModelId, sFIFCategoryCd) {
    /// <summary>
    /// This method gets all the FIFs for a given model id and fif category id
    /// </summary>
    /// <param name="sModelId">ModelId for which FIF are requested</param>
    /// <param name="sFIFCategoryCd">FIF Category Code for which FIFs are requested</param>
    /// <returns>FIF objects or null if no FIFs in a particular category are present.</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);

    var oFIFs = new Array();;
    try {
        if (oModel != null) {
            oFIFCategory = oECM.GetFIFCategoryByCode(sModelId, sFIFCategoryCd);

            for (var i = 0; i < oFIFCategory.FIFs.length; i++) {
                var sFIFId = oFIFCategory.FIFs[i];

                var oFIF = oECM.GetFIFById(sModelId, sFIFId);

                if (oFIF != null) {
                    oFIFs.push(oFIF);
                }

            }
            return oFIFs;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oExtColors = null; oIntColors = null; oFIFCategory = null; oFIF = null; }
}

ECConfigurationManager.prototype.GetFIFById = function (sModelId, sFIFId) {

    /// <summary>
    /// This method gets FIF for a given model id and fif id
    /// </summary>
    /// <param name="sModelId">ModelId for which FIF Category is requested</param>
    /// <param name="sFIFId">FIFId for which FIF is requested</param>
    /// <returns>FIF object or null if no FIF is found for a particular fif id</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);

    var oFIFs;
    try {
        if (oModel != null) {
            oFIFs = oModel.ModelFIFList;
            for (var i = 0; i < oFIFs.length; i++) {

                if (oFIFs[i].FIFId == sFIFId) {
                    return oFIFs[i];
                }
            }
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; oFIFs = null; }
}

ECConfigurationManager.prototype.GetFIFs = function (sModelId) {

    /// <summary>
    /// This method returns all FIFs for passed in ModelId
    /// </summary>
    /// <param name="sModelId">ModelId for which FIFs are requested</param>
    /// <returns>FIFs array</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);

    var aFIFs = new Array();
    var aSelFIFs = new Array();

    try {
        if (oModel != null) {
            aFIFs = oModel.ModelFIFList;
            return aFIFs;
        }
    }
    catch (e) { throw e; }
    finally {
        oModel = null; aFIFs = null;
    }
}

ECConfigurationManager.prototype.GetCurrentlySelectedFIFs = function (sModelId) {

    /// <summary>
    /// This method returns the currently selected FIFs for passed in ModelId
    /// </summary>
    /// <param name="sModelId">ModelId for which FIF Category is requested</param>
    /// <returns>Selected FIFs array</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);

    var aFIFs = new Array();
    var aSelFIFs = new Array();

    try {
        if (oModel != null) {
            aFIFs = oModel.ModelFIFList;
            for (var i = 0; i < aFIFs.length; i++) {

                if (aFIFs[i].IsSelected) {
                    aSelFIFs.push(aFIFs[i]);
                }
            }
            return aSelFIFs;
        }
    }
    catch (e) { throw e; }
    finally {
        oModel = null; aFIFs = null;
        aSelFIFs = null;
    }
}

ECConfigurationManager.prototype.GetCurrentlyUnSelectedFIFs = function (sModelId) {

    /// <summary>
    /// This method returns the currently unselected FIFs for passed in ModelId
    /// </summary>
    /// <param name="sModelId">ModelId for which FIF Category is requested</param>
    /// <returns>Selected FIFs array</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);

    var aFIFs = new Array();
    var aUnSelFIFs = new Array();

    try {
        if (oModel != null) {
            aFIFs = oModel.ModelFIFList;
            for (var i = 0; i < aFIFs.length; i++) {

                if (!aFIFs[i].IsSelected) {
                    aUnSelFIFs.push(aFIFs[i]);
                }
            }
            return aUnSelFIFs;
        }
    }
    catch (e) { throw e; }
    finally {
        oModel = null; aFIFs = null;
        aUnSelFIFs = null;
    }
}

ECConfigurationManager.prototype.GetFIFsByaDisplayGroup = function (sModelId, sFIFDisplayGroup) {
    /// <summary>
    /// This method returns the ECFIF objects for the passed in ModelId and DisplayGroup
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose Options are requested</param>
    /// <param name="sFIFDisplayGroup">DisplayGroup Code for which FIFs are requested</param>
    /// <returns>Array of ECFIF object</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>
    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);
    var aFIFList = new Array();
    var aFIFUnsortedList = new Array();
    var aFIFListwSortOrder = new Array();
    var counter = 0;

    try {
        for (var i = 0; i < oModel.ModelFIFList.length; i++) {
            aDisplayGroups = oModel.ModelFIFList[i].FIFDisplayGroups;
            if (aDisplayGroups != null) {
                for (var j = 0; j < aDisplayGroups.length; j++) {
                    if (aDisplayGroups[j].DisplayGrpCd == sFIFDisplayGroup) {
                        aFIFUnsortedList[counter] = oModel.ModelFIFList[i];
                        aFIFListwSortOrder[counter] = { "FIFId": oModel.ModelFIFList[i].FIFId, "SortOrder": aDisplayGroups[j].FIFSortOrder };

                        counter++;
                    }
                }
            }
        }
        aFIFListwSortOrder.sort(oECM.SortArray);
        for (var k = 0; k < aFIFListwSortOrder.length; k++) {
            for (var l = 0; l < aFIFUnsortedList.length; l++) {
                if (aFIFListwSortOrder[k].FIFId == aFIFUnsortedList[l].FIFId) {
                    aFIFList[k] = aFIFUnsortedList[l];
                }
            }
        }
        return aFIFList;
    }
    catch (e) {
        throw e;
    }
    finally {
        oModel = null; aFIFListwSortOrder = null; aFIFUnsortedList = null;
    }
}

ECConfigurationManager.prototype.GetFIFsByDisplayGroup = function (sModelId, aFIFDisplayGroupList) {
    /// <summary>
    /// This method returns the ECFIF objects for the passed in ModelId and DisplayGroups
    /// </summary>
    /// <param name="sModelId">ModelId of the Model whose FIFs are requested</param>
    /// <param name="aOptionDisplayGroupList">Array of DisplayGroup Code for which FIFs are requested</param>
    /// <returns>Array of ECFIF object</returns>
    /// <exception>If no Model is present, returns "Model doesn't exist" error</exception>

    var oECM = new ECConfigurationManager();
    var oModel = oECM.GetModel(sModelId);
    var aFIFList = new Array();
    var counter = 0;

    try {
        if (oModel != null) {
            for (var k = 0; k < aFIFDisplayGroupList.length; k++) {
                for (var i = 0; i < oModel.ModelFIFList.length; i++) {
                    aDisplayGroups = oModel.ModelFIFList[i].FIFDisplayGroups;
                    if (aDisplayGroups != null) {
                        for (var j = 0; j < aDisplayGroups.length; j++) {
                            if (aDisplayGroups[j].DisplayGrpCd == aFIFDisplayGroupList[k]) {
                                aFIFList[counter] = oModel.ModelFIFList[i];
                                counter++;
                            }
                        }
                    }
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { oModel = null; }
    return aFIFList;
}

ECConfigurationManager.prototype.AddModels = function (aModels) {
    /// <summary>
    /// This method adds the passed in models to the ModelList array. 
    /// NOTE: If the Model already exist in the ModelList Array, it replaces the old Model in the 
    ///       ModelList Array with the new one.
    /// </summary>
    /// <param name="aModels">Array of models to be added</param>
    /// <returns>True/False</returns>
    /// <exception></exception>
    var oECM, aModelList, oModel, bAddModels;

    oECM = new ECConfigurationManager();
    bAddModels = false;

    try {
        if (aModels != null) {
            for (var i = 0; i < aModels.length; i++) {
                if (aModels[i] != null) {
                    oModel = oECM.GetModel(aModels[i].ModelId);
                    if (oModel != null) {
                        //If model already exists, remove it from the ModelList
                        oECM.ModelList.pop(oModel);
                        //Add the new model passed in to the ModelList
                        oECM.ModelList.push(aModels[i]);
                    }
                    else {
                        oECM.ModelList.push(aModels[i]);
                    }
                    bAddModels = true;
                }
            }

        }
    }
    catch (e) { throw e; }
    finally { }

    return bAddModels;
}

ECConfigurationManager.prototype.AddModelAssets = function (sModelId, aNewAssets) {
    /// <summary>
    /// This method compares the Assets in current Model against the new Assets passed 
    /// and adds any new Assets to the ModelAssetList.
    /// </summary>
    /// <param name="sModelId">Model currently in ModelList</param>
    /// <param name="aNewAssets">Assets Array</param>
    /// <returns>N/A</returns>
    /// <exception>If no Model exists, throws errModel1000 - "Model does not exist" error</exception> 
    var bAsset, aAddAssets, aAssets, oECM, oModel;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);

    try {
        if (oModel != null) {
            aAssets = oModel.ModelAssetList;
            if (aNewAssets != null) {
                if (aAssets != null) {
                    oECM.AddAdditionalArrayValues(aAssets, aNewAssets, "AssetId");
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { aAddAssets = null; aAssets = null; }
}

ECConfigurationManager.prototype.AddModelFIFs = function (sModelId, aNewFIFs) {
    /// <summary>
    /// This method compares the FIFs in current Model against the new FIFs passed 
    /// and adds any new FIFs to the ModelFIFList.
    /// </summary>
    /// <param name="sModelId">Model currently in ModelList</param>
    /// <param name="aNewFIFs">FIFs Array</param>
    /// <returns>N/A</returns>
    /// <exception>If no Model exists, throws errModel1000 - "Model does not exist" error</exception> 
    var bFIF, aAddFIFs, aFIFs, oECM, oModel, bFIFInCategory;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);

    try {
        if (oModel != null) {
            aFIFs = oModel.ModelFIFList;
            if (aNewFIFs != null) {
                if (aFIFs != null) {
                    oECM.AddAdditionalArrayValues(aFIFs, aNewFIFs, "FIFId");

                    //If added FIFs not in FIF Category, add them to a particular FIFCategory
                    for (var i = 0; i < aNewFIFs.length; i++) {
                        for (var j = 0; j < oModel.ModelFIFCategoryList.length; j++) {
                            if (oModel.ModelFIFCategoryList[j].FIFCategoryCd == aNewFIFs[i].FIFCategoryCd) {
                                bFIFInCategory = false;
                                for (var k = 0; k < oModel.ModelFIFCategoryList[j].FIFs.length; k++) {
                                    if (oModel.ModelFIFCategoryList[j].FIFs[k] == aNewFIFs[i].FIFId) {
                                        bFIFInCategory = true;
                                        break;
                                    }
                                }
                                if (!bFIFInCategory) {
                                    oModel.ModelFIFCategoryList[j].FIFs.push(aNewFIFs[i].FIFId);
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { aAddAssets = null; aAssets = null; }
}

ECConfigurationManager.prototype.AddModelTexts = function (sModelId, aNewTexts) {
    /// <summary>
    /// This method compares the Marketing Texts in current Model ag nainst the new Texts passed 
    /// and adds any new Marketing Texts to the ModelTextList.
    /// </summary>
    /// <param name="sModelId">Model currently in ModelList</param>
    /// <param name="aNewTexts">Marketing Texts Array</param>
    /// <returns>N/A</returns>
    /// <exception>If no Model exists, throws errModel1000 - "Model does not exist" error</exception> 
    var bText, aAddTexts, aTexts, oECM, oModel;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);

    try {
        if (oModel != null) {
            aTexts = oModel.ModelTextList;

            if (aNewTexts != null) {
                if (aTexts != null) {
                    oECM.AddAdditionalArrayValues(aTexts, aNewTexts, "TextIdent");
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { aAddTexts = null; aNewTexts = null; aTexts = null; }
}

ECConfigurationManager.prototype.AddModelAttributes = function (sModelId, aNewAttributes) {
    /// <summary>
    /// This method compares the Assets in current Model against the new Assets passed 
    /// and adds any new Assets to the ModelAssetList.
    /// </summary>
    /// <param name="sModelId">Model currently in ModelList</param>
    /// <param name="aNewAssets">Assets Array</param>
    /// <returns>N/A</returns>
    /// <exception>If no Model exists, throws errModel1000 - "Model does not exist" error</exception> 
    var bAttribute, aAddAttributes, aAttributes, oECM, oModel;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);

    try {
        if (oModel != null) {
            aAttributes = oModel.ModelAttributeList;
            if (aNewAttributes != null) {
                if (aAttributes != null) {
                    oECM.AddAdditionalArrayValues(aAttributes, aNewAttributes, "AttributeId");
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { aNewAttributes = null; aAttributes = null; }
}

ECConfigurationManager.prototype.AddModelCustomAttributes = function (sModelId, aNewCustomAttributes) {
    /// <summary>
    /// This method compares the Assets in current Model against the new Assets passed 
    /// and adds any new Assets to the ModelAssetList.
    /// </summary>
    /// <param name="sModelId">Model currently in ModelList</param>
    /// <param name="aNewAssets">Assets Array</param>
    /// <returns>N/A</returns>
    /// <exception>If no Model exists, throws errModel1000 - "Model does not exist" error</exception> 
    var bCustomAttribute, aAddCustomAttributes, aCustomAttributes, oECM, oModel;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);

    try {
        if (oModel != null) {
            aCustomAttributes = oModel.ModelCustomAttributeList;
            if (aNewCustomAttributes != null) {
                if (aCustomAttributes != null) {
                    oECM.AddAdditionalArrayValues(aCustomAttributes, aNewCustomAttributes, "CustAttrId");
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { aNewCustomAttributes = null; aCustomAttributes = null; }
}

ECConfigurationManager.prototype.AddModelFeatures = function (sModelId, aNewFeatures) {
    /// <summary>
    /// This method compares the Assets in current Model against the new Assets passed 
    /// and adds any new Assets to the ModelAssetList.
    /// </summary>
    /// <param name="sModelId">Model currently in ModelList</param>
    /// <param name="aNewAssets">Assets Array</param>
    /// <returns>N/A</returns>
    /// <exception>If no Model exists, throws errModel1000 - "Model does not exist" error</exception> 
    var bFeatures, aAddFeatures, aFeatures, oECM, oModel;
    oECM = new ECConfigurationManager();
    oModel = oECM.GetModel(sModelId);

    try {
        if (oModel != null) {
            aFeatures = oModel.ModelFeatureList;
            if (aNewFeatures != null) {
                if (aFeatures != null) {
                    oECM.AddAdditionalArrayValues(aFeatures, aNewFeatures, "FeatureCd");
                }
            }
        }
        else {
            throw errModel1000;
        }
    }
    catch (e) { throw e; }
    finally { aNewFeatures = null; aFeatures = null; }
}

ECConfigurationManager.prototype.AddOptionAssets = function (sModelId, sOpCode, aNewAssets) {
    /// <summary>
    /// This method compares the Assets in current Model against the new Assets passed 
    /// and adds any new Assets to the ModelAssetList.
    /// </summary>
    /// <param name="sModelId">Model currently in ModelList</param>
    /// <param name="aNewAssets">Assets Array</param>
    /// <returns>N/A</returns>
    /// <exception>If no Model exists, throws errModel1000 - "Model does not exist" error</exception> 
    var bAsset, aAddAssets, aAssets, oECM, oModel, oOption;
    oECM = new ECConfigurationManager();
    oOption = oECM.GetOption(sModelId, sOpCode);

    try {
        if (oOption != null) {
            aAssets = oOption.OptionAssetList;
            if (aNewAssets != null) {
                if (aAssets != null) {
                    oECM.AddAdditionalArrayValues(aAssets, aNewAssets, "AssetId");
                }
            }
        }
        else {
            throw errModel2001;
        }
    }
    catch (e) { throw e; }
    finally { aAddAssets = null; aAssets = null; }
}

ECConfigurationManager.prototype.AddFIFAssets = function (sModelId, sFIFId, aNewAssets) {
    /// <summary>
    /// This method compares the Assets in current Model against the new Assets passed 
    /// and adds any new Assets to the ModelAssetList.
    /// </summary>
    /// <param name="sModelId">Model currently in ModelList</param>
    /// <param name="sFIFId">FIF Id for which Assets need to be added</param>
    /// <param name="aNewAssets">Assets Array</param>
    /// <returns>N/A</returns>
    /// <exception>If no Model exists, throws errModel1000 - "Model does not exist" error</exception> 
    var bAsset, aAddAssets, aAssets, oECM, oModel, oFIF;
    oECM = new ECConfigurationManager();
    oFIF = oECM.GetFIFById(sModelId, sFIFId);

    try {
        if (oFIF != null) {
            aAssets = oFIF.FIFAssets;
            if (aNewAssets != null) {
                if (aAssets != null) {
                    oECM.AddAdditionalArrayValues(aAssets, aNewAssets, "AssetId");
                }
            }
        }
        else {
            throw errModel2001;
        }
    }
    catch (e) { throw e; }
    finally { aAddAssets = null; aAssets = null; }
}

ECConfigurationManager.prototype.AddOptionTexts = function (sModelId, sOpCode, aNewTexts) {
    /// <summary>
    /// This method compares the Marketing Texts in current Option against the new Texts passed 
    /// and adds any new Marketing Texts to the OptionTextList.
    /// </summary>
    /// <param name="sModelId">Model currently in ModelList</param>
    /// <param name="sOpCode">Opcode whose text are added</param>
    /// <param name="aNewTexts">Marketing Texts Array</param>
    /// <returns>N/A</returns>
    /// <exception>If no option exists, throws errModel2001 - "Option does not exist"</exception> 
    var bText, aAddTexts, aTexts, oECM, oOption;
    oECM = new ECConfigurationManager();
    oOption = oECM.GetOption(sModelId, sOpCode);

    try {
        if (oOption != null) {
            aTexts = oOption.OptionTextList;

            if (aNewTexts != null) {
                if (aTexts != null) {
                    oECM.AddAdditionalArrayValues(aTexts, aNewTexts, "TextId");
                }
            }
        }
        else {
            throw errModel2001;
        }
    }
    catch (e) { throw e; }
    finally { aAddTexts = null; aNewTexts = null; aTexts = null; }
}

ECConfigurationManager.prototype.AddFIFTexts = function (sModelId, sFIFId, aNewTexts) {
    /// <summary>
    /// This method compares the Marketing Texts in current Option against the new Texts passed 
    /// and adds any new Marketing Texts to the OptionTextList.
    /// </summary>
    /// <param name="sModelId">Model currently in ModelList</param>
    /// <param name="sFIFId">FIF whose text are added</param>
    /// <param name="aNewTexts">Marketing Texts Array</param>
    /// <returns>N/A</returns>
    /// <exception>If no FIF exists, throws errModel2001 - "Option does not exist"</exception> 
    var bText, aAddTexts, aTexts, oECM, oOption;
    oECM = new ECConfigurationManager();
    oOption = oECM.GetOption(sModelId, sOpCode);

    try {
        if (oOption != null) {
            aTexts = oOption.OptionTextList;

            if (aNewTexts != null) {
                if (aTexts != null) {
                    oECM.AddAdditionalArrayValues(aTexts, aNewTexts, "TextId");
                }
            }
        }
        else {
            throw errModel2001;
        }
    }
    catch (e) { throw e; }
    finally { aAddTexts = null; aNewTexts = null; aTexts = null; }
}

ECConfigurationManager.prototype.AddOptionCustomAttributes = function (sModelId, sOpCode, aNewCustomAttributes) {
    /// <summary>
    /// This method compares the Marketing Texts in current Option against the new Texts passed 
    /// and adds any new Marketing Texts to the OptionTextList.
    /// </summary>
    /// <param name="sModelId">Model currently in ModelList</param>
    /// <param name="sOpCode">Opcode whose text are added</param>
    /// <param name="aNewTexts">Marketing Texts Array</param>
    /// <returns>N/A</returns>
    /// <exception>If no option exists, throws errModel2001 - "Option does not exist"</exception> 
    var bCustomAttribute, aAddCustomAttributes, aCustomAttributes, oECM, oOption;
    oECM = new ECConfigurationManager();
    oOption = oECM.GetOption(sModelId, sOpCode);

    try {
        if (oOption != null) {
            aCustomAttributes = oOption.OptionCustomAttributeList;

            if (aNewCustomAttributes != null) {
                if (aCustomAttributes != null) {
                    oECM.AddAdditionalArrayValues(aCustomAttributes, aNewCustomAttributes, "CustAttrId");
                }
            }
        }
        else {
            throw errModel2001;
        }
    }
    catch (e) { throw e; }
    finally { aAddCustomAttributes = null; aNewCustomAttributes = null; aCustomAttributes = null; }
}

ECConfigurationManager.prototype.AddAdditionalArrayValues = function (aCurList, aNewList, sIdent) {
    /// <summary>
    /// This is a helper method that compares two arrays and adds the new items to the current array list.
    /// </summary>
    /// <param name="aCurList">Currently existing Array List</param>
    /// <param name="aNewList">New Array List</param>
    /// <param name="sIdent">Unique identifier to compare the two arrays</param>
    /// <returns>N/A</returns>
    /// <exception>None</exception> 
    var aAddNewValues, bFlag;
    aAddNewValues = new Array();

    try {
        for (var i = 0; i < aNewList.length; i++) {
            bFlag = false;
            for (var j = 0; j < aCurList.length; j++) {
                switch (sIdent) {
                    case "AssetId":
                        if (aNewList[i].AssetId == aCurList[j].AssetId) {
                            bFlag = true;
                            break;
                        }
                        break;
                    case "TextId":
                        if (aNewList[i].TextId == aCurList[j].TextId) {
                            bFlag = true;
                            break;
                        }
                        break;
                    case "AttributeId":
                        if (aNewList[i].AttributeId == aCurList[j].AttributeId) {
                            bFlag = true;
                            break;
                        }
                        break;
                    case "CustAttrId":
                        if (aNewList[i].CustAttrId == aCurList[j].CustAttrId) {
                            bFlag = true;
                            break;
                        }
                        break;
                    case "FeatureCd":
                        if (aNewList[i].FeatureCd == aCurList[j].FeatureCd) {
                            bFlag = true;
                            break;
                        }
                        break;
                    case "FIFId":
                        if (aNewList[i].FIFId == aCurList[j].FIFId) {
                            bFlag = true;
                            break;
                        }
                        break;
                    default:
                        break;
                }
                if (bFlag) break;
            }
            if (!bFlag) {
                aAddNewValues.push(aNewList[i]);
            }
        }

        if (aAddNewValues.length > 0) {
            for (var k = 0; k < aAddNewValues.length; k++) {
                aCurList.push(aAddNewValues[k]);
            }
        }
    }
    catch (e) { throw e; }
    finally { aAddNewValues = null; }
}

ECConfigurationManager.prototype.GetTotalSelectedOptionsPrice = function (sModelId) {
    /// <summary>
    /// This method calculates the total price of all selected options
    /// </summary>
    /// <param name="sModelId">Unique model identifier</param>
    /// <returns>N/A</returns>
    /// <exception>None</exception> 
    var aSelOptions, fTotalOptionsPrice, oECM;
    oECM = new ECConfigurationManager();

    aSelOptions = oECM.GetCurrentlySelectedOptions(sModelId);

    if (aSelOptions != null) {
        if (aSelOptions.length > 0) {
            fTotalOptionsPrice = 0;
            for (var i = 0; i < aSelOptions.length; i++) {
                if (aSelOptions[i].OptionType == "Required") {
                    fTotalOptionsPrice += parseFloat(aSelOptions[i].OptionPrice);
                }
            }
        }
    }
    return fTotalOptionsPrice;
}

ECConfigurationManager.prototype.GetFIFPrice = function (sModelId, oSelFIF) {
    var oECM = new ECConfigurationManager();
    var fifPrice = 0;
    var bFIFAvailable = false;
    if (oSelFIF != null) {
        var oSelExtColor = oECM.GetSelectedExteriorColor(sModelId);
        var oSelIntColor = oECM.GetSelectedInteriorColor(sModelId);
        for (var i = 0; i < oSelFIF.FIFColors.length; i++) {
            if (oSelFIF.FIFColors[i].ExteriorColorCode == oSelExtColor.ColorMfgCode) {
                for (var j = 0; j < oSelFIF.FIFColors[i].InteriorColors.length; j++) {
                    if (oSelFIF.FIFColors[i].InteriorColors[j].IntColorCd == oSelIntColor.ColorCode) {
                        bFIFAvailable = true;
                        fifPrice = oSelFIF.FIFColors[i].InteriorColors[j].FIFMSRP;
                        break;
                    }
                }
            }
            if (bFIFAvailable) {
                break;
            }
        }
        return fifPrice;
    }
}

ECConfigurationManager.prototype.GetTotalSelectedDealerOptionsPrice = function (sModelId) {
    /// <summary>
    /// This method calculates the total dealer price of all selected options
    /// </summary>
    /// <param name="sModelId">Unique model identifier</param>
    /// <returns>N/A</returns>
    /// <exception>None</exception> 
    var aSelOptions, fTotalOptionsPrice, oECM;
    oECM = new ECConfigurationManager();

    aSelOptions = oECM.GetCurrentlySelectedOptions(sModelId);

    if (aSelOptions != null) {
        if (aSelOptions.length > 0) {
            fTotalOptionsPrice = 0;
            for (var i = 0; i < aSelOptions.length; i++) {
                if (aSelOptions[i].OptionType == "Required") {
                    fTotalOptionsPrice += parseFloat(aSelOptions[i].DealerOptionPrice);
                }
            }
        }
    }
    return fTotalOptionsPrice;
}


/************************************* Private ECRulesEngine Class **************************************************/
function ECRulesEngine() {

    this.ValidateConfiguration = function (sModelId, sExtColSel, sIntColSel, sOpCodeSel, sFIFIdSel, bAutoApproveChanges, sExclusivelySelectedFIFs) {
        /// <summary>
        /// This method contains the logic for validating a configuration for Model color and option rules. 
        /// 
        /// The sOpCodeSel is optional and is needed when verifying Options selected in the configuration.
        /// The Validation Rules will be processed as follows
        /// 1. If Exterior Color is not passed in, the state is checked to see if the color is already selected.
        ///    If no color is selected, first exterior color in the array will be selected as default. If
        ///    exteriorcolors array is empty, exception errColor3000 is thrown. If wrong exterior color is passed,
        ///    ModelColorConflict is created for that color.
        /// 2. If Interior Color is not passed in, the state is checked to see if the color is already selected.
        ///    If no color is selected, first interior color in the array for the selected exterior color will be 
        ///    selected as default. If interiorcolors array is empty, exception errColor3001 is thrown. If wrong 
        ///    interior color is passed, ModelColorConflict is created for that color.
        /// 3. If both Exterior/Interior Color are passed, Exterior/Interior color combination is verified and any conflicts are
        ///    returned as Model Color Conflicts.
        /// 4. If OpCode is passed in, Process Model Option Rules method is called which processes the Exclude, Required, Include and 
        ///    package rules. It also processes the Option Color Conflict rules for the selected color.
        /// 5. If OpCode is not passed in, Process Option Color Conflict method is called to make sure previously selected accessories
        ///    doesn't conflict with currently passed in colors.
        /// </summary>
        /// <param name="sModelId">ModelId of Model on which configuration Rules are executed</param>
        /// <param name="sExtColSel">Exterior Color of passed in Model</param>
        /// <param name="sIntColSel">Interior Color of passed in Model</param>
        /// <param name="sOpCodeSel">OpCode for which rules are validated</param>
        /// <param name="sFIFIdSel">FIFIdent for which rules are validated</param>
        /// <param name="bAutoApproveChanges">       
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If not, the conflicts are resolved and the user can get the new state.
        ///</param>
        ///<param name="sExclusivelySelectedFIFs">This will be comma seperated list of FIFIds that are part of ExclusivelyRequiredFIFs and selected by User</param>
        /// <returns>ECRulesEngineQueryResult object with passedValidation flag and any conflicts</returns>
        /// <exception>If ModelId is not passed, throws "No ModelId Passed".</exception> 
        /// <exception>If ModelId passed is not in ConfigurationEngine, throws "Passed in Model not in Configuration".</exception> 
        try {
            if (sModelId != null) {
                var oECM = new ECConfigurationManager();
                var oQueryResult = new ECRulesEngineQueryResult();
                var oModel = oECM.GetModel(sModelId);
                var bExtColor = false;
                var bIntColor = false;
                var bValidExtIntColor = false;
                var oExtColSel, oIntColSel, oCurExtColSel, oCurIntColSel, aIntColors;

                if (oModel != null) {
                    //Check if Exterior Color Exists
                    if (sExtColSel == null || sExtColSel == "") {
                        oCurExtColSel = oECM.GetSelectedExteriorColor(sModelId);
                        if (oCurExtColSel != null) {
                            sExtColSel = oCurExtColSel.ColorMfgCode;
                        }
                        else {
                            if (oModel.ExteriorColors.length > 0) {
                                //Selecting default color in the list
                                sExtColSel = oModel.ExteriorColors[0].ColorMfgCode;
                                oModel.ExteriorColors[0].IsSelected = true;   //TODO: ADD 
                            }
                            else {
                                // No Exterior colors for this model
                                throw errColor3000;
                            }
                        }
                    }
                    else if (sExtColSel == "None") {
                        oCurExtColSel = oECM.GetSelectedExteriorColor(sModelId);
                        if (oCurExtColSel != null) {
                            oCurExtColSel.IsSelected = false;
                        }
                    }
                    //else
                    //{
                    //check if the Exterior color is valid
                    oExtColSel = oECM.GetColor(oModel, sExtColSel, "E");
                    if (oExtColSel != null) {
                        bExtColor = true;
                        oCurExtColSel = oECM.GetSelectedExteriorColor(sModelId);
                        if (oCurExtColSel != null) {
                            oCurExtColSel.IsSelected = false;
                        }
                        oExtColSel.IsSelected = true;
                    }
                    else {
                        this.PopulateModelColorConflict(oModel, oQueryResult, sExtColSel, "E", "None", "E");
                    }
                    //}

                    //Check if Interior Color Exists
                    if (sIntColSel == null || sIntColSel == "") {
                        oCurIntColSel = oECM.GetSelectedInteriorColor(sModelId);
                        if (oCurIntColSel != null) {
                            sIntColSel = oCurIntColSel.ColorCode;
                        }
                        else {
                            if (oModel.InteriorColors.length > 0) {
                                aIntColors = oECM.GetInteriorColorList(sModelId, sExtColSel);
                                sIntColSel = aIntColors[0].ColorCode;
                                aIntColors[0].IsSelected = true;   //TODO: ADD
                            }
                            else {
                                throw errColor3001; // No Interior colors for this model
                            }
                        }
                    }
                    else if (sIntColSel == "None") {
                        //If Color passed is "None" then the state of the colors is cleared
                        oCurIntColSel = oECM.GetSelectedInteriorColor(sModelId);
                        if (oCurIntColSel != null) {
                            oCurIntColSel.IsSelected = false;
                        }
                    }
                    //else
                    //{
                    //check if the Interior color is valid for this Model
                    oIntColSel = oECM.GetColor(oModel, sIntColSel, "I");
                    if (oIntColSel != null) {
                        bIntColor = true;
                        oCurIntColSel = oECM.GetSelectedInteriorColor(sModelId);
                        if (oCurIntColSel != null) {
                            oCurIntColSel.IsSelected = false;
                        }
                        oIntColSel.IsSelected = true;
                    }
                    else {
                        this.PopulateModelColorConflict(oModel, oQueryResult, sIntColSel, "I", "None", "I");
                    }
                    //}

                    if (bExtColor && bIntColor) {
                        //Validate if the Ext/Int Color Combination is valid or not
                        var aIntColors = oModel.ColorComboList[sExtColSel].InteriorColors;

                        for (var j = 0; j < aIntColors.length; j++) {
                            if (aIntColors[j].ColorCode == oIntColSel.ColorCode) {
                                bValidExtIntColor = true;
                                oExtColSel.IsSelected = true;
                                oIntColSel.IsSelected = true;
                                break;
                            }
                        }

                        if (!bValidExtIntColor) {
                            oIntColSel.IsSelected = false;
                            this.PopulateModelColorConflict(oModel, oQueryResult, oExtColSel.ColorMfgCode, oExtColSel.ColorType, oIntColSel.ColorCode, oIntColSel.ColorType);
                        }
                    }

                    if (bValidExtIntColor) {
                        if (!(sOpCodeSel == null || sOpCodeSel == "")) {
                            this.ProcessModelOptionRules(sModelId, oQueryResult, sOpCodeSel, bAutoApproveChanges);
                        }
                        else {
                            var aOptions = oModel.ModelOptionList;
                            if (aOptions != null) {
                                for (var z = 0; z < aOptions.length; z++) {
                                    if (aOptions[z].IsSelected) {
                                        this.ProcessOptionColorRules(sModelId, aOptions[z], oECM, oQueryResult, bAutoApproveChanges);
                                    }
                                }
                            }
                        }

                        if (!(sFIFIdSel == null || sFIFIdSel == "")) {
                            this.ProcessModelFIFRules(sModelId, oQueryResult, sFIFIdSel, bAutoApproveChanges, sExclusivelySelectedFIFs);
                        }
                        else {
                            //If State already has the FIFs, then process the ModelFIFRules for those FIFs
                            var aSelectedFIFs = oECM.GetCurrentlySelectedFIFs(sModelId);
                            if (aSelectedFIFs != null) {
                                if (aSelectedFIFs.length > 0) {
                                    for (var m = 0; m < aSelectedFIFs.length; m++) {
                                        this.ProcessModelFIFRules(sModelId, oQueryResult, aSelectedFIFs[m].FIFId, bAutoApproveChanges, "");
                                    }
                                }
                                else {
                                    //Else the state is empty. Select Default FIFs for the selected Exterior/Interior Color

                                    //Process FIF Rules for each of the categories
                                    //need to think how you are going to do this..either looping over here or if empty id is passed, check in
                                    //processmodelfifrules
                                    //Create a method for setting the defaults for each of the categories. This method will also make a call to
                                    //process rules on each of the fif defaults that have been selected by the user.
                                    this.ProcessDefaultFIFs(sModelId, oQueryResult, bAutoApproveChanges);
                                }
                            }
                        }

                        //TODO: Add FIF Pacakge Rules over here for Carbon Package
                        //1. Identify based on selection if Package FIFs are selected
                        //2. If selected, based on bAutoApproveChanges, add to oQueryResult or select it.
                        //3. Add property to each of the FIFs that it is included in package
                        //4. If the package is not selected, set IsIncludedInPackage flag to false
                        this.CheckFIFPackageIsEnabled(sModelId, oQueryResult, bAutoApproveChanges);

                        //Calculate the Price
                        this.CalculatePrice(sModelId, oECM);
                    }


                    //Update Passed Validation flag
                    this.UpdateValidationStatus(oQueryResult);
                }
                else {
                    throw errModel1001;
                }
            }
            else {
                throw errModel1003;
            }
        }
        catch (e) { throw e; }
        finally {
            oModel = null; oExtColSel = null; oIntColSel = null; oCurExtColSel = null; oCurIntColSel = null; aIntColors = null;
        }
        return oQueryResult;
    }

    this.CheckFIFPackageIsEnabled = function (sModelId, oQueryResult, bAutoApproveChanges) {
        if (sModelId != null) {
            var oECM = new ECConfigurationManager();
            var oQueryResult = new ECRulesEngineQueryResult();
            var oModel = oECM.GetModel(sModelId);

            for (var s = 0; s < oModel.ModelFIFCategoryList.length; s++) {
                if (oModel.ModelFIFCategoryList[s].FIFCategoryCd == "L") {
                    var aFIFs = oModel.ModelFIFCategoryList[s].FIFs;
                    var allFIFSelected = 0;
                    for (var t = 0; t < aFIFs.length; t++) {
                        //console.log(aFIFs[t]);

                        for (var u = 0; u < oModel.ModelFIFList.length; u++) {
                            if (aFIFs[t] == oModel.ModelFIFList[u].FIFId) {
                                //console.log(aFIFs[t]);
                                if (oModel.ModelFIFList[u].FIFRules != undefined) {
                                    //console.log("FIFRules" + oModel.ModelFIFList[u].FIFRules);
                                    if (oModel.ModelFIFList[u].FIFRules.FIFToFIFRules != undefined) {
                                        //console.log("FIFToFIFRules" + oModel.ModelFIFList[u].FIFRules.FIFToFIFRules);
                                        if (oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules != undefined) {
                                            //alert(oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequiredRules);
                                            //console.log("RequiredRules.length:" + oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules.length);
                                            var totallength = oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules.length;
                                            var aIncludedInPackage = new Array();
                                            //console.log("Included in package.length:" + aIncludedInPackage.length);
                                            //Reset IsIncludedInPackage
                                            for (var v1 = 0; v1 < oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules.length; v1++) {
                                                for (var y1 = 0; y1 < oModel.ModelFIFList.length; y1++) {
                                                    if (oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules[v1].FIFId == oModel.ModelFIFList[y1].FIFId) {
                                                        if (!oModel.ModelFIFList[y1].IsSelected) {
                                                            //   //console.log("Included in Package Set to false" + oModel.ModelFIFList[y1].FIFId)
                                                            oModel.ModelFIFList[y1].IsIncludedInPackage = false;
                                                        }
                                                    }
                                                }
                                            }
                                            allFIFSelected = 0;
                                            for (var v = 0; v < oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules.length; v++) {
                                                var iRequiredFIFId = oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules[v].FIFId;

                                                for (var w = 0; w < oModel.ModelFIFList.length; w++) {
                                                    if (iRequiredFIFId == oModel.ModelFIFList[w].FIFId) {

                                                        if (oModel.ModelFIFList[w].IsSelected) {
                                                            //console.log(oModel.ModelFIFList[w].FIFName);
                                                            allFIFSelected = allFIFSelected + 1;
                                                        }
                                                    }
                                                }
                                                //console.log("for counter:" + v)
                                                //console.log("Required rules length:" + oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules.length);
                                                if (v == oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules.length - 1) {
                                                    //console.log("in v=requiredruleslength");
                                                    //console.log("allFIFSelected" + allFIFSelected);
                                                    //console.log("totallength" + totallength);
                                                    if (allFIFSelected == totallength) {
                                                        //Select the package FIF
                                                        this.ProcessModelFIFRules(sModelId, oQueryResult, oModel.ModelFIFList[u].FIFId, bAutoApproveChanges, "");
                                                        //For all selected FIFs, add IsIncludedInPackage
                                                        for (var x = 0; x < oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules.length; x++) {

                                                            var iRequiredFIFId = oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules[x].FIFId;
                                                            var oSelFIF = oECM.GetFIFById(sModelId, iRequiredFIFId);
                                                            //console.log(oSelFIF.FIFId + "--" + oSelFIF.FIFDesc);
                                                            //console.log(oSelFIF.FIFId + "--" + oSelFIF.IsSelected);
                                                            //console.log(oSelFIF.FIFId + "--" + oSelFIF.IsIncludedInPackage);
                                                            if (oSelFIF.IsSelected) {
                                                                oSelFIF.IsIncludedInPackage = true;
                                                                aIncludedInPackage[aIncludedInPackage.length] = oSelFIF.FIFId;
                                                            }
                                                            //console.log(iRequiredFIFId + oSelFIF);
                                                        }

                                                        for (var a1 = 0; a1 < aIncludedInPackage.length; a1++) {
                                                            //console.log(oModel.ModelFIFList[u].FIFDesc + "--" + oModel.ModelFIFList[u].FIFId + "-->" + aIncludedInPackage[a1]);
                                                        }
                                                        //Uncheck the FIFs that are not included in the package

                                                        for (var y = 0; y < oModel.ModelFIFList.length; y++) {
                                                            var bIncludedInPackage = false;
                                                            for (var z = 0; z < oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules.length; z++) {
                                                                if (oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequireRules[z].FIFId == oModel.ModelFIFList[y].FIFId) {
                                                                    //console.log(oModel.ModelFIFList[y].FIFId);
                                                                    //console.log(oModel.ModelFIFList[y].IsSelected);
                                                                    if (oModel.ModelFIFList[y].IsSelected) {
                                                                        bIncludedInPackage = true;
                                                                    }
                                                                }
                                                            }
                                                            for (var ip = 0; ip < aIncludedInPackage.length; ip++) {
                                                                if (aIncludedInPackage[ip] == oModel.ModelFIFList[y].FIFId) {
                                                                    //console.log("FIF part of package" + oModel.ModelFIFList[y].FIFId);

                                                                    oModel.ModelFIFList[y].IsIncludedInPackage = true;
                                                                    bIncludedInPackage = true;
                                                                }
                                                            }
                                                            if (!bIncludedInPackage) {
                                                                if (!oModel.ModelFIFList[y].IsSelected) {
                                                                    //console.log("Not in package" + oModel.ModelFIFList[y].FIFId);
                                                                    oModel.ModelFIFList[y].IsIncludedInPackage = false;
                                                                }
                                                            }

                                                        }

                                                        //console.log(allFIFSelected);
                                                    }
                                                    /*else
                                                    {
                                                        var resetNotInPackagelist = false;
                                                        for (var w1 = 0; w1 < oModel.ModelFIFList.length; w1++) {
                                                            if (iRequiredFIFId == oModel.ModelFIFList[w1].FIFId) {
                                                                //console.log("Required FIF:" + iRequiredFIFId);
                                                                //console.log("length of included items:" + aIncludedInPackage.length)
                                                                for(var w2=0; w2 < aIncludedInPackage.length; w2++)
                                                                {
                                                                    if(iRequiredFIFId == aIncludedInPackage[w2])
                                                                    {
                                                                        resetNotInPackagelist = true;
                                                                    }
                                                                }
                                                                if(!resetNotInPackagelist)
                                                                {
                                                                    oModel.ModelFIFList[w1].IsIncludedInPackage = false;
                                                                }
                                                            }
                                                        }
                                                    }*/
                                                }
                                            }
                                        }
                                    }
                                }


                            }
                        }

                    }
                    for (var u1 = 0; u1 < oModel.ModelFIFList.length; u1++) {
                        if (oModel.ModelFIFList[u1].IsSelected) {
                            //console.log(oModel.ModelFIFList[u1].FIFId + "is included in package" + oModel.ModelFIFList[u1].IsIncludedInPackage)
                        }
                    }
                    /*if (allFIFSelected == oModel.ModelFIFList[u].FIFRules.FIFToFIFRules.RequiredRules.length) {
                        alert("all fif selected");
                    }*/
                }
            }

            /*for (var s1 = 0; s1 < oModel.ModelFIFList.length; s1++) {
                if (oModel.ModelFIFList[s1].IsIncludedInPackage) {
                    console.log(oModel.ModelFIFList[s1].FIFId + "--" + oModel.ModelFIFList[s1].IsIncludedInPackage);
                }
            }*/
        }
    }
    this.UpdateValidationStatus = function (oQueryResult) {
        if (oQueryResult.RequiredOptions.length > 0 || oQueryResult.IncludedOptions.length > 0 || oQueryResult.ExcludedOptions.length > 0 || oQueryResult.OptionColorConflicts.length > 0 || oQueryResult.ModelColorConflicts.length > 0
            || oQueryResult.RequiredFIFs.length > 0 || oQueryResult.ExcludedFIFs.length > 0 || oQueryResult.ExclusivelyRequiredFIFs.length > 0 || oQueryResult.FIFColorConflicts.length > 0) {
            oQueryResult.PassedValidation = false;
        }
        else {
            oQueryResult.PassedValidation = true;
        }
    }

    this.PopulateModelColorConflict = function (oModel, oQueryResult, curSelColCode, curSelColType, conColCode, conColType) {
        /// <summary>
        /// This is a helper method that populates the Model Color Conflict object.
        /// </summary>
        /// <param name="oModel">Model object for which Color Conflict is populated</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object in which ModelColorConflict Array resides</param>
        /// <param name="curSelColCode">Selected Color Code(can be Exterior/Interior)</param>
        /// <param name="curSelColType">Type of selected color</param>
        /// <param name="conColCode">Conflicting Color Code</param>
        /// <param name="conColType">Conflicting Color Type</param>
        /// <returns>None</returns>
        /// <exception>If any error occurs while populating the conflict, throws "Error populating Model Color Conflict"</exception>
        var oMCC = new ECModelColorConflict();
        try {
            oMCC.CurrentlySelectedColorCode = curSelColCode;
            oMCC.CurrentlySelectedColorType = curSelColType;
            oMCC.ConflictingColorCode = conColCode;
            oMCC.ConflictingColorType = conColType;
            oMCC.ModelId = oModel.ModelId;
            oQueryResult.PassedValidation = false;
            oQueryResult.ModelColorConflicts.push(oMCC);
        }
        catch (e) { throw errColor3002; }
    }

    this.ProcessDefaultFIFs = function (sModelId, oQueryResult, bAutoApproveChanges) {
        /// <summary>
        /// This method is called by the ValidateConfiguration method and processes the default FIFs in a particular category
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model FIF Default Rules"</exception>
        try {
            var oECM, oModel, oSelExteriorColor, oSelInteriorColor;

            oECM = new ECConfigurationManager();
            oModel = oECM.GetModel(sModelId);
            oSelExteriorColor = oECM.GetSelectedExteriorColor(sModelId);
            oSelInteriorColor = oECM.GetSelectedInteriorColor(sModelId);

            aFIFCategoryList = oModel.ModelFIFCategoryList;

            //Loop through all the category list and select defaults. Then Process Model FIF Rules to make sure there are no conflicts.
            for (var k = 0; k < aFIFCategoryList.length; k++) {

                var aFIFsForCategory = oECM.GetFIFsByCategory(sModelId, aFIFCategoryList[k].FIFCategoryId);
                var colorMatched = false;
                if (aFIFsForCategory != null) {
                    //For each FIFs in a FIF Category check if the color matchs the exterior and interior color that is selected, 
                    //If the color matches and it has a default set, set the default on the FIF for ease of use.
                    for (var l = 0; l < aFIFsForCategory.length; l++) {

                        var aFIFColors = aFIFsForCategory[l].FIFColors;

                        for (var m = 0; m < aFIFColors.length; m++) {

                            if (aFIFColors[m].ExteriorColorCode == oSelExteriorColor.ColorMfgCode) {
                                for (var n = 0; n < aFIFColors[m].InteriorColors.length; n++) {
                                    if (aFIFColors[m].InteriorColors[n].IntColorCd == oSelInteriorColor.ColorCode) {
                                        //Point where the backend code changes from true to y and vice versa :)
                                        if (aFIFColors[m].InteriorColors[n].IsDefault.toLowerCase() == "y") {
                                            aFIFsForCategory[l].IsDefault = true;
                                            aFIFsForCategory[l].IsSelected = true;
                                            colorMatched = true;
                                            break;
                                        }
                                    }
                                }
                                if (colorMatched) {
                                    break; //breaks out of FIF Colors
                                }
                            }
                        }
                        if (colorMatched) {
                            break; //since we already found the FIF in a particular color for that FIF Category, we are no longer looking in that category
                        }

                    }
                    //If the color matched FIF is not found as default, we need to select the one which is not set as default
                    if (!colorMatched) {
                        for (var l = 0; l < aFIFsForCategory.length; l++) {

                            var aFIFColors = aFIFsForCategory[l].FIFColors;

                            for (var m = 0; m < aFIFColors.length; m++) {

                                if (aFIFColors[m].ExteriorColorCode == oSelExteriorColor.ColorMfgCode) {
                                    for (var n = 0; n < aFIFColors[m].InteriorColors.length; n++) {
                                        if (aFIFColors[m].InteriorColors[n].IntColorCd == oSelInteriorColor.ColorCode) {
                                            //Point where the backend code changes from true to y and vice versa :)
                                            if (aFIFColors[m].InteriorColors[n].IsDefault.toLowerCase() == "n") {
                                                aFIFsForCategory[l].IsDefault = false;
                                                aFIFsForCategory[l].IsSelected = true;
                                                colorMatched = true;
                                                break;
                                            }
                                        }
                                    }
                                    if (colorMatched) {
                                        break; //breaks out of FIF Colors
                                    }
                                }
                            }
                            if (colorMatched) {
                                break; //since we already found the FIF in a particular color for that FIF Category, we are no longer looking in that category
                            }

                        }
                    }
                }
            }

            for (var k = 0; k < aFIFCategoryList.length; k++) {

                var aFIFsForCategory = oECM.GetFIFsByCategory(sModelId, aFIFCategoryList[k].FIFCategoryId);

                if (aFIFsForCategory != null) {
                    //For each FIF set as default in a particular category, check the rules on it to make sure it doesn't conflict 
                    //with the 
                    for (var l = 0; l < aFIFsForCategory.length; l++) {
                        if (aFIFsForCategory[l].IsDefault == true) {
                            this.ProcessModelFIFRules(sModelId, oQueryResult, aFIFsForCategory[l].FIFId, bAutoApproveChanges);
                        }
                    }
                }
            }

        }
        catch (e) {
            throw e + " In method ProcessDefaultFIFs";
        }
        finally {
        }
    }

    this.ProcessModelFIFRules = function (sModelId, oQueryResult, sFIFIdSel, bAutoApproveChanges, sExclusivelySelectedFIFs) {
        /// <summary>
        /// This method is called by the ValidateConfiguration method and processes the Model Option Rules
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="sSelOpCode">Selected OpCode which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        ///<param name="sExclusivelySelectedFIFs">This will be comma seperated list of FIFIds that are part of ExclusivelyRequiredFIFs and selected by User</param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model Option Rules"</exception>
        var oECM, oSelFIF;
        var bFIFAvailable = false;
        oECM = new ECConfigurationManager();
        oQueryResult.currentFIF = sFIFIdSel;

        if (oECM.AutoApproveChanges) { bAutoApproveChanges = true; }

        try {
            oSelFIF = oECM.GetFIFById(sModelId, sFIFIdSel);



            if (oSelFIF != null) {
                //Check if the FIF is available in the color selected
                bFIFAvailable = this.CheckFIFAvailableInSelectedColor(sModelId, oSelFIF);

                if (!bFIFAvailable) {
                    oQueryResult.FIFColorConflicts.push(oSelFIF);
                }
            }



            if (!oSelFIF.IsSelected) {
                oSelFIF.SType = "Selected";

                //Process Required Rules
                //a. Determine if a FIF requires a FIFSet or an FIF 
                //   a1. If the FIF requires a FIFSet which is going to be the case most of the time
                //       a11. Process FIFSet
                //       a12. Process any excludes based on the FIF selected.
                //       a13. Based on the excludes from the FIFSet, select the default in that category that needs to be added in the Required List.
                this.ProcessRequiredFIFList(sModelId, oQueryResult, oSelFIF, bAutoApproveChanges, sExclusivelySelectedFIFs);

                //Process Exclude Rules
                //a. Process Excludes within the FIF's category.
                //   a1. Process Excludes for all FIFs in a category that excludes other FIFs
                //   a2. If a particular category has an exclude, select the default in that category that needs to be added in the Required List.
                //b. Process Excludes if FIF's exclude FIF in other category.
                //   b1. If a particular category has an exclude, select the default in that category that needs to be added in the Required List.
                this.ProcessExcludeFIFList(sModelId, oQueryResult, oSelFIF, bAutoApproveChanges);


                //If bAutoApproveChanges is set to true
                if (bAutoApproveChanges) {
                    SelectedFIFOrderCounter += 1;
                    oSelFIF.SelectedOrder = SelectedFIFOrderCounter;
                    oSelFIF.IsSelected = true;
                }
            }


        }
        catch (e) {
            throw e + " In method RulesEngine.ProcessModelFIFRules";
        }
        finally { }
    }

    this.ProcessExcludeOptionsForFIF = function (sModelId, oQueryResult, oSelFIF, bAutoApproveChanges, aExcludedFIFs) {
        try {


            var oECM = new ECConfigurationManager();
            //Check if the selected FIF excludes any accessory
            var aExcludedOptions = oSelFIF.FIFRules.FIFToOptionRules.ExcludeRules;
            if (aExcludedOptions != null) {
                if (aExcludedOptions.length > 0) {
                    for (var i = 0; i < aExcludedOptions.length; i++) {
                        var oOption = oECM.GetOption(sModelId, aExcludedOptions[i]);
                        if (oOption != null) {
                            if (oOption.IsSelected) {
                                //This scenario allows unselecting any options that are included in a package
                                this.ProcessIncludeByListToUnselect(sModelId, oOption, oECM, oQueryResult, bAutoApproveChanges);

                                if (!bAutoApproveChanges) {
                                    if (!this.CheckOptionsListInQueryResult("Excluded", oOption, oQueryResult)) {
                                        oQueryResult.ExcludedOptions.push(oOption);
                                    }
                                    //TODO:
                                    //Check if this option is required by anything else. If so, that option needs to be excluded as well
                                }
                                else {
                                    oOption.IsSelected = false;
                                    oOption.SelectedOrder = null;
                                }

                                //If this excluded option has a required list, process required list to unselect option
                                var optionType = "Required";
                                //TODO:
                                //1. Option requires some other options or FIFs, then excluded those
                                //this.ProcessRequiredListToUnselectOption(sModelId, oQueryResult, oOption, oSelFIF, bAutoApproveChanges, optionType);

                                //2. Option is required by some other options, then exclude those (FIF cannot require an Option)

                                //3. Option is included by some other options, then excluded those (FIF cannot include an Option)

                                //this.ProcessRequiredListToUnselect(sModelId, oExOption, oSelOption, oECM, oQueryResult, bAutoApproveChanges, optionType);
                                //this.ProcessIncludeListToUnselect(sModelId, oExOption, oECM, oQueryResult, bAutoApproveChanges, optionType, oSelOption);
                                //this.ProcessRequiredByListToUnselectOptions(sModelId, oExOption, oSelOption, oECM, oQueryResult, bAutoApproveChanges);

                            }
                        }
                    }
                }
            }
            /*
                        if (!bAutoApproveChanges) {
                            for (var j = 0; j < oQueryResult.ExcludedFIFs.length; j++) {
            
                                //Process Exclude Rules for Options
                                this.ProcessExcludeOptionsForFIF(sModelId, oQueryResult, oQueryResult.ExcludedFIFs[j], bAutoApproveChanges);
            
                            }
                        }
                        else {
                            if (aExcludedFIFs != null) {
                                for (var k = 0; k < aExcludedFIFs.length; k++) {
            
                                    //Process Exclude Rules for Options
                                    this.ProcessExcludeOptionsForFIF(sModelId, oQueryResult, aExcludedFIFs[k], bAutoApproveChanges);
            
                                }
                            }
                        }
            */



        }
        catch (e) {
        }
        finally {
        }
    }

    this.ProcessRequiredFIFToUnselectOption = function (sModelId, oQueryResult, oFIF, bAutoApproveChanges) {
        //This method excludes any Options that are excluded by the Required FIF that needs to be selected

        //Steps
        //1. See if the Required FIF excludes an Option
        //2. If it does, the following rules need to be processed
        //2a. Are there any FIFs that are excluded by this Option
        //2b. Are there any FIFs that are required by this Option
        //2c. Is the Option included by any of the Option packages
        //2d. Is the Option required by any of the other Option
        //2e. Does the Option require any other Option
        //2f. Does the Option include any other Option
        try {
            var oECM = new ECConfigurationManager();
            var aExcludedOptions = oFIF.FIFRules.FIFToOptionRules.ExcludeRules;
            if (aExcludedOptions != null) {
                for (var i = 0; i < aExcludedOptions.length; i++) {
                    var sExcludedOpCode = aExcludedOptions[i];
                    var oExcludedOption = oECM.GetOption(sModelId, sExcludedOpCode);
                    if (oExcludedOption.IsSelected) {
                        if (!bAutoApproveChanges) {
                            if (!this.CheckOptionsListInQueryResult("Excluded", oExcludedOption, oQueryResult)) {
                                oQueryResult.ExcludedOptions.push(oExcludedOption);
                            }
                        }
                        else {
                            oExcludedOption.IsSelected = false;
                            oExcludedOption.SType = null;
                            oExcludedOption.SelectedOrder = null;
                        }

                        //2a.
                        if (oExcludedOption.OptionToFIFRules != null) {
                            if (oExcludedOption.OptionToFIFRules.ExcludeRules != null) {
                                if (oExcludedOption.OptionToFIFRules.ExcludeRules.length > 0) {
                                    //TODO: Check if to call this or directly call the unselect of an FIF
                                    for (var k = 0; k < oExcludedOption.OptionToFIFRules.ExcludeRules.length; k++) {
                                        var oExcludedRule = oExcludedOption.OptionToFIFRules.ExcludeRules[k];
                                        //Currently no excluded sets to an accessory, only direct FIF exclusions
                                        if (oExcludedRule.Type.toLowerCase() == "" && oExcludedRule.FIFSetId == "") {
                                            this.ProcessExcludeFIFList(sModelId, oQueryResult, oSelFIF, bAutoApproveChanges);
                                        }
                                    }
                                }
                            }
                        }

                        //2b. If an Accessory Excludes an FIF and that Accessory is excluded, this step is not required
                        //                        if (oExcludedOption.OptionToFIFRules.RequireRules.length > 0) {
                        //                            //TODO: Check which method to call
                        //                            //this.ProcessRequiredListToUnselectFIF(sModelId);
                        //                            for (var l = 0; l < oExcludedOption.OptionToFIFRules.RequireRules.length; l++) {
                        //                                var oRequiredRule = oExcludedOption.OptionToFIFRules.RequireRules[l];
                        //                                //Currently no excluded sets to an accessory, only direct FIF exclusions
                        //                                if (oRequiredRule.Type.toLowerCase() == "" && oRequiredRule.FIFSetId == "") {
                        //                                    this.ProcessExcludeFIFList(sModelId, oQueryResult, oSelFIF, bAutoApproveChanges);
                        //                                }
                        //                            }
                        //                        }

                        //2c.
                        if (oExcludedOption.IncludedByList != null) {
                            if (oExcludedOption.IncludedByList.length > 0) {

                                //Process included by list to make sure if an option is includedby any of the options that include it are also unselected
                                this.ProcessIncludeByListToUnselect(sModelId, oExcludedOption, oECM, oQueryResult, bAutoApproveChanges);

                            }
                        }
                        //2d .Process RequiredByList
                        if (oExcludedOption.RequiredByList != null) {
                            if (oExcludedOption.RequiredByList.length > 0) {
                                //Process required by list to make sure if an option is unselected any of the options that require it are also unselected
                                this.ProcessRequiredByListToUnselectOptions(sModelId, oExcludedOption, oExcludedOption, oECM, oQueryResult, bAutoApproveChanges);
                            }
                        }

                        //2e. process required rules
                        if (oExcludedOption.RequiredList != null) {
                            if (oExcludedOption.RequiredList.length > 0) {
                                oExcludedOption.OptionType = "Required";
                                this.ProcessRequiredListToUnselect(sModelId, oExcludedOption, oExcludedOption, oECM, oQueryResult, bAutoApproveChanges, oExcludedOption.OptionType);

                            }
                        }

                        //2f. process include rules
                        if (oExcludedOption.IncludeList != null) {
                            if (oExcludedOption.IncludeList.length > 0) {

                                oExcludedOption.OptionType = "Required";
                                this.ProcessIncludeListToUnselect(sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges, oSelOption.OptionType);

                            }
                        }
                    }
                }
            }
        }
        catch (e) {
        }
        finally { }
    }

    this.ProcessRequiredListToUnselectOption = function (sModelId, oQueryResult, oOption, oSelFIF, bAutoApproveChanges, optionType) {
        var oECM = new ECConfigurationManager();
        try {
            //check if the Option passed in requires a FIF or Option, if so, remove those
            var aRequiredOptions = oOption.RequiredList;
            if (aRequiredOptions != null) {
                for (var i = 0; i < aRequiredOptions.length; i++) {
                    if (aRequiredOptions[i].IsSelected) {
                        this.ProcessRequiredListToUnselect(sModelId, aRequiredOptions[i], oOption, oECM, oQueryResult, bAutoApproveChanges, optionType);
                    }
                }
            }

            //var aRequiredFIFs =  oOption
        }
        catch (e) {
        }
        finally {
        }
    }

    this.ProcessRequiredFIFList = function (sModelId, oQueryResult, oSelFIF, bAutoApproveChanges, sExclusivelySelectedFIFs) {
        /// <summary>
        /// This method processes the Required FIF List of the Selected FIF passed in
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelFIF">Selected OpCode which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        ///<param name="sExclusivelySelectedFIFs">This will be comma seperated list of FIFIds that are part of ExclusivelyRequiredFIFs and selected by User</param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model Option Rules"</exception>

        try {
            var oECM = new ECConfigurationManager();
            var aRequiredRules = new Array();

            if (oSelFIF.FIFRules != null) {
                if (oSelFIF.FIFRules.FIFToFIFRules != null) {
                    if (oSelFIF.FIFRules.FIFToFIFRules.RequireRules.length > 0) {
                        var aRequiredRules = oSelFIF.FIFRules.FIFToFIFRules.RequireRules;
                        //Process the require rules
                        for (var i = 0; i < aRequiredRules.length; i++) {
                            var oFIFRule = aRequiredRules[i];
                            if (oFIFRule != null) {
                                if (oFIFRule.Type.toLowerCase() == "set") {
                                    if (oFIFRule.FIFSetId != null && oFIFRule.FIFSetId != "") {
                                        var depth = 0;
                                        var oProcessedFIFRule = new Object();
                                        this.GetFIFRule(sModelId, oQueryResult, oFIFRule.FIFSetId, oSelFIF, oProcessedFIFRule, depth);

                                        if (oProcessedFIFRule.Operator != null && oProcessedFIFRule.Operator != "") {
                                            this.ProcessRequiredRuleToSelectFIFSet(sModelId, oQueryResult, oSelFIF, oProcessedFIFRule.FIFRule1, oProcessedFIFRule.Operator, oProcessedFIFRule.FIFRule2, bAutoApproveChanges, sExclusivelySelectedFIFs);

                                        }
                                    }
                                }
                                else {
                                    if (oFIFRule.FIFId != null && oFIFRule.FIFId != "") {
                                        var oFIF = oECM.GetFIFById(sModelId, oFIFRule.FIFId);

                                        //Process the required list for this FIF
                                        this.ProcessRequiredFIFList(sModelId, oQueryResult, oFIF, bAutoApproveChanges);

                                        //Process the exclude list for this FIF
                                        this.ProcessExcludeFIFList(sModelId, oQueryResult, oFIF, bAutoApproveChanges);

                                        if (!bAutoApproveChanges) {
                                            if (!this.CheckFIFsList("Required", oFIF, oQueryResult)) {
                                                oQueryResult.RequiredFIFs.push(oFIF);
                                            }

                                            //Check if the Required FIF Excludes any Accessories, if so, added to Excluded Option list
                                            this.ProcessRequiredFIFToUnselectOption(sModelId, oQueryResult, oFIF, bAutoApproveChanges);
                                        }
                                        else {
                                            oFIF.IsSelected = true;

                                            this.ProcessRequiredFIFToUnselectOption(sModelId, oQueryResult, oFIF, bAutoApproveChanges);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

        }
        catch (e) {
            throw e + " In method RulesEngine.ProcessRequiredFIFList";
        }
        finally {

        }

    }

    this.ProcessRequiredRuleToSelectFIFSet = function (sModelId, oQueryResult, oSelFIF, oFIFRule1, sOperator, oFIFRule2, bAutoApproveChanges, sExclusivelySelectedFIFs) {
        /// <summary>
        /// This method processes the Required Rule to select FIFSet. i.e FIF A R (FIFB OR FIFC), etc.
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelFIF">Selected OpCode which needs to be processed</param>
        /// <param name="oFIFRule1">Rule Object 1</param>
        /// <param name="sOperator">Operator i.e O for OR and A for And</param>
        /// <param name="oFIFRule2">Rule Object 2</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        ///<param name="sExclusivelySelectedFIFs">This will be comma seperated list of FIFIds that are part of ExclusivelyRequiredFIFs and selected by User</param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model Option Rules"</exception>

        try {
            var oFIF1, oFIF2;
            var oECM = new ECConfigurationManager();

            if (oFIFRule1 != null && oFIFRule2 != null) {
                if (oFIFRule1.Operator != null && oFIFRule1.Operator != "") {
                    ProcessRequiredRuleToSelectFIFSet(sModelId, oQueryResult, oSelFIF, oFIFRule1.FIFRule1, oFIFRule1.Operator, oFIFRule1.FIFRule2, bAutoApproveChanges)
                }
                if (oFIFRule2.Operator != null && oFIFRule2.Operator != "") {
                    ProcessRequiredRuleToSelectFIFSet(sModelId, oQueryResult, oSelFIF, oFIFRule2.FIFRule1, oFIFRule2.Operator, oFIFRule2.FIFRule2, bAutoApproveChanges)
                }
                if (oFIFRule1.Operator != null && oFIFRule1.Operator == "") {
                    var fifId1 = oFIFRule1.FIFRule1.FIFId1;
                    oFIF1 = oECM.GetFIFById(sModelId, fifId1);
                }
                if (oFIFRule2.Operator != null && oFIFRule2.Operator == "") {
                    var fifid2 = oFIFRule2.FIFRule1.FIFId1;
                    oFIF2 = oECM.GetFIFById(sModelId, fifid2);
                }
                if (sOperator.toLowerCase() == "o") {
                    if (!bAutoApproveChanges) {
                        if (oFIF1 != null && oFIF2 != null) {
                            if (oFIF1.IsSelected == true || oFIF2.IsSelected == true) {
                                //don't do anything over here since either one of them is already selected
                            }
                            if (oFIF1.IsSelected == false && oFIF2.IsSelected == false) {
                                var ruleObject = new Object();
                                ruleObject.FIF1 = oFIF1;
                                ruleObject.FIF2 = oFIF2;
                                oQueryResult.ExclusivelyRequiredFIFs.push(ruleObject);
                            }
                        }
                    }
                    else {
                        if (oFIF1.IsSelected == true || oFIF2.IsSelected == true) {
                            //don't do anything over here since either one of them is already selected
                        }
                        if (oFIF1.IsSelected == false && oFIF2.IsSelected == false) {
                            //This is where sExclusively Required FIFs will be processed
                            //The user has selected one of FIF1 or FIF2. whichever matches, the rules are checked on those
                            //and those FIFs are selected.
                            if (sExclusivelySelectedFIFs != null && sExclusivelySelectedFIFs != "") {
                                var aFIFExclusivelySelected = sExclusivelySelectedFIFs.split(",");
                                var bFIFInList = false;
                                if (aFIFExclusivelySelected.length > 0) {
                                    for (var n = 0; n < aFIFExclusivelySelected.length; n++) {
                                        if (aFIFExclusivelySelected[n] == oFIF1.FIFId) {

                                            //Process the required list for this FIF
                                            this.ProcessRequiredFIFList(sModelId, oQueryResult, oFIF1, bAutoApproveChanges);

                                            //Process the exclude list for this FIF
                                            this.ProcessExcludeFIFList(sModelId, oQueryResult, oFIF1, bAutoApproveChanges);

                                            oFIF1.IsSelected = true;

                                            bFIFInList = true;
                                        }
                                        if (aFIFExclusivelySelected[n] == oFIF2.FIFId) {
                                            //Process the required list for this FIF
                                            this.ProcessRequiredFIFList(sModelId, oQueryResult, oFIF2, bAutoApproveChanges);

                                            //Process the exclude list for this FIF
                                            this.ProcessExcludeFIFList(sModelId, oQueryResult, oFIF2, bAutoApproveChanges);


                                            oFIF2.IsSelected = true;

                                            bFIFInList = true;
                                        }
                                    }
                                    //If the string is passed but none of the selected matched, select one by default
                                    if (!bFIFInList) {
                                        //Process the required list for this FIF
                                        this.ProcessRequiredFIFList(sModelId, oQueryResult, oFIF1, bAutoApproveChanges);

                                        //Process the exclude list for this FIF
                                        this.ProcessExcludeFIFList(sModelId, oQueryResult, oFIF1, bAutoApproveChanges);

                                        oFIF1.IsSelected = true;
                                    }
                                }


                            }
                            else { //Incase none is passed in, select the first one as default
                                //Process the required list for this FIF
                                var sCurFIFSelected = oQueryResult.currentFIF;
                                var oCurFIFSelected = oECM.GetFIFById(sModelId, sCurFIFSelected);
                                //Check if the FIFs in the set are same as the one selected by the user
                                //If not the same, then select the first FIF by default
                                if (!((oFIF1.FIFId == sCurFIFSelected) || (oFIF2.FIFId == sCurFIFSelected))) {

                                    this.ProcessRequiredFIFList(sModelId, oQueryResult, oFIF1, bAutoApproveChanges);

                                    //Process the exclude list for this FIF
                                    this.ProcessExcludeFIFList(sModelId, oQueryResult, oFIF1, bAutoApproveChanges);

                                    oFIF1.IsSelected = true;
                                }
                            }
                        }
                    }
                }
                if (sOperator.toLowerCase() == "a") {
                    if (!bAutoApproveChanges) {
                        if (oFIF1 != null && oFIF2 != null) {
                            if (oFIF1.IsSelected == true && oFIF2.IsSelected == true) {
                                //don't do anything over here since both of them are already selected
                            }
                            if (oFIF1.IsSelected == false && oFIF2.IsSelected == false) {

                                if (!this.CheckFIFsList("Required", oFIF1, oQueryResult)) {
                                    oQueryResult.RequiredFIFs.push(oFIF1);
                                }
                                if (!this.CheckFIFsList("Required", oFIF2, oQueryResult)) {
                                    oQueryResult.RequiredFIFs.push(oFIF2);
                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) { throw e + " In method ProcessRequiredRuleToSelectFIFSet"; }
        finally {
            oECM, oFIF1, oFIF2, aFIFExclusivelySelected = null;
        }


    }

    this.CheckFIFAvailableInSelectedColor = function (sModelId, oSelFIF) {
        /// <summary>
        /// This method checks if the fif passed in is available in the selected exterior and interior color
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oSelFIF">Selected OpCode which needs to be processed</param>
        /// <returns>true if color found else false</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model Option Rules"</exception>


        try {
            var oECM = new ECConfigurationManager();
            //loop through all the colors and check if the fif is available in the color selected. If not, display FIF Color Conflict
            var oSelExteriorColor = oECM.GetSelectedExteriorColor(sModelId);
            var oSelInteriorColor = oECM.GetSelectedInteriorColor(sModelId);
            var bFIFAvailable = false;
            for (var i = 0; i < oSelFIF.FIFColors.length; i++) {
                if (oSelFIF.FIFColors[i].ExteriorColorCode == oSelExteriorColor.ColorMfgCode) {
                    for (var j = 0; j < oSelFIF.FIFColors[i].InteriorColors.length; j++) {
                        if (oSelFIF.FIFColors[i].InteriorColors[j].IntColorCd == oSelInteriorColor.ColorCode) {
                            bFIFAvailable = true;
                            break;
                        }
                    }
                }
                if (bFIFAvailable) {
                    break;
                }
            }

            return bFIFAvailable;
        }
        catch (e) { throw e + " In method CheckFIFAvailableInSelectedColor"; }
        finally { }

    }

    this.ProcessExcludeFIFList = function (sModelId, oQueryResult, oSelFIF, bAutoApproveChanges) {
        /// <summary>
        /// This method is called by the ValidateConfiguration method and processes the FIF Exclude Rules
        /// a. Process Excludes within the FIF's category.
        ///   a1. Process Excludes for all FIFs in a category that excludes other FIFs
        ///   a2. If a particular category has an exclude, select the default in that category that needs to be added in the Required List.
        /// b. Process Excludes if FIF's exclude FIF in other category.
        ///   b1. If a particular category has an exclude, select the default in that category that needs to be added in the Required List.
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelFIF">Selected FIF which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        ///<param name="sExclusivelySelectedFIFs">This will be comma seperated list of FIFIds that are part of ExclusivelyRequiredFIFs and selected by User</param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model FIF Rules"</exception>
        try {
            var oECM = new ECConfigurationManager();
            //For storing excluded fifs in other categories. This will be used to process the defaults in those categories. 
            //This array won't contain the excluded FIFs of the category of currently selected FIF
            var aExcludedFIFs = new Array();

            //Exclude the FIFs which are part of the category of the currently selected FIF
            this.ProcessRulesToUnSelectFIFsForACategory(sModelId, oQueryResult, oSelFIF, bAutoApproveChanges, aExcludedFIFs);

            //TODO: Require Rules for excluded fif, needs to be excluded.
            //Check if the selected FIF have required FIFs, if so and if selected, put it in the excluded list.
            //this.ProcessRequiredRulesToUnSelectFIFs(sModelId, oQueryResult, oSelFIF, oSelFIF, bAutoApproveChanges, aExcludedFIFs);

            //This excludes the FIFs which are in Excluded List of the currently selected FIF.
            this.ProcessUnSelectRulesForExcludedFIFs(sModelId, oQueryResult, oSelFIF, bAutoApproveChanges, aExcludedFIFs);

            this.ProcessRequiredAndExcludeRulesOnExcludedFIFs(sModelId, oQueryResult, oSelFIF, bAutoApproveChanges, aExcludedFIFs);

            //Exclude any Accessories that the selected FIF excludes
            this.ProcessRequiredFIFToUnselectOption(sModelId, oQueryResult, oSelFIF, bAutoApproveChanges);
        }
        catch (e) {
            throw e + " In method ProcessExcludeFIFList";
        }
        finally {
            oECM, aExcludedFIFs = null;
        }
    }

    this.ProcessRequiredAndExcludeRulesOnExcludedFIFs = function (sModelId, oQueryResult, oSelFIF, bAutoApproveChanges, aExcludedFIFs) {

        try {
            var oECM = new ECConfigurationManager();
            //This scenario is when bAutoApproveChanges is true
            if (bAutoApproveChanges) {
                if (aExcludedFIFs.length > 0) {
                    //looking through all the excluded fifs to select default in that category
                    for (var i = 0; i < aExcludedFIFs.length; i++) {
                        var oFIF = aExcludedFIFs[i];
                        var bFIFAvailable = false;
                        if (oFIF.FIFCategoryCd != oSelFIF.FIFCategoryCd) {
                            //In case when this function is called in a loop, it's possible that the oSelFIF is the FIF being processed.
                            //The process should also not process any rules on the current FIF being processed by the user
                            //hence a check needs to happen to make sure that FIF category is not processed again.
                            var sCurSelFIF = oQueryResult.currentFIF;
                            var oCurSelFIF = oECM.GetFIFById(sModelId, sCurSelFIF);
                            if (oFIF.FIFCategoryCd != oCurSelFIF.FIFCategoryCd) {
                                var aFIFsByCategory = oECM.GetFIFsByCategoryCode(sModelId, oFIF.FIFCategoryCd);
                                for (var j = 0; j < aFIFsByCategory.length; j++) {
                                    if (aFIFsByCategory[j].FIFId != oFIF.FIFId) {
                                        //Check if this FIF can be selected in the category and it doesn't have any conflicts.
                                        var oFIFToBeSelected = aFIFsByCategory[j];

                                        //Check if it is available in the exterior and interior color currently selected
                                        bFIFAvailable = this.CheckFIFAvailableInSelectedColor(sModelId, oFIFToBeSelected);

                                        //If available, check other rules
                                        if (bFIFAvailable) {

                                            //Check if the FIF is already in the Require Rules of Selected FIF

                                            //Check if the FIF is Excluded by the selected FIF
                                            var aExcludeRulesForSelectedFIF = oSelFIF.FIFRules.FIFToFIFRules.ExcludeRules;
                                            var bExcludedFIF = false;
                                            if (aExcludeRulesForSelectedFIF != null && aExcludeRulesForSelectedFIF.length > 0) {
                                                for (var m = 0; m < aExcludeRulesForSelectedFIF.length; m++) {
                                                    if (aExcludeRulesForSelectedFIF[m].FIFId == aFIFsByCategory[j].FIFId) {
                                                        bExcludedFIF = true;
                                                        break;
                                                    }
                                                }
                                            }
                                            if (!bExcludedFIF) {
                                                //Check Require Rules for this once the regular require rules are processed.
                                                this.ProcessRequiredFIFList(sModelId, oQueryResult, aFIFsByCategory[j], bAutoApproveChanges);
                                                //Check Exclude Rules for this
                                                this.ProcessExcludeFIFList(sModelId, oQueryResult, aFIFsByCategory[j], bAutoApproveChanges);

                                                //The following FIF is selected now
                                                aFIFsByCategory[j].IsSelected = true;

                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            else {
                //TODO: Same scenario as above when bAutoApproveChanges is false
                if (oQueryResult.ExcludedFIFs != null) {
                    if (oQueryResult.ExcludedFIFs.length > 0) {
                        for (var i = 0; i < oQueryResult.ExcludedFIFs.length; i++) {
                            //1. For each excluded FIF, check if in that category has atleast an FIF in
                            //   RequiredFIFs or ExclusivelyRequiredFIFs list.
                            //   a. If it is in there, don't do anything
                            //   b. If it is not in there, loop through each of the FIF and see if the FIF
                            //      b1. FIF requires an FIF that is conflicting with the selected FIF
                            //      b2.
                            var oExcludedFIF = oQueryResult.ExcludedFIFs[i];
                            var sFIFCategoryCd = oExcludedFIF.FIFCategoryCd;
                            if (sFIFCategoryCd != oSelFIF.FIFCategoryCd) {
                                var bFIFAvailable = false;
                                var bInRequiredFIFs = false;
                                var bInExclusivelyRequiredFIFs = false;

                                var aFIFs = oECM.GetFIFsByCategoryCode(sModelId, sFIFCategoryCd);

                                if (aFIFs != null) {
                                    if (aFIFs.length > 0) {
                                        for (var j = 0; j < aFIFs.length; j++) {

                                            //Check if it is available in the exterior and interior color currently selected
                                            bFIFAvailable = this.CheckFIFAvailableInSelectedColor(sModelId, aFIFs[j]);

                                            //If available, check other rules
                                            if (bFIFAvailable) {

                                                //Check if it's not part of RequiredFIFs already
                                                if (oQueryResult.RequiredFIFs != null) {
                                                    if (oQueryResult.RequiredFIFs.length > 0) {
                                                        for (var k = 0; k < oQueryResult.RequiredFIFs.length; k++) {
                                                            if (oQueryResult.RequiredFIFs[k].FIFId == aFIFs[j].FIFId) {
                                                                bInRequiredFIFs = true;
                                                                break;
                                                            }
                                                        }
                                                    }
                                                }

                                                if (!bInRequiredFIFs) {
                                                    //Check if it's not part of ExclusivelyRequiredFIFs
                                                    if (oQueryResult.ExclusivelyRequiredFIFs != null) {
                                                        if (oQueryResult.ExclusivelyRequiredFIFs.length > 0) {
                                                            for (var l = 0; l < oQueryResult.ExclusivelyRequiredFIFs.length; l++) {
                                                                if ((oQueryResult.ExclusivelyRequiredFIFs[l].FIF1.FIFId == aFIFs[j].FIFId) ||
                                                                    (oQueryResult.ExclusivelyRequiredFIFs[l].FIF2.FIFId == aFIFs[j].FIFId)) {
                                                                    bInExclusivelyRequiredFIFs = true;
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                    }

                                                    //No FIF for this category in RequiredFIFs or ExclusivelyRequiredFIFs
                                                    //Process the exclude rules on this selected FIF to see if the FIF is in that list
                                                    if (!bInRequiredFIFs && !bInExclusivelyRequiredFIFs) {
                                                        var aExcludeRulesForSelectedFIF = oSelFIF.FIFRules.FIFToFIFRules.ExcludeRules;
                                                        var bExcludedFIF = false;
                                                        if (aExcludeRulesForSelectedFIF != null && aExcludeRulesForSelectedFIF.length > 0) {
                                                            for (var m = 0; m < aExcludeRulesForSelectedFIF.length; m++) {
                                                                if (aExcludeRulesForSelectedFIF[m].FIFId == aFIFs[j].FIFId) {
                                                                    bExcludedFIF = true;
                                                                    break;
                                                                }
                                                            }

                                                            //If this is not excluded by the selected fif process the required and exclude rules
                                                            //on it
                                                            if (!bExcludedFIF) {
                                                                //this.ProcessRequiredFIFList(sModelId, oQueryResult, aFIFs[j], bAutoApproveChanges);

                                                                //this.ProcessExcludeFIFList(sModelId, oQueryResult, aFIFs[j], bAutoApproveChanges);
                                                                var oCurrentFIF = oECM.GetFIFById(sModelId, oQueryResult.currentFIF);
                                                                if (aFIFs[j].FIFCategoryCd != oCurrentFIF.FIFCategoryCd) {
                                                                    if (!this.CheckFIFsList("Required", aFIFs[j], oQueryResult)) {
                                                                        oQueryResult.RequiredFIFs.push(aFIFs[j]);
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) {
            throw e + " In ProcessRequiredAndExcludeRulesOnExcludedFIFs";
        }
        finally {
            oECM, oFIF = null; bFIFAvailable = null; aFIFsByCategory = null; oFIFToBeSelected = null; aExcludeRulesForSelectedFIF = null;
            bExcludedFIF = null; oExcludedFIF = null; sFIFCategoryCd = null; bInRequiredFIFs = null; bInExclusivelyRequiredFIFs = null;
            aFIFs = null; aExcludeRulesForSelectedFIF = null;
        }
    }

    this.ProcessRulesToUnSelectFIFsForACategory = function (sModelId, oQueryResult, oSelFIF, bAutoApproveChanges, aExcludedFIFs) {
        /// <summary>
        /// This method excludes all FIFs in a category except the one that is selected
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelFIF">Selected OpCode which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        ///<param name="aExcludedFIFs">Excluded FIF Array when bAutoApproveChanges is set to true</param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model Option Rules"</exception>


        try {
            var oECM = new ECConfigurationManager();
            var aFIFs = new Array();
            var sFIFCategory = oSelFIF.FIFCategoryCd;
            if (sFIFCategory != null && sFIFCategory != "") {
                aFIFs = oECM.GetFIFsByCategoryCode(sModelId, sFIFCategory);
                if (aFIFs != null) {
                    for (var k = 0; k < aFIFs.length; k++) {
                        if (aFIFs[k].FIFId != oSelFIF.FIFId) {
                            if (aFIFs[k].IsSelected) {
                                //Check if Excluded FIFs have required FIFs, if so and if selected, put it in the excluded list.
                                //this.ProcessRequiredRulesToUnSelectFIFs(sModelId, oQueryResult, aFIFs[k], oSelFIF, bAutoApproveChanges, aExcludedFIFs);

                                //TODO: Processs RequiredBy Rules on the Excluded FIFs
                                this.ProcessRequiredByRulesToUnSelectFIFs(sModelId, oQueryResult, aFIFs[k], oSelFIF, bAutoApproveChanges, aExcludedFIFs);

                                if (!bAutoApproveChanges) {
                                    if (!this.CheckFIFsList("Excluded", aFIFs[k], oQueryResult)) {
                                        oQueryResult.ExcludedFIFs.push(aFIFs[k]);
                                    }
                                }
                                else {
                                    aFIFs[k].IsSelected = false;
                                    //Adding this to Excluded FIFs to unselect any FIFs required by this FIF
                                    //aExcludedFIFs.push(aFIFs[k]);
                                }
                            }
                        }
                    }
                }
            }

        }
        catch (e) {
            throw e + " In method UnSelectFIFsForACategory";
        }
        finally {
            oECM, aFIFs = null; sFIFCategory = null;
        }

    }

    this.ProcessUnSelectRulesForExcludedFIFs = function (sModelId, oQueryResult, oSelFIF, bAutoApproveChanges, aExcludedFIFs) {
        /// <summary>
        /// This method processes the Exclude rules for an FIF
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelFIF">Selected OpCode which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        ///<param name="sExclusivelySelectedFIFs">This will be comma seperated list of FIFIds that are part of ExclusivelyRequiredFIFs and selected by User</param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model Option Rules"</exception>


        try {
            var oECM = new ECConfigurationManager();
            var aFIFExcludeRules = oSelFIF.FIFRules.FIFToFIFRules.ExcludeRules;
            if (aFIFExcludeRules != null) {
                if (aFIFExcludeRules.length > 0) {
                    for (var i = 0; i < aFIFExcludeRules.length; i++) {
                        if ((aFIFExcludeRules[i].Type == "") && (aFIFExcludeRules[i].FIFSetId == "")) {
                            //This is an FIF that needs to be excluded.
                            var sFIFId = aFIFExcludeRules[i].FIFId;
                            if (sFIFId != null && sFIFId != "") {
                                var oExcludedFIF = oECM.GetFIFById(sModelId, sFIFId);
                                //The Excluded FIF in the list is excluded.
                                if (oExcludedFIF.IsSelected) {
                                    if (!bAutoApproveChanges) {
                                        if (!this.CheckFIFsList("Excluded", oExcludedFIF, oQueryResult)) {
                                            oQueryResult.ExcludedFIFs.push(oExcludedFIF);
                                        }
                                    }
                                    else {
                                        oExcludedFIF.IsSelected = false;
                                        aExcludedFIFs.push(oExcludedFIF);
                                    }

                                    //Check if Excluded FIFs have required FIFs, if so and if selected, put it in the excluded list.
                                    this.ProcessRequiredRulesToUnSelectFIFs(sModelId, oQueryResult, oExcludedFIF, oSelFIF, bAutoApproveChanges, aExcludedFIFs);

                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) {
            throw e + " In method ProcessUnSelectRulesForExcludedFIFs";
        }
        finally {
            oECM, aFIFExcludeRules = null; sFIFId = null;
        }


    }

    this.ProcessRequiredRulesToUnSelectFIFs = function (sModelId, oQueryResult, oUnSelectFIF, oSelFIF, bAutoApproveChanges, aExcludedFIFs) {
        /// <summary>
        /// This method checks if Excluded FIFs have required FIFs, if so and if selected, put it in the excluded list or unselect it if bAutoApproveChanges is set to true
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Required Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oUnSelectFIF">Unselected FIF for which Required Rules are being processed</param>
        /// <param name="oSelFIF">Original Selected FIF</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model Required Rules To UnSelect FIFs"</exception>
        try {
            var oECM = new ECConfigurationManager();
            var aUnSelectFIFRequiredRules = oUnSelectFIF.FIFRules.FIFToFIFRules.RequireRules;
            if (aUnSelectFIFRequiredRules != null) {
                if (aUnSelectFIFRequiredRules.length > 0) {
                    for (var j = 0; j < aUnSelectFIFRequiredRules.length; j++) {
                        //Figure out process to unselect FIFs and FIFSets.
                        //1. If it's an FIF, than unselect it and loop through to make sure the FIFs it requires and are selected are excluded.
                        //2. If it's an FIFSet, then unselect the set and loop through to make sure the FIFs in the set which have required FIFs are also processed.
                        if ((aUnSelectFIFRequiredRules[j].Type == "") && (aUnSelectFIFRequiredRules[j].FIFSetId == "")) {
                            var sFIFId = aUnSelectFIFRequiredRules[j].FIFId;
                            if (sFIFId != null && sFIFId != "") {
                                var oFIFToBeUnSelected = oECM.GetFIFById(sModelId, sFIFId);
                                //The FIF to be unselected in the list is excluded
                                if (oFIFToBeUnSelected.IsSelected) {
                                    if (!bAutoApproveChanges) {
                                        if (!this.CheckFIFsList("Excluded", oFIFToBeUnSelected, oQueryResult)) {
                                            oQueryResult.ExcludedFIFs.push(oFIFToBeUnSelected);
                                        }
                                    }
                                    else {
                                        oFIFToBeUnSelected.IsSelected = false;
                                        aExcludedFIFs.push(oFIFToBeUnSelected);
                                    }

                                    //Check if Excluded FIFs have required FIFs, if so and if selected, put it in the excluded list.
                                    this.ProcessRequiredRulesToUnSelectFIFs(sModelId, oQueryResult, oFIFToBeUnSelected, oUnSelectFIF, bAutoApproveChanges, aExcludedFIFs);

                                }
                            }
                        }
                        else {
                            if (aUnSelectFIFRequiredRules[j].Type.toLowerCase() == "set") {
                                if (aUnSelectFIFRequiredRules[j].FIFSetId != null && aUnSelectFIFRequiredRules[j].FIFSetId != "") {
                                    //Process Required Rules to UnSelect FIF Sets
                                    this.ProcessRequiredRulesToUnSelectFIFSets(sModelId, oQueryResult, aUnSelectFIFRequiredRules[j].FIFSetId, oUnSelectFIF, oSelFIF, bAutoApproveChanges, aExcludedFIFs);
                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) {
            throw e + " In method ProcessRequiredRulesToUnSelectFIFs";
        }
        finally { oECM, aUnSelectFIFRequiredRules = null; sFIFId = null; oFIFToBeUnSelected = null; }


    }

    this.ProcessRequiredByRulesToUnSelectFIFs = function (sModelId, oQueryResult, oUnSelectFIF, oSelFIF, bAutoApproveChanges, aExcludedFIFs) {
        /// <summary>
        /// This method processes the Required By Rules to unselect an FIF. 
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oUnSelectFIF">FIF that needs to be unselected</param>
        /// <param name="oSelFIF">Selected FIF which is being processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        ///<param name="aExcludedFIFs">Array containing Excluded FIFs in case when bAutoApproveChanges is set to true</param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model FIF Rules"</exception>

        try {
            var oECM = new ECConfigurationManager();
            //Loop through all the FIF and see if any of the FIFs have this FIF required
            var oModel = oECM.GetModel(sModelId);
            if (oModel != null) {
                var aFIFList = oModel.ModelFIFList;
                if (aFIFList.length > 0) {
                    for (var i = 0; i < aFIFList.length; i++) {
                        var aFIFRequireRules = aFIFList[i].FIFRules.FIFToFIFRules.RequireRules;
                        if (aFIFRequireRules != null) {
                            for (var j = 0; j < aFIFRequireRules.length; j++) {
                                //Check if the rule is a set or not
                                if (aFIFRequireRules[j].Type.toLowerCase() == "set" && aFIFRequireRules[j].FIFSetId != "") {
                                    //TODO:
                                }
                                else {
                                    //If not set, make sure the FIFId is the same as the one to be unselected

                                    if (aFIFRequireRules[j].FIFId == oUnSelectFIF.FIFId) {

                                        var oFIF = oECM.GetFIFById(sModelId, aFIFList[i].FIFId);

                                        //Exclude the FIF
                                        if (!bAutoApproveChanges) {
                                            if (!this.CheckFIFsList("Excluded", oFIF, oQueryResult)) {
                                                oQueryResult.ExcludedFIFs.push(oFIF);
                                            }
                                        }
                                        else {
                                            oFIF.IsSelected = false;
                                            aExcludedFIFs.push(oFIF);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) {
            throw e + " Error in ProcessRequiredByRulesToUnSelectFIFs";
        }
        finally { }

    }

    this.ProcessRequiredRulesToUnSelectFIFSets = function (sModelId, oQueryResult, sFIFSetId, oUnSelectFIF, oSelFIF, bAutoApproveChanges, aExcludedFIFs) {
        /// <summary>
        /// This method processes the Required Rules to unselect FIF
        ///1. Require Rules is a set, get the set id, jump to set.
        ///2. The set has a set, jump to that set, return fif id and rule
        ///3. the second item is a set, jump to that set, return fif id and rule
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="sFIFSetId">FIFSetId that needs to be processed</param>
        /// <param name="oUnSelectFIF">FIF that needs to be unselected</param>
        /// <param name="oSelFIF">Selected FIF which is currently being processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        ///<param name="aExcludedFIFs">Array containing excluded fifs </param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model Option Rules"</exception>


        try {
            //Obtain FIFSets for the Option that needs to be Unselected
            var oFIFRule = new Object();
            var depth = 0;
            this.GetFIFRule(sModelId, oQueryResult, sFIFSetId, oUnSelectFIF, oFIFRule, depth);
            //Now the rule is obtained for an fifset, process it.
            //Process Required rules to unselect by processing the fifs
            if (oFIFRule.Operator != null && oFIFRule.Operator != "") {
                this.ProcessUnSelectFIFRule(sModelId, oQueryResult, oUnSelectFIF, oSelFIF, oFIFRule.FIFRule1, oFIFRule.Operator, oFIFRule.FIFRule2, bAutoApproveChanges, aExcludedFIFs);
            }
        }
        catch (e) {
            throw e + " In method ProcessRequiredRulesToUnSelectFIFSets";
        }
        finally { }


    }

    this.ProcessUnSelectFIFRule = function (sModelId, oQueryResult, oUnSelectFIF, oSelFIF, FIFRule1, Operator, FIFRule2, bAutoApproveChanges, aExcludedFIFs) {
        /// <summary>
        /// This method processes the FIF Rule to Unselect
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oUnSelectFIF">FIF to be unselected</param>
        /// <param name="oSelFIF">Selected OpCode which needs to be processed</param>
        /// <param name="oFIFRule1">Rule Object 1</param>
        /// <param name="sOperator">Operator i.e O for OR and A for And</param>
        /// <param name="oFIFRule2">Rule Object 2</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        ///<param name="aExcludedFIFs">Array containing excluded FIFs when bAutoApproveChanges is set to true</param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model Option Rules"</exception>


        try {
            var oECM = new ECConfigurationManager();

            if (FIFRule1 != null & FIFRule2 != null) {
                if (FIFRule1.Operator != null && FIFRule1.Operator != "") {
                    this.ProcessUnSelectFIFRule(sModelId, oQueryResult, oUnSelectFIF, oSelFIF, oFIFRule.FIFRule1, oFIFRule.Operator, oFIFRule.FIFRule2, bAutoApproveChanges);
                }
                else if (FIFRule2.Operator != null && FIFRule2.Operator != "") {
                    this.ProcessUnSelectFIFRule(sModelId, oQueryResult, oUnSelectFIF, oSelFIF, oFIFRule.FIFRule1, oFIFRule.Operator, oFIFRule.FIFRule2, bAutoApproveChanges);
                }
                else if (FIFRule1.Operator == null || FIFRule1.Operator == "") {
                    //If the Rule is OR or AND, if the FIF is selected, it needs to be unselected.
                    //if (FIFRule1.Operator == "O" || FIFRule1.Operator == "A") {
                    var fifId1 = FIFRule1.FIFRule1.FIFId1;
                    var fifId2 = FIFRule2.FIFRule1.FIFId1;
                    if (fifId1 != null && fifId1 != "") {
                        var oFIF = oECM.GetFIFById(sModelId, fifId1);
                        if (oFIF.IsSelected == true) {
                            if (!bAutoApproveChanges) {
                                if (!this.CheckFIFsList("Excluded", oFIF, oQueryResult)) {
                                    oQueryResult.ExcludedFIFs.push(oFIF);
                                }
                            }
                            else {
                                oFIF.IsSelected = false;
                                aExcludedFIFs.push(oFIF);
                            }
                        }
                    }
                    if (fifId2 != null && fifId2 != "") {
                        var oFIF = oECM.GetFIFById(sModelId, fifId2);
                        if (oFIF.IsSelected == true) {
                            if (!bAutoApproveChanges) {
                                if (!this.CheckFIFsList("Excluded", oFIF, oQueryResult)) {
                                    oQueryResult.ExcludedFIFs.push(oFIF);
                                }
                            }
                            else {
                                oFIF.IsSelected = false;
                                aExcludedFIFs.push(oFIF);
                            }
                        }
                    }
                    //}

                }
            }
        }
        catch (e) {
            throw e + " In method ProcessUnSelectFIFRule";
        }
        finally { oECM = null; oFIF = null; fifId1, fifId2 = null; }


    }

    this.GetFIFRule = function (sModelId, oQueryResult, sFIFSetId, oUnSelectFIF, oFIFRule, depth) {
        /// <summary>
        /// This method processes the FIFSet to create a rule object which contains the rules
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="sFIFSetId">FIFSetId which needs to be processed</param>
        /// <param name="oUnSelectFIF">Selected OpCode which needs to be processed</param>
        /// <param name="oSelFIF">Selected OpCode which needs to be processed</param>
        /// <param name="oFIFRule">Rule Object</param>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model Option Rules"</exception>


        try {
            var aUnSelectFIFSets = oUnSelectFIF.FIFRules.FIFSets;
            for (var k = 0; k < aUnSelectFIFSets.length; k++) {
                if (aUnSelectFIFSets[k].FIFSetId == sFIFSetId) {
                    oFIFRule.Operator = aUnSelectFIFSets[k].OperationCode;
                    for (var l = 0; l < aUnSelectFIFSets[k].FIFs.length; l++) {
                        var oFIFRule1 = new Object();
                        if (aUnSelectFIFSets[k].FIFs[l].FIFSetId != null && aUnSelectFIFSets[k].FIFs[l].FIFSetId != "") {
                            depth += 1;
                            oFIFRule1.FIFSetId = aUnSelectFIFSets[k].FIFs[l].FIFSetId;

                            this.GetFIFRule(sModelId, oQueryResult, aUnSelectFIFSets[k].FIFs[l].FIFSetId, oUnSelectFIF, oFIFRule1, depth);
                        }
                        else {

                            if (l == 0) {
                                oFIFRule1.FIFId1 = aUnSelectFIFSets[k].FIFs[l].FIFId;
                            }
                            if (l == 1) {
                                oFIFRule1.FIFId2 = aUnSelectFIFSets[k].FIFs[l].FIFId;
                            }
                        }
                        if (l == 0) {
                            oFIFRule.FIFRule1 = oFIFRule1;
                        }
                        if (l == 1) {
                            oFIFRule.FIFRule2 = oFIFRule1;
                        }
                    }
                }
            }
            oFIFRule.Depth = depth;
        }
        catch (e) {
            throw e + " In method GetFIFRule";
        }
        finally { }


    }

    this.ProcessModelOptionRules = function (sModelId, oQueryResult, sSelOpCode, bAutoApproveChanges) {
        /// <summary>
        /// This method is called by the ValidateConfiguration method and processes the Model Option Rules
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="sSelOpCode">Selected OpCode which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>ECRulesEngineQueryResult</returns>
        /// <exception>If any error occurs while processing the rules, throws "Error processing Model Option Rules"</exception>
        var oECM, oSelOption;

        oECM = new ECConfigurationManager();
        oQueryResult.currentOption = sSelOpCode;

        if (oECM.AutoApproveChanges) { bAutoApproveChanges = true; }

        try {
            //Get Option object for passed in OpCode
            oSelOption = oECM.GetOption(sModelId, sSelOpCode);

            //Process all Rules

            //If a particular Option is not selected then it's SelectType is set to "Selected"
            //and the SelectedOrder counter is incremented by 1;
            if (!oSelOption.IsSelected) {
                oSelOption.SType = "Selected";
                if (bAutoApproveChanges) {
                    SelectedOrderCounter += 1;
                    oSelOption.SelectedOrder = SelectedOrderCounter;
                }
            }

            //Process exclude Rules
            if (!oSelOption.IsSelected) {
                if (oSelOption.ExcludeList.length > 0) {
                    this.ProcessExcludeList(sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges);
                }
            }

            //Process RequiredByList 
            if (oSelOption.RequiredByList.length > 0) {
                if (oSelOption.IsSelected) {
                    //Process required by list to make sure if an option is unselected any of the options that require it are also unselected
                    this.ProcessRequiredByListToUnselectOptions(sModelId, oSelOption, oSelOption, oECM, oQueryResult, bAutoApproveChanges);
                }
            }

            // process required rules
            if (oSelOption.RequiredList.length > 0) {
                oSelOption.OptionType = "Required";
                if (oSelOption.IsSelected) {
                    this.ProcessRequiredListToUnselect(sModelId, oSelOption, oSelOption, oECM, oQueryResult, bAutoApproveChanges, oSelOption.OptionType);
                }
                else {
                    this.ProcessRequiredListToSelect(sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges);
                }
            }

            // process include rules
            if (oSelOption.IncludeList.length > 0) {
                oSelOption.OptionType = "Required";
                if (oSelOption.IsSelected) {
                    this.ProcessIncludeListToUnselect(sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges, oSelOption.OptionType);
                }
                else {
                    this.ProcessIncludeListToSelect(sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges);
                }
            }


            if (oSelOption.IncludedByList.length > 0) {
                if (oSelOption.IsSelected) {
                    //Process included by list to make sure if an option is includedby any of the options that include it are also unselected
                    this.ProcessIncludeByListToUnselect(sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges);
                }
            }

            //Process Accessory Rules to Require FIFs
            if (oSelOption.OptionToFIFRules != null) {
                if (oSelOption.OptionToFIFRules.RequireRules != null) {
                    for (var i = 0; i < oSelOption.OptionToFIFRules.RequireRules.length; i++) {

                        var sRequiredFIF = oSelOption.OptionToFIFRules.RequireRules[i].FIFId;
                        var oReqFIF = oECM.GetFIFById(sModelId, sRequiredFIF);

                        if (oReqFIF != null) {

                            this.ProcessModelFIFRules(sModelId, oQueryResult, sRequiredFIF, bAutoApproveChanges, "");
                            //Accessory Requires an FIF. Process required FIFs
                            //this.ProcessRequiredFIFList(sModelId, oQueryResult, oReqFIF, bAutoApproveChanges, "");

                            //Accessory requires an FIF> Process Exclude rules for the FIFs to make sure to exclude any FIFs/Accessories it excludes
                            //this.ProcessExcludeFIFList(sModelId, oQueryResult, oReqFIF, bAutoApproveChanges);
                            if (!bAutoApproveChanges) {
                                if (!this.CheckFIFsList("Required", oReqFIF, oQueryResult)) {
                                    oQueryResult.RequiredFIFs.push(oReqFIF);
                                }
                            }
                            else {
                                oReqFIF.IsSelected = true;
                            }
                        }
                    }
                }
            }

            // Set state of currently processed option
            if (bAutoApproveChanges) {
                oSelOption.OptionType = "Required";
                if (oSelOption.IsSelected) {
                    oSelOption.IsSelected = false;
                }
                else {
                    oSelOption.IsSelected = true;
                }
            }
            else {
                this.currentOption = oSelOption;
            }



            // Process Option Color Rules
            this.ProcessOptionColorRules(sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges);

            // Update Package Information
            this.UpdatePackages(sModelId, oECM, oQueryResult);

            // Update Model Price
            this.CalculatePrice(sModelId, oECM);

        }
        catch (e) { throw errRules4000; }

        // Return Query Result object
        return oQueryResult;
    }

    //This method processes the Exclude Rules
    this.ProcessExcludeList = function (sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges) {
        /// <summary>
        /// This is a helper method that processes the exclude rules
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager object</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelOption">Selected Option which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>None</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>
        var oExOption;

        try {
            for (var e = 0; e < oSelOption.ExcludeList.length; e++) {
                //Get Option object for the OpCode in the Exclude List
                oExOption = oECM.GetOption(sModelId, oSelOption.ExcludeList[e]);

                if (oExOption.IsSelected) {
                    //This scenario allows unselecting any options that are included in a package
                    this.ProcessIncludeByListToUnselect(sModelId, oExOption, oECM, oQueryResult, bAutoApproveChanges);

                    if (bAutoApproveChanges) {
                        //Unselect this Option by setting its IsSelected property to false
                        oExOption.IsSelected = false;
                        oExOption.SelectedOrder = null;
                    }
                    else {
                        if (!this.CheckOptionsListInQueryResult("Excluded", oExOption, oQueryResult)) {
                            oQueryResult.ExcludedOptions.push(oExOption);
                        }
                    }

                    //If this excluded option has a required list, process required list to unselect option
                    var optionType = "Required";
                    this.ProcessRequiredListToUnselect(sModelId, oExOption, oSelOption, oECM, oQueryResult, bAutoApproveChanges, optionType);
                    this.ProcessIncludeListToUnselect(sModelId, oExOption, oECM, oQueryResult, bAutoApproveChanges, optionType, oSelOption);
                    this.ProcessRequiredByListToUnselectOptions(sModelId, oExOption, oSelOption, oECM, oQueryResult, bAutoApproveChanges);

                }
            }
        }
        catch (e) { throw "Error in Process Exclude Rules"; }

    }

    this.ProcessRequiredListToSelect = function (sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges) {
        /// <summary>
        /// This is a helper method that processes the Required rules to Select Option
        /// This method is called when the state of the processed Option is not selected.
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager object</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelOption">Selected Option which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>None</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>
        var oReqOption;

        try {
            for (var i = 0; i < oSelOption.RequiredList.length; i++) {
                //Get Option object for the OpCode in the required list
                oReqOption = oECM.GetOption(sModelId, oSelOption.RequiredList[i]);

                //If Option.IsSelected = false follow the process below else continue with next Option 
                if (!oReqOption.IsSelected) {
                    oReqOption.OptionType = "Required";
                    //Since the Required Option is not selected before and required by other option
                    //it's SelectType is set to "Required";
                    oReqOption.SType = "Required";
                    if (bAutoApproveChanges) {
                        //Select the option
                        oReqOption.IsSelected = true;
                    }
                    else {
                        //Check if Option exists in RequiredOptions List
                        if (!this.CheckRequiredOptionsList(oReqOption)) {
                            oQueryResult.RequiredOptions.push(oReqOption);
                        }
                    }

                    //Check if the Option contains an exclude list. 
                    //If true, process the Exclude Options list
                    if (oReqOption.ExcludeList.length > 0) {
                        this.ProcessExcludeList(sModelId, oReqOption, oECM, oQueryResult, bAutoApproveChanges);
                    }
                }
            }
        }
        catch (e) { throw "Error in Process Required Rules to select"; }
    }

    this.ProcessRequiredListToUnselect = function (sModelId, oSelOption, oParOption, oECM, oQueryResult, bAutoApproveChanges, sOptionType) {
        /// <summary>
        /// This is a helper method that processes the Required rules to Unselect Option
        /// This method is called when the state of the processed Option is selected.
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager object</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelOption">Selected Option which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>None</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>        
        var oReqOption;
        try {
            for (var i = 0; i < oSelOption.RequiredList.length; i++) {
                //Get Option object for the OpCode in the required list
                oReqOption = oECM.GetOption(sModelId, oSelOption.RequiredList[i]);

                if (oReqOption.IsSelected) {
                    //Process Option Required By List
                    var usedByAnOption = this.ProcessRequiredByListToCheckExcludedOptions(sModelId, oReqOption, oParOption, oECM, oQueryResult, bAutoApproveChanges, sOptionType);
                    if (!usedByAnOption) {
                        if (oReqOption.SType == "Selected" && oReqOption.SelectedOrder < oSelOption.SelectedOrder) {
                            //keep it selected
                        }
                        else {
                            if (oReqOption.SType == "Required") {
                                if (bAutoApproveChanges) {
                                    oReqOption.IsSelected = false;
                                    oReqOption.SelectedOrder = null;
                                    if (sOptionType == "Required") {
                                        oReqOption.OptionType = "Required";
                                    }
                                    else {
                                        oReqOption.OptionType = "Included";
                                    }
                                }
                                else {
                                    if (sOptionType == "Required") {
                                        oReqOption.OptionType = "Required";
                                    }
                                    else {
                                        oReqOption.OptionType = "Included";
                                    }
                                    if (!this.CheckOptionsListInQueryResult("Excluded", oReqOption, oQueryResult)) {
                                        oQueryResult.ExcludedOptions.push(oReqOption);
                                    }
                                }
                            }
                        }
                    }
                    else {
                        for (var j = 0; j < oReqOption.RequiredByList.length; j++) {
                            oReqByOption = oECM.GetOption(sModelId, oReqOption.RequiredByList[j]);
                            if (oReqByOption.OpCode != oSelOption.OpCode) {
                                if (oReqByOption.IsSelected) {
                                    if (oReqByOption.SelectedOrder > oSelOption.SelectedOrder) {
                                        //Added check on 11/20/2008 for checking if the Option is used by any other option or not
                                        usedByAnOption = this.ProcessRequiredByListToUnselect(sModelId, oReqOption, oReqByOption, oECM, oQueryResult, bAutoApproveChanges, sOptionType);
                                        if (!usedByAnOption) {
                                            if (bAutoApproveChanges) {
                                                oReqOption.IsSelected = false;
                                                oReqOption.SelectedOrder = null;
                                                if (sOptionType == "Required") {
                                                    oReqOption.OptionType = "Required";
                                                }
                                                else {
                                                    oReqOption.OptionType = "Included";
                                                }
                                            }
                                            else {
                                                if (sOptionType == "Required") {
                                                    oReqOption.OptionType = "Required";
                                                }
                                                else {
                                                    oReqOption.OptionType = "Included";
                                                }
                                                if (!this.CheckOptionsListInQueryResult("Excluded", oReqOption, oQueryResult)) {
                                                    oQueryResult.ExcludedOptions.push(oReqOption);
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        usedByAnOption1 = false;
                                        bRequiredByOther = false;
                                        bInList = false;
                                        for (var l = 0; l < oReqByOption.RequiredByList.length; l++) {
                                            if (oReqByOption.RequiredByList[l] != oSelOption.OpCode) {
                                                oReqByListOption = oECM.GetOption(sModelId, oReqByOption.RequiredByList[l]);
                                                if (oReqByListOption.IsSelected) {
                                                    bRequiredByOther = true;
                                                    break;
                                                }

                                            }
                                        }

                                        for (var k = 0; k < oSelOption.RequiredList.length; k++) {
                                            if (oReqByOption.IsSelected) {
                                                if (oReqByOption.OpCode == oSelOption.RequiredList[k]) {
                                                    for (var l = 0; l < oReqByOption.RequiredList.length; l++) {
                                                        if (oReqOption.OpCode == oReqByOption.RequiredList[l]) {
                                                            if (oReqByOption.SelectedOrder != null) {
                                                                if (oReqByOption.SelectedOrder > oSelOption.SelectedOrder) {
                                                                    bInList = true;
                                                                    break;
                                                                }
                                                            }
                                                            else {
                                                                bInList = true;
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    break;
                                                }
                                            }
                                        }
                                        if (!bInList) {
                                            //Commented because TrailerHitch unselect was not unchecking all the required options
                                            usedByAnOption1 = this.ProcessRequiredByListToUnselect(sModelId, oReqOption, oReqByOption, oECM, oQueryResult, bAutoApproveChanges, sOptionType);
                                        }
                                        //check if the oReqByOption is in the list of oParOption's RequiredList
                                        if (!usedByAnOption1) {
                                            //Add logic over here to check if this item is included by any package
                                            for (var m = 0; m < oReqOption.IncludedByList.length; m++) {
                                                var incByOption = oECM.GetOption(sModelId, oReqOption.IncludedByList[m]);
                                                if (incByOption.IsSelected) {
                                                    bRequiredByOther = true;
                                                    break;
                                                }

                                            }


                                            if (!bRequiredByOther) {
                                                if (bAutoApproveChanges) {
                                                    oReqOption.IsSelected = false;
                                                    oReqOption.SelectedOrder = null;
                                                    if (sOptionType == "Required") {
                                                        oReqOption.OptionType = "Required";
                                                    }
                                                    else {
                                                        oReqOption.OptionType = "Included";
                                                    }
                                                }
                                                else {
                                                    if (sOptionType == "Required") {
                                                        oReqOption.OptionType = "Required";
                                                    }
                                                    else {
                                                        oReqOption.OptionType = "Included";
                                                    }
                                                    if (!this.CheckOptionsListInQueryResult("Excluded", oReqOption, oQueryResult)) {
                                                        oQueryResult.ExcludedOptions.push(oReqOption);
                                                    }
                                                }
                                            }
                                        }
                                        //else
                                        //{
                                        //  for(var k=0; k < oSelOption.RequiredList.length; k++)
                                        //  {
                                        //   if(oReqByOption.OpCode == oSelOption.RequiredList[k])
                                        //    {
                                        //        alert(oReqByOption.OpCode);
                                        //    }
                                        //  }    
                                        //}

                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) { throw "Error in Process Required Rules to Unselect"; }
    }

    this.ProcessRequiredListToUnselectOptions = function (sModelId, oSelOption, oParOption, oECM, oQueryResult, bAutoApproveChanges, sOptionType) {
        /// <summary>
        /// This is a helper method that processes the Required rules to Unselect Option
        /// This method is called when the state of the processed Option is selected.
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager object</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelOption">Selected Option which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>None</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>        
        var oReqOption;
        try {
            if (oSelOption.IsSelected) {
                for (var i = 0; i < oSelOption.RequiredList.length; i++) {
                    //Get Option object for the OpCode in the required list
                    oReqOption = oECM.GetOption(sModelId, oSelOption.RequiredList[i]);

                    if (oReqOption.OpCode != oParOption.OpCode) {

                        if (oReqOption.IsSelected) {
                            //Process Option Required By List
                            var usedByAnOption = this.ProcessRequiredByListToCheckExcludedOptions(sModelId, oReqOption, oParOption, oECM, oQueryResult, bAutoApproveChanges, sOptionType);
                            if (!usedByAnOption) {
                                if (oReqOption.SType == "Selected" && oReqOption.SelectedOrder < oSelOption.SelectedOrder) {
                                    //keep it selected
                                }
                                else {
                                    if (oReqOption.SType == "Required") {
                                        if (bAutoApproveChanges) {
                                            oReqOption.IsSelected = false;
                                            oReqOption.SelectedOrder = null;
                                            if (sOptionType == "Required") {
                                                oReqOption.OptionType = "Required";
                                            }
                                            else {
                                                oReqOption.OptionType = "Included";
                                            }
                                        }
                                        else {
                                            if (sOptionType == "Required") {
                                                oReqOption.OptionType = "Required";
                                            }
                                            else {
                                                oReqOption.OptionType = "Included";
                                            }
                                            if (!this.CheckOptionsListInQueryResult("Excluded", oReqOption, oQueryResult)) {
                                                oQueryResult.ExcludedOptions.push(oReqOption);
                                            }
                                        }
                                    }
                                }


                            }
                            else {
                                if (oReqOption.SelectedOrder > oSelOption.SelectedOrder) {
                                    if (oReqOption.OpCode != oParOption.OpCode) {
                                        if (bAutoApproveChanges) {
                                            oReqOption.IsSelected = false;
                                            oReqOption.SelectedOrder = null;
                                            if (sOptionType == "Required") {
                                                oReqOption.OptionType = "Required";
                                            }
                                            else {
                                                oReqOption.OptionType = "Included";
                                            }
                                        }
                                        else {
                                            if (sOptionType == "Required") {
                                                oReqOption.OptionType = "Required";
                                            }
                                            else {
                                                oReqOption.OptionType = "Included";
                                            }
                                            if (!this.CheckOptionsListInQueryResult("Excluded", oReqOption, oQueryResult)) {
                                                oQueryResult.ExcludedOptions.push(oReqOption);
                                            }
                                        }
                                    }
                                }
                                else if (oReqOption.SType == "Required") {
                                    if (oReqOption.OpCode != oParOption.OpCode) {
                                        if (bAutoApproveChanges) {
                                            oReqOption.IsSelected = false;
                                            oReqOption.SelectedOrder = null;
                                            if (sOptionType == "Required") {
                                                oReqOption.OptionType = "Required";
                                            }
                                            else {
                                                oReqOption.OptionType = "Included";
                                            }
                                        }
                                        else {
                                            if (sOptionType == "Required") {
                                                oReqOption.OptionType = "Required";
                                            }
                                            else {
                                                oReqOption.OptionType = "Included";
                                            }
                                            if (!this.CheckOptionsListInQueryResult("Excluded", oReqOption, oQueryResult)) {
                                                oQueryResult.ExcludedOptions.push(oReqOption);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) { throw "Error in Process Required Rules to Unselect Options"; }
    }

    this.ProcessIncludeListToSelect = function (sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges, sOptionType) {
        /// <summary>
        /// This is a helper method that processes the Include rules to Select Option
        /// This method is called when the state of the package Option is not selected.
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager object</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelOption">Selected Option which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <param name="oOptionType">OptionType determines if the option is "Required" or "Included". It is used for price calculations</param>
        /// <returns>None</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>    
        var oIncOption;

        try {
            for (var j = 0; j < oSelOption.IncludeList.length; j++) {
                oIncOption = oECM.GetOption(sModelId, oSelOption.IncludeList[j]);

                if (!oIncOption.IsSelected) {
                    this.ProcessExcludeList(sModelId, oIncOption, oECM, oQueryResult, bAutoApproveChanges);
                    if (bAutoApproveChanges) {
                        oIncOption.OptionType = "Included";
                        oIncOption.SType = "Included";
                        oIncOption.IsSelected = true;
                    }
                    else {
                        if (!this.CheckOptionsListInQueryResult("Included", oIncOption, oQueryResult)) {
                            oQueryResult.IncludedOptions.push(oIncOption);
                        }
                    }
                }
                else {
                    oIncOption.OptionType = "Included";
                    oIncOption.SType = "Included";
                    oIncOption.SelectedOrder = null;
                }
            }
        }
        catch (e) { throw "Error in Process Included Rules to select"; }
    }

    this.ProcessIncludeListToUnselect = function (sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges, sOptionType, oParOption) {
        /// <summary>
        /// This is a helper method that processes the Include rules to Unselect Option
        /// This method is called when the state of the package Option is selected.
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager object</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelOption">Selected Option which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <param name="oOptionType">OptionType determines if the option is "Required" or "Included". It is used for price calculations</param>
        /// <returns>None</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>     

        var oIncOption, bIncluded;

        try {
            for (var u = 0; u < oSelOption.IncludeList.length; u++) {
                oIncOption = oECM.GetOption(sModelId, oSelOption.IncludeList[u]);
                if (oIncOption.IsSelected) {
                    bIncluded = false;
                    //check if the Included Option is included by anyone else
                    for (var v = 0; v < oIncOption.IncludedByList.length; v++) {
                        //check if the Includeby opcode is different than the selected Opcode
                        if (oIncOption.IncludedByList[v] != oSelOption.OpCode) {
                            var oIncByOption = oECM.GetOption(sModelId, oIncOption.IncludedByList[v]);
                            if (oIncByOption.IsSelected) {
                                bIncluded = true;
                                break;
                            }
                        }

                    }

                    bRequired = false;
                    var counter = 0;
                    var inList = false;
                    var aOptions = new Array();
                    var oModel = oECM.GetModel(sModelId);
                    //Gets the list of Options that require the passed in Option and are selected
                    for (var i = 0; i < oModel.ModelOptionList.length; i++) {
                        //Loop through all the Requiredlist to see if the option is required by other options
                        for (var j = 0; j < oModel.ModelOptionList[i].RequiredList.length; j++) {
                            //checks the required list of an option contains the passed in option opcode
                            if (oModel.ModelOptionList[i].RequiredList[j] == oIncOption.OpCode) {
                                if (oModel.ModelOptionList[i].IsSelected) {
                                    aOptions.push(oModel.ModelOptionList[i]);
                                }
                            }
                        }

                    }
                    for (var j = 0; j < aOptions.length; j++) {
                        for (var k = 0; k < oSelOption.IncludeList.length; k++) {
                            if (aOptions[j].OpCode == oSelOption.IncludeList[k]) {
                                counter++;
                            }
                        }
                    }

                    if (aOptions.length - counter >= 1) {
                        bRequired = true;
                        if (oIncOption.SType != "Selected") {
                            oIncOption.SType = "Required";
                            oIncOption.OptionType = "Required";
                            oIncOption.SelectedOrder = null;
                        }
                    }

                    if (!bRequired) {
                        if (!bIncluded) {
                            if (oIncOption.SType == "Selected") {
                                if (oIncOption.SelectedOrder > oSelOption.SelectedOrder) {
                                    if (bAutoApproveChanges) {
                                        //Change the Option Type to required
                                        oIncOption.OptionType = "Required";
                                        //Change option state to unselected
                                        oIncOption.IsSelected = false;
                                    }
                                    else {
                                        if (!this.CheckOptionsListInQueryResult("Excluded", oIncOption, oQueryResult)) {
                                            oQueryResult.ExcludedOptions.push(oIncOption);
                                        }
                                    }
                                }
                            }
                            else {
                                if (bAutoApproveChanges) {
                                    //Change the Option Type to required
                                    oIncOption.OptionType = "Required";
                                    //Change option state to unselected
                                    oIncOption.IsSelected = false;
                                }
                                else {
                                    bOptionIncluded = false;
                                    if (oParOption) {
                                        for (var w = 0; w < oParOption.IncludeList.length; w++) {
                                            if (oParOption.IncludeList[w] == oIncOption.OpCode) {
                                                bOptionIncluded = true;
                                                break;
                                            }
                                        }
                                    }
                                    if (!bOptionIncluded) {
                                        if (!this.CheckOptionsListInQueryResult("Excluded", oIncOption, oQueryResult)) {
                                            oQueryResult.ExcludedOptions.push(oIncOption);
                                        }
                                    }
                                    //else - This code allows already included options of a previous package to be added to the IncludedOptions array of QueryResult
                                    //{
                                    //    if(!this.CheckOptionsListInQueryResult("Included",oIncOption,oQueryResult))
                                    //    {
                                    //        oQueryResult.IncludedOptions.push(oIncOption);
                                    //    }
                                    //}
                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) { throw "Error in Process Included Rules to select"; }
    }

    this.ProcessRequiredByListToUnselectOptions = function (sModelId, oOption, oSelOption, oECM, oQueryResult, bAutoApproveChanges) {
        /// <summary>
        /// This is a helper method that processes the RequiredBy rules to Unselect Option
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager object</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oOption">Option which is processed to see if it is required by anyone</param>
        /// <param name="oSelOption">Selected Option which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>   

        var bResult = false;
        var oModel = oECM.GetModel(sModelId);
        var aOptions = new Array();

        try {
            if (oModel != null) {
                //Loop through the options to get all the options that require this option
                for (var i = 0; i < oModel.ModelOptionList.length; i++) {
                    //Loop through all the Requiredlist to see if the option is required by other options
                    for (j = 0; j < oModel.ModelOptionList[i].RequiredList.length; j++) {
                        //checks the required list of an option contains the passed in option opcode
                        if (oModel.ModelOptionList[i].RequiredList[j] == oOption.OpCode) {
                            //checks if the Option which requires the objOption is
                            //the same as the parent Option (selectedOption) passed in
                            if (oModel.ModelOptionList[i].OpCode != oSelOption.OpCode) {
                                if (oModel.ModelOptionList[i].IsSelected) {
                                    aOptions.push(oModel.ModelOptionList[i]);
                                    bResult = true;
                                    //return bResult;
                                }

                            }
                        }
                    }
                }
            }
        }
        catch (e) { throw "Error in Process RequiredBy Rules to Unselect"; }
        if (aOptions.length > 0) {
            for (var k = 0; k < aOptions.length; k++) {
                this.ProcessRequiredListToUnselectOptions(sModelId, aOptions[k], oSelOption, oECM, oQueryResult, bAutoApproveChanges, "Required");
                if (bAutoApproveChanges) {
                    aOptions[k].IsSelected = false;
                }
                else {
                    if (!this.CheckOptionsListInQueryResult("Excluded", aOptions[k], oQueryResult)) {
                        oQueryResult.ExcludedOptions.push(aOptions[k]);
                    }
                }
            }
        }
    }

    this.ProcessRequiredByListToUnselect = function (sModelId, oOption, oSelOption, oECM, oQueryResult, bAutoApproveChanges) {
        /// <summary>
        /// This is a helper method that processes the RequiredBy rules to Unselect Option
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager object</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oOption">Option which is processed to see if it is required by anyone</param>
        /// <param name="oSelOption">Selected Option which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>   

        var bResult = false;
        var oModel = oECM.GetModel(sModelId);

        try {
            if (oModel != null) {
                //Loop through the options to get all the options that require this option
                for (var i = 0; i < oModel.ModelOptionList.length; i++) {
                    //Loop through all the Requiredlist to see if the option is required by other options
                    for (var j = 0; j < oModel.ModelOptionList[i].RequiredList.length; j++) {
                        //checks the required list of an option contains the passed in option opcode
                        if (oModel.ModelOptionList[i].RequiredList[j] == oOption.OpCode) {
                            //checks if the Option which requires the objOption is
                            //the same as the parent Option (selectedOption) passed in
                            if (oModel.ModelOptionList[i].OpCode != oSelOption.OpCode) {
                                if (oModel.ModelOptionList[i].IsSelected) {
                                    bResult = true;
                                    return bResult;
                                }

                            }
                        }
                    }
                }
            }
        }
        catch (e) { throw "Error in Process RequiredBy Rules to Unselect"; }

        return bResult;
    }

    this.ProcessRequiredByListToCheckExcludedOptions = function (sModelId, oOption, oSelOption, oECM, oQueryResult, bAutoApproveChanges) {
        /// <summary>
        /// This is a helper method that processes the RequiredBy rules to Unselect Option
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager object</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oOption">Option which is processed to see if it is required by anyone</param>
        /// <param name="oSelOption">Selected Option which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>   

        var bResult = false;
        var oModel = oECM.GetModel(sModelId);

        try {
            if (oModel != null) {
                //Loop through the options to get all the options that require this option
                for (var i = 0; i < oModel.ModelOptionList.length; i++) {
                    //Loop through all the Requiredlist to see if the option is required by other options
                    for (var j = 0; j < oModel.ModelOptionList[i].RequiredList.length; j++) {
                        //checks the required list of an option contains the passed in option opcode
                        if (oModel.ModelOptionList[i].RequiredList[j] == oOption.OpCode) {
                            //checks if the Option which requires the objOption is
                            //the same as the parent Option (selectedOption) passed in
                            if (oModel.ModelOptionList[i].OpCode != oSelOption.OpCode) {
                                if (oModel.ModelOptionList[i].IsSelected) {
                                    if (this.CheckOptionsListInQueryResult("Excluded", oModel.ModelOptionList[i], oQueryResult)) {
                                        bResult = false; //Return false since the Option is already in ExcludedOption
                                    }
                                    else {
                                        bResult = true; //If the Option is not in Excluded Option, return true;
                                    }
                                    return bResult;
                                }

                            }
                        }
                    }
                }
            }
        }
        catch (e) { throw "Error in Process RequiredBy Rules to Unselect"; }

        return bResult;
    }

    this.ProcessIncludeByListToUnselect = function (sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges) {
        /// <summary>
        /// This is a helper method that processes the IncludedBy rules to Unselect Option
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager object</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelOption">Selected Option which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>     
        var oModel, oIncOption;
        oModel = oECM.GetModel(sModelId);

        try {
            //Loop through the options to get all the options that include this option
            for (var i = 0; i < oModel.ModelOptionList.length; i++) {
                //Loop through all the Includelist to see if the option is included by other options
                for (var j = 0; j < oModel.ModelOptionList[i].IncludeList.length; j++) {
                    //checks the include list of an option contains the passed in option opcode
                    if (oModel.ModelOptionList[i].IncludeList[j] == oSelOption.OpCode) {
                        if (oModel.ModelOptionList[i].IsSelected) {
                            if (bAutoApproveChanges) {
                                oModel.ModelOptionList[i].IsSelected = false;
                            }
                            else {
                                if (oModel.ModelOptionList[i].IsSelected) {
                                    //Add Option to ExcludedOptions List
                                    if (!this.CheckOptionsListInQueryResult("Excluded", oModel.ModelOptionList[i], oQueryResult)) {
                                        oQueryResult.ExcludedOptions.push(oModel.ModelOptionList[i]);
                                    }
                                }
                            }
                            //Loop through the include options for this particular option
                            for (var k = 0; k < oModel.ModelOptionList[i].IncludeList.length; k++) {
                                if (oModel.ModelOptionList[i].IncludeList[k] != oSelOption.OpCode) {
                                    oIncOption = oECM.GetOption(sModelId, oModel.ModelOptionList[i].IncludeList[k]);
                                    if (oIncOption.IsSelected) {
                                        bIncluded = false;
                                        counter = 0;
                                        //check if the Included Option is included by anyone else
                                        for (var v = 0; v < oIncOption.IncludedByList.length; v++) {
                                            //check if the Includeby opcode is different than the selected Opcode
                                            if (oIncOption.IncludedByList[v] != oSelOption.OpCode) {
                                                var oIncByOption = oECM.GetOption(sModelId, oIncOption.IncludedByList[v]);
                                                if (oIncByOption.IsSelected) {
                                                    if (bAutoApproveChanges) {
                                                        bIncluded = true;
                                                    }
                                                    counter += 1;
                                                    if (counter == 2) break;
                                                }
                                            }

                                        }
                                        if (!bIncluded) {
                                            if (bAutoApproveChanges) {
                                                oIncOption.IsSelected = false;
                                            }
                                            else {
                                                if (oIncOption.IsSelected) {
                                                    if (counter == 2) {
                                                        //Add Option to ExcludedOptions List
                                                        //if(!this.CheckOptionsListInQueryResult("Included",oIncOption, oQueryResult))
                                                        //{
                                                        //    oQueryResult.IncludedOptions.push(oIncOption);
                                                        //}
                                                    }
                                                    else {

                                                        //Add Option to ExcludedOptions List
                                                        if (!this.CheckOptionsListInQueryResult("Excluded", oIncOption, oQueryResult)) {
                                                            oQueryResult.ExcludedOptions.push(oIncOption);
                                                        }
                                                    }
                                                }
                                            }
                                            this.ProcessRequiredListToUnselect(sModelId, oIncOption, oSelOption, oECM, oQueryResult, bAutoApproveChanges, "Included");
                                        }

                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        catch (e) { throw "Error in Process IncludedBy Rules to Unselect"; }

    }

    this.ProcessOptionColorRules = function (sModelId, oSelOption, oECM, oQueryResult, bAutoApproveChanges) {
        /// <summary>
        /// This is a helper method that processes the Option Color Rules
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager object</param>
        /// <param name="oQueryResult">ECRulesEngineQueryResult object</param>
        /// <param name="oSelOption">Selected Option which needs to be processed</param>
        /// <param name="bAutoApproveChanges">
        /// Boolean flag to determine if conflicts need to be sent to the caller or not. 
        /// If false, the conflicts are returned back to the caller. If true, the conflicts are resolved and the user can get the new state.
        ///</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>        
        var oModel = oECM.GetModel(sModelId);
        var oSelExtColor;
        var oSelIntColor;
        var oRequiredOptions;

        oSelExtColor = oECM.GetSelectedExteriorColor(sModelId);
        oSelIntColor = oECM.GetSelectedInteriorColor(sModelId);

        try {
            //If bAutoApproveChanges is true, then get the selected Options and check for any color conflicts
            //Else process option color conflict for currently processed option and all RequiredOptions
            if (bAutoApproveChanges) {
                for (var l = 0; l < oModel.ModelOptionList.length; l++) {
                    if (oModel.ModelOptionList[l].IsSelected) {
                        this.CheckForOptionColorConflicts(sModelId, oModel.ModelOptionList[l], oSelExtColor, oSelIntColor, oQueryResult);
                    }
                }
            }
            else {
                //check for option color conflicts for currently selected option
                this.CheckForOptionColorConflicts(sModelId, oSelOption, oSelExtColor, oSelIntColor, oQueryResult);
                oRequiredOptions = oQueryResult.RequiredOptions;

                if (oRequiredOptions != null) {
                    for (var j = 0; j < oRequiredOptions.length; j++) {
                        this.CheckForOptionColorConflicts(sModelId, oRequiredOptions[j], oSelExtColor, oSelIntColor, oQueryResult);
                    }
                }
            }
        }
        catch (e) { throw "Error in Process Option Color Rules "; }
    }

    this.CheckForOptionColorConflicts = function (sModelId, oOptionToProcess, oSelExtColor, oSelIntColor, oQueryResult) {
        /// <summary>
        /// This is a helper method that checks the Option Color conflicts. If any conflicts arises, it calls the PopulateOptionColorConflict
        /// method to populate the conflict.
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oOptionToProcess">Option for which Color Conflict Rules are processed</param>
        /// <param name="oSelExtColor">Currently selected Exterior Color</param>
        /// <param name="oSelIntColor">Currently selected Interior Color</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>      

        var extPassed = false;
        var intPassed = false;

        try {
            if (oOptionToProcess.OptionColorList.length > 0) {
                for (var iCol = 0; iCol < oOptionToProcess.OptionColorList.length; iCol++) {
                    if (oOptionToProcess.OptionColorList[iCol].ColorType == "E") {
                        intPassed = true;
                        if (oSelExtColor != null) {
                            if (oOptionToProcess.OptionColorList[iCol].ColorIdent == oSelExtColor.ColorIdent) {
                                //Select the part number
                                oOptionToProcess.OptionColorList[iCol].IsSelected = true;
                                extPassed = true;
                                break;
                            }
                        }
                    }
                    else if (oOptionToProcess.OptionColorList[iCol].ColorType == "I") {
                        extPassed = true;
                        if (oSelIntColor != null) {
                            if (oOptionToProcess.OptionColorList[iCol].ColorIdent == oSelIntColor.ColorIdent) {
                                //Select the part number
                                oOptionToProcess.OptionColorList[iCol].IsSelected = true;
                                intPassed = true;
                                break;
                            }
                        }
                    }
                }
                if (!extPassed) { this.PopulateOptionColorConflict(sModelId, oOptionToProcess, oSelExtColor, "E", oQueryResult); }
                if (!intPassed) { this.PopulateOptionColorConflict(sModelId, oOptionToProcess, oSelIntColor, "I", oQueryResult); }
            }
        }
        catch (e) { throw "Error in Check Option Color Conflicts "; }

    }

    this.PopulateOptionColorConflict = function (sModelId, oOption, oColor, sColorType, oQueryResult) {

        var oOCC = new ECOptionColorConflict();
        oOCC.ModelId = sModelId;
        if (oOption != null) {
            oOCC.OpCode = oOption.OpCode;
        }
        else {
            oOCC.OpCode = "No OpCode Passed";
        }
        if (oColor != null) {
            if (oColor.ColorType == "E") {
                oOCC.ColorCode = oColor.ColorMfgCode;
            }
            else {
                oOCC.ColorCode = oColor.ColorCode;
            }
        }
        else {
            oOCC.ColorCode = "None";
        }
        oOCC.ColorType = sColorType;
        oQueryResult.PassedValidation = false;
        oQueryResult.OptionColorConflicts.push(oOCC);
    }

    this.UpdatePackages = function (sModelId, oECM, oQueryResult) {
        /// <summary>
        /// This is a helper method that updates the package information. It populates the currently selected options within the package.
        /// It also calculates the selected accessory count and unselected accessory count.
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>          
        var oModel = oECM.GetModel(sModelId);
        var iSelCnt = 0;
        var iNotSelCnt = 0;
        var fSelPrice = 0;
        try {
            for (var n = 0; n < oModel.ModelOptionPackageList.length; n++) {
                for (var m = 0; m < oModel.ModelOptionList.length; m++) {
                    if (oModel.ModelOptionList[m].OpCode == oModel.ModelOptionPackageList[n].OpCode) {
                        if (oModel.ModelOptionList[m].IsSelected) { oModel.ModelOptionPackageList[n].IsSelected = true; }
                        else { oModel.ModelOptionPackageList[n].IsSelected = false; }
                    }
                    for (var k = 0; k < oModel.ModelOptionPackageList[n].IncludedOptionsList.length; k++) {
                        if (oModel.ModelOptionList[m].OpCode == oModel.ModelOptionPackageList[n].IncludedOptionsList[k].OpCode) {
                            if (oModel.ModelOptionList[m].IsSelected) {
                                oModel.ModelOptionPackageList[n].IncludedOptionsList[k].IsSelected = true;
                                fSelPrice += parseFloat(oModel.ModelOptionList[m].OptionPrice);
                                iSelCnt += 1;
                            }
                            else {
                                oModel.ModelOptionPackageList[n].IncludedOptionsList[k].IsSelected = false;
                                iNotSelCnt += 1;
                            }
                        }
                    }
                }
                oModel.ModelOptionPackageList[n].TotalSelectedOptions = iSelCnt;
                oModel.ModelOptionPackageList[n].TotalSelectedPrice = fSelPrice;

                fSelPrice = 0;
                iSelCnt = 0;
                iNotSelCnt = 0;
            }
            oQueryResult.Packages = oModel.ModelOptionPackageList;
        }
        catch (e) { throw "Error in UpdatePackages " + e.Message; }
    }

    this.CalculatePrice = function (sModelId, oECM) {
        /// <summary>
        /// This is a helper method that calculates the total price of the current configuration. 
        /// </summary>
        /// <param name="sModelId">ModelId of the Model for which Option Rules are processed</param>
        /// <param name="oECM">Instance of ECConfigurationManager</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>If any error occurs while processing the rules, throws error by appending this method name</exception>

        var totalPrice = 0;
        var fExteriorColorPriceDelta, fInteriorColorPriceDelta;
        var oModel = oECM.GetModel(sModelId);
        var oSelExtColor = oECM.GetSelectedExteriorColor(sModelId);
        var oSelIntColor = oECM.GetSelectedInteriorColor(sModelId);
        totalPrice = parseFloat(oModel.MSRP);

        if (oModel.ColorComboList[oSelExtColor.ColorMfgCode].InteriorColors != null) {
            for (var i = 0; i < oModel.ColorComboList[oSelExtColor.ColorMfgCode].InteriorColors.length; i++) {
                if (oModel.ColorComboList[oSelExtColor.ColorMfgCode].InteriorColors[i].ColorCode == oSelIntColor.ColorCode) {
                    fInteriorColorPriceDelta = oModel.ColorComboList[oSelExtColor.ColorMfgCode].InteriorColors[i].InteriorPriceDelta;
                    totalPrice += isNaN(fInteriorColorPriceDelta) ? parseFloat(0) : parseFloat(fInteriorColorPriceDelta);
                    //Exterior Price Delta not based on Interior color anymore. Exterior Price delta now set back at the ExteriorColorLevel
                    fExteriorColorPriceDelta = oModel.ColorComboList[oSelExtColor.ColorMfgCode].PriceDelta;
                    totalPrice += isNaN(fExteriorColorPriceDelta) ? parseFloat(0) : parseFloat(fExteriorColorPriceDelta);
                }
            }
        }

        for (var p = 0; p < oModel.ModelOptionList.length; p++) {
            if (oModel.ModelOptionList[p].IsSelected) {
                if (oModel.ModelOptionList[p].OptionType == "Required") {
                    if (oModel.DealerNumber.length > 0) {
                        totalPrice += parseFloat(oModel.ModelOptionList[p].OptionDealerPrice);
                    }
                    else {
                        totalPrice += parseFloat(oModel.ModelOptionList[p].OptionPrice);
                    }

                }
                if (oModel.ModelOptionList[p].OptionColorList.length > 0) {
                    for (var q = 0; q < oModel.ModelOptionList[p].OptionColorList.length; q++) {
                        if (oModel.ModelOptionList[p].OptionColorList[q].IsSelected) {
                            pricedelta = parseFloat(oModel.ModelOptionList[p].OptionColorList[q].PriceDelta);
                            totalPrice += isNaN(pricedelta) ? parseFloat(0) : pricedelta;
                        }
                    }
                }
            }
        }

        var fifPrice = 0;
        for (var r = 0; r < oModel.ModelFIFList.length; r++) {
            if (oModel.ModelFIFList[r].IsSelected) {
                //console.log("selected fifs:" + oModel.ModelFIFList[r].FIFId)
                if (oModel.ModelFIFList[r].IsIncludedInPackage) {
                    fifPrice = 0;
                }
                else {
                    fifPrice = this.GetFIFPrice(sModelId, oModel.ModelFIFList[r]);
                }
                totalPrice += isNaN(parseFloat(fifPrice)) ? parseFloat(0) : parseFloat(fifPrice);
            }
        }


        oModel.TotalPrice = totalPrice;
    }

    this.GetFIFPrice = function (sModelId, oSelFIF) {
        var oECM = new ECConfigurationManager();
        var fifPrice = 0;
        var bFIFAvailable = false;
        if (oSelFIF != null) {
            var oSelExtColor = oECM.GetSelectedExteriorColor(sModelId);
            var oSelIntColor = oECM.GetSelectedInteriorColor(sModelId);
            for (var i = 0; i < oSelFIF.FIFColors.length; i++) {
                if (oSelFIF.FIFColors[i].ExteriorColorCode == oSelExtColor.ColorMfgCode) {
                    for (var j = 0; j < oSelFIF.FIFColors[i].InteriorColors.length; j++) {
                        if (oSelFIF.FIFColors[i].InteriorColors[j].IntColorCd == oSelIntColor.ColorCode) {
                            bFIFAvailable = true;
                            fifPrice = oSelFIF.FIFColors[i].InteriorColors[j].FIFMSRP;
                            break;
                        }
                    }
                }
                if (bFIFAvailable) {
                    break;
                }
            }
            return fifPrice;
        }
    }

    this.CheckRequiredOptionsList = function (oOption) {
        /// <summary>
        /// This is a helper method that checks if the option passed in is in Required Options List or not
        /// </summary>
        /// <param name="oOption">Option to be verified</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>None</exception>          

        var bResult = false;
        var oQueryResult = new ECRulesEngineQueryResult();
        var aRequiredOptions = oQueryResult.RequiredOptions;
        if (aRequiredOptions.length > 0) {
            for (var i = 0; i < aRequiredOptions.length; i++) {
                if (aRequiredOptions[i] == oOption) {
                    bResult = true;
                }
            }

        }
        return bResult;
    }

    this.CheckOptionsList = function (listType, oOption) {
        /// <summary>
        /// This is a helper method that checks if the passed in option is in the array or not.
        /// </summary>
        /// <param name="oOption">option to be verified</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>None</exception>          

        var bResult = false;
        var oQueryResult = new ECRulesEngineQueryResult();
        var aOptions;

        switch (listType) {
            case "Required":
                aOptions = oQueryResult.RequiredOptions;
                break;
            case "Included":
                aOptions = oQueryResult.IncludedOptions;
                break;
            case "Excluded":
                aOptions = oQueryResult.ExcludedOptions;
                break;
            default: break;
        }

        if (aOptions.length > 0) {
            for (var i = 0; i < aOptions.length; i++) {
                if (aOptions[i] == oOption) {
                    bResult = true;
                }
            }
        }

        return bResult;
    }

    this.CheckOptionsListInQueryResult = function (listType, oOption, oQueryResult) {
        /// <summary>
        /// This is a helper method that checks if the passed in option is in the array or not.
        /// </summary>
        /// <param name="oOption">option to be verified</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>None</exception>          

        var bResult = false;
        var aOptions;

        switch (listType) {
            case "Required":
                aOptions = oQueryResult.RequiredOptions;
                break;
            case "Included":
                aOptions = oQueryResult.IncludedOptions;
                break;
            case "Excluded":
                aOptions = oQueryResult.ExcludedOptions;
                break;
            default: break;
        }

        if (aOptions.length > 0) {
            for (var i = 0; i < aOptions.length; i++) {
                if (aOptions[i] == oOption) {
                    bResult = true;
                }
            }
        }

        return bResult;
    }

    this.CheckFIFsList = function (listType, oFIF, oQueryResult) {
        /// <summary>
        /// This is a helper method that checks if the passed in option is in the array or not.
        /// </summary>
        /// <param name="oOption">option to be verified</param>
        /// <returns>Boolean result flag</returns>
        /// <exception>None</exception>          

        var bResult = false;
        var aFIFs;

        switch (listType) {
            case "Required":
                aFIFs = oQueryResult.RequiredFIFs;
                break;
            case "Excluded":
                aFIFs = oQueryResult.ExcludedFIFs;
                break;
            default: break;
        }

        if (aFIFs.length > 0) {
            for (var i = 0; i < aFIFs.length; i++) {
                if (aFIFs[i].FIFId == oFIF.FIFId) {
                    bResult = true;
                }
            }
        }

        return bResult;
    }

}

/* RULES ENGINE FILES END */

export default ECConfigurationManager;